/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Array: { input: any; output: any; }
  /** The `DateTime` scalar type represents a point in time. */
  DateTime: { input: any; output: any; }
  /** The original data used to create an Address Model. Contains the full JSON response from the original Google API call. */
  GoogleMaps_Raw: { input: any; output: any; }
  Json: { input: any; output: any; }
  /** The `Number` scalar type represents a number that can be a float, an integer or a null value. */
  Number: { input: any; output: any; }
  /** The `QueryArgument` scalar type represents a value to be using in Craft element queries. It can be an integer, a string, or a boolean value. */
  QueryArgument: { input: any; output: any; }
};

export type Address = AddressInterface & ElementInterface & {
  __typename?: 'Address';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** First line of the address */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Second line of the address */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** Third line of the address */
  addressLine3?: Maybe<Scalars['String']['output']>;
  /** Administrative area. */
  administrativeArea?: Maybe<Scalars['String']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Two-letter country code */
  countryCode: Scalars['String']['output'];
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Dependent locality */
  dependentLocality?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The first name on the address. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The full name on the address. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The last name on the address. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Latitude */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Locality */
  locality?: Maybe<Scalars['String']['output']>;
  /** Longitude */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Organization name */
  organization?: Maybe<Scalars['String']['output']>;
  /** Organization tax ID */
  organizationTaxId?: Maybe<Scalars['String']['output']>;
  /** Postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Sorting code */
  sortingCode?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Address_CountArgs = {
  field: Scalars['String']['input'];
};

/** This is the interface implemented by all addresses. */
export type AddressInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** First line of the address */
  addressLine1?: Maybe<Scalars['String']['output']>;
  /** Second line of the address */
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** Third line of the address */
  addressLine3?: Maybe<Scalars['String']['output']>;
  /** Administrative area. */
  administrativeArea?: Maybe<Scalars['String']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Two-letter country code */
  countryCode: Scalars['String']['output'];
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Dependent locality */
  dependentLocality?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The first name on the address. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The full name on the address. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The last name on the address. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Latitude */
  latitude?: Maybe<Scalars['String']['output']>;
  /** Locality */
  locality?: Maybe<Scalars['String']['output']>;
  /** Longitude */
  longitude?: Maybe<Scalars['String']['output']>;
  /** Organization name */
  organization?: Maybe<Scalars['String']['output']>;
  /** Organization tax ID */
  organizationTaxId?: Maybe<Scalars['String']['output']>;
  /** Postal code */
  postalCode?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Sorting code */
  sortingCode?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all addresses. */
export type AddressInterface_CountArgs = {
  field: Scalars['String']['input'];
};

/** This is the interface implemented by all assets. */
export type AssetInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Alternative text for the asset. */
  alt?: Maybe<Scalars['String']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the asset file was last modified. */
  dateModified?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The file extension for the asset file. */
  extension: Scalars['String']['output'];
  /** The filename of the asset file. */
  filename: Scalars['String']['output'];
  /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
  focalPoint?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** The ID of the folder that the asset belongs to. */
  folderId: Scalars['Int']['output'];
  /** Returns the file’s format. */
  format?: Maybe<Scalars['String']['output']>;
  /** Whether a user-defined focal point is set on the asset. */
  hasFocalPoint: Scalars['Boolean']['output'];
  /** The height in pixels or null if it’s not an image. */
  height?: Maybe<Scalars['Int']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** An `<img>` tag based on this asset. */
  img?: Maybe<Scalars['String']['output']>;
  /** The file kind. */
  kind: Scalars['String']['output'];
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The file’s MIME type, if it can be determined. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<AssetInterface>;
  /** The asset’s path in the volume. */
  path: Scalars['String']['output'];
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<AssetInterface>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The file size in bytes. */
  size?: Maybe<Scalars['String']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
  srcset?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
  url?: Maybe<Scalars['String']['output']>;
  /** The ID of the volume that the asset belongs to. */
  volumeId?: Maybe<Scalars['Int']['output']>;
  /** The width in pixels or null if it’s not an image. */
  width?: Maybe<Scalars['Int']['output']>;
};


/** This is the interface implemented by all assets. */
export type AssetInterface_CountArgs = {
  field: Scalars['String']['input'];
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceFormatArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceHeightArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceNextArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfacePrevArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceSrcsetArgs = {
  sizes: Array<Scalars['String']['input']>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceUrlArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


/** This is the interface implemented by all assets. */
export type AssetInterfaceWidthArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type AssetRelationCriteriaInput = {
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the assets’ files’ last-modified dates. */
  dateModified?: InputMaybe<Scalars['String']['input']>;
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the assets’ filenames. */
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the folders the assets belong to, per the folders’ IDs. */
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on whether the assets have alternative text. */
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the assets’ image heights. */
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Broadens the query results to include assets from any of the subfolders of the folder specified by `folderId`. */
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the assets’ file kinds. */
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines which site(s) the elements should be queried in, based on their language. */
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to elements that do not relate to the provided element IDs. */
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  /** Narrows the relations based on the field they were created in. */
  relatedViaField?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the relations based on the site they were created in. */
  relatedViaSite?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the assets’ file sizes (in bytes). */
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the user the assets were uploaded by, per the user’s ID. */
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the volumes the assets belong to, per the volumes’ handles. */
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the volumes the assets belong to, per the volumes’ IDs. */
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the assets’ image widths. */
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** A list of transform handles to preload. */
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** This is the interface implemented by all categories. */
export type CategoryInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The category’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<CategoryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The category’s children. */
  children: Array<CategoryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The category’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<CategoryInterface>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the group that contains the category. */
  groupHandle: Scalars['String']['output'];
  /** The ID of the group that contains the category. */
  groupId: Scalars['Int']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<CategoryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterface_CountArgs = {
  field: Scalars['String']['input'];
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceAncestorsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceDescendantsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfacePrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all categories. */
export type CategoryInterfaceSeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type CategoryRelationCriteriaInput = {
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `ancestorOf`. */
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to only elements that are ancestors of another element in its structure, provided by its ID. */
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `descendantOf`. */
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to only elements that are descendants of another element in its structure provided by its ID. */
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to only return categories that the user has permission to edit. */
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the category groups the categories belong to per the group’s handles. */
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the category groups the categories belong to, per the groups’ IDs. */
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on whether the elements have any descendants in their structure. */
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines which site(s) the elements should be queried in, based on their language. */
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on whether the elements are “leaves” in their structure (element with no descendants). */
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the elements’ level within the structure. */
  level?: InputMaybe<Scalars['Int']['input']>;
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to only the entry that comes immediately after another element in its structure, provided by its ID. */
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to elements that do not relate to the provided element IDs. */
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Narrows the query results to only entries that are positioned after another element in its structure, provided by its ID. */
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to only entries that are positioned before another element in its structure, provided by its ID. */
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to only the entry that comes immediately before another element in its structure, provided by its ID. */
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  /** Narrows the relations based on the field they were created in. */
  relatedViaField?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the relations based on the site they were created in. */
  relatedViaSite?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines which structure data should be joined into the query. */
  structureId?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Explicitly determines whether the query should join in the structure data. */
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Element = ElementInterface & {
  __typename?: 'Element';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Element_CountArgs = {
  field: Scalars['String']['input'];
};

/** This is the interface implemented by all elements. */
export type ElementInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all elements. */
export type ElementInterface_CountArgs = {
  field: Scalars['String']['input'];
};

/** This is the interface implemented by all entries. */
export type EntryInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<EntryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']['output']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']['output']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children: Array<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<EntryInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']['output']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']['output']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the element is enabled for the site. */
  enabledForSite?: Maybe<Scalars['Boolean']['output']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** The handle of the field that contains the entry. */
  fieldHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the field that contains the entry. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<EntryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The ID of the entry’s owner elementt. */
  ownerId?: Maybe<Scalars['Int']['output']>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']['output']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']['output']>;
  /** The revision notes (from the `revisions` table). */
  revisionNotes?: Maybe<Scalars['String']['output']>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The entry’s position within the field that contains it. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle: Scalars['String']['output'];
  /** The ID of the entry type that contains the entry. */
  typeId: Scalars['Int']['output'];
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterface_CountArgs = {
  field: Scalars['String']['input'];
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceAncestorsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceChildrenArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceDescendantsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceLocalizedArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceNextArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceParentArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfacePrevArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all entries. */
export type EntryInterfaceSeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type EntryRelationCriteriaInput = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to only entries that were posted on or after a certain date. */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `ancestorOf`. */
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to only elements that are ancestors of another element in its structure, provided by its ID. */
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the user group the entries’ authors belong to. */
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the user group the entries’ authors belong to, per the groups’ IDs. */
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the entries’ authors. */
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to only entries that were posted before a certain date. */
  before?: InputMaybe<Scalars['String']['input']>;
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to only elements that are up to a certain distance away from the element in its structure specified by `descendantOf`. */
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to only elements that are descendants of another element in its structure provided by its ID. */
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  /** Whether to only return entries that the user has permission to edit. */
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the entries’ expiry dates. */
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the field the entries are contained by. */
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the field the entries are contained by, per the fields’ IDs. */
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on whether the elements have any descendants in their structure. */
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines which site(s) the elements should be queried in, based on their language. */
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on whether the elements are “leaves” in their structure (element with no descendants). */
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the elements’ level within the structure. */
  level?: InputMaybe<Scalars['Int']['input']>;
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to only the entry that comes immediately after another element in its structure, provided by its ID. */
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to elements that do not relate to the provided element IDs. */
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Narrows the query results based on the owner element of the entries, per the owners’ IDs. */
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to only entries that are positioned after another element in its structure, provided by its ID. */
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to only entries that are positioned before another element in its structure, provided by its ID. */
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results based on the entries’ post dates. */
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to only the entry that comes immediately before another element in its structure, provided by its ID. */
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results based on the primary owner element of the entries, per the owners’ IDs. */
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  /** Narrows the relations based on the field they were created in. */
  relatedViaField?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the relations based on the site they were created in. */
  relatedViaSite?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Narrows the query results based on the section handles the entries belong to. */
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the sections the entries belong to, per the sections’ IDs. */
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Determines which structure data should be joined into the query. */
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the entries’ entry type handles. */
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the entries’ entry types, per the types’ IDs. */
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Explicitly determines whether the query should join in the structure data. */
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FieldAttribute = {
  __typename?: 'FieldAttribute';
  label?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** This is the interface implemented by all fields. */
export type FieldInterface = {
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type FieldOption = {
  __typename?: 'FieldOption';
  /** Whether this option has been marked as disabled. */
  disabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this option has been marked as a default. */
  isDefault?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this option has been marked as an `optgroup`. */
  isOptgroup?: Maybe<Scalars['Boolean']['output']>;
  /** The label of the option. */
  label?: Maybe<Scalars['String']['output']>;
  /** The value of the option. */
  value?: Maybe<Scalars['String']['output']>;
};

export type Field_Address = FieldInterface & {
  __typename?: 'Field_Address';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s nested fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s nested rows. */
  nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  subFieldLabelPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};


export type Field_AddressFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Field_AddressNestedRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Field_Address1 = FieldInterface & {
  __typename?: 'Field_Address1';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Address2 = FieldInterface & {
  __typename?: 'Field_Address2';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Address3 = FieldInterface & {
  __typename?: 'Field_Address3';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_AddressAutoComplete = FieldInterface & {
  __typename?: 'Field_AddressAutoComplete';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_AddressCity = FieldInterface & {
  __typename?: 'Field_AddressCity';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_AddressCountry = FieldInterface & {
  __typename?: 'Field_AddressCountry';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_AddressState = FieldInterface & {
  __typename?: 'Field_AddressState';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_AddressZip = FieldInterface & {
  __typename?: 'Field_AddressZip';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Agree = FieldInterface & {
  __typename?: 'Field_Agree';
  checkedValue?: Maybe<Scalars['String']['output']>;
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  defaultState?: Maybe<Scalars['Boolean']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  descriptionHtml?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uncheckedValue?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Calculations = FieldInterface & {
  __typename?: 'Field_Calculations';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  decimals?: Maybe<Scalars['Int']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  formatting?: Maybe<Scalars['String']['output']>;
  formula?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  prefix?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Categories = FieldInterface & {
  __typename?: 'Field_Categories';
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  defaultCategory?: Maybe<CategoryInterface>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  labelSource?: Maybe<Scalars['String']['output']>;
  limitOptions?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  orderBy?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  rootCategory?: Maybe<CategoryInterface>;
  source?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Scalars['String']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};


export type Field_CategoriesCategoriesArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Field_CategoriesDefaultCategoryArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Field_CategoriesRootCategoryArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Field_Checkboxes = FieldInterface & {
  __typename?: 'Field_Checkboxes';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Date = FieldInterface & {
  __typename?: 'Field_Date';
  availableDaysOfWeek?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  datePickerOptions?: Maybe<Array<Maybe<FieldAttribute>>>;
  defaultDate?: Maybe<Scalars['DateTime']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s nested fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  maxDate?: Maybe<Scalars['DateTime']['output']>;
  minDate?: Maybe<Scalars['DateTime']['output']>;
  /** The field’s nested rows. */
  nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  subFieldLabelPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};


export type Field_DateFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Field_DateNestedRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Field_DateAmPmDropdown = FieldInterface & {
  __typename?: 'Field_DateAmPmDropdown';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateAmPmNumber = FieldInterface & {
  __typename?: 'Field_DateAmPmNumber';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateDayDropdown = FieldInterface & {
  __typename?: 'Field_DateDayDropdown';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateDayNumber = FieldInterface & {
  __typename?: 'Field_DateDayNumber';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateHourDropdown = FieldInterface & {
  __typename?: 'Field_DateHourDropdown';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateHourNumber = FieldInterface & {
  __typename?: 'Field_DateHourNumber';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateMinuteDropdown = FieldInterface & {
  __typename?: 'Field_DateMinuteDropdown';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateMinuteNumber = FieldInterface & {
  __typename?: 'Field_DateMinuteNumber';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateMonthDropdown = FieldInterface & {
  __typename?: 'Field_DateMonthDropdown';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateMonthNumber = FieldInterface & {
  __typename?: 'Field_DateMonthNumber';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateSecondDropdown = FieldInterface & {
  __typename?: 'Field_DateSecondDropdown';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateSecondNumber = FieldInterface & {
  __typename?: 'Field_DateSecondNumber';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateYearDropdown = FieldInterface & {
  __typename?: 'Field_DateYearDropdown';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_DateYearNumber = FieldInterface & {
  __typename?: 'Field_DateYearNumber';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Dropdown = FieldInterface & {
  __typename?: 'Field_Dropdown';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Email = FieldInterface & {
  __typename?: 'Field_Email';
  blockedDomains?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Entries = FieldInterface & {
  __typename?: 'Field_Entries';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  defaultEntry?: Maybe<EntryInterface>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entries?: Maybe<Array<Maybe<EntryInterface>>>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  labelSource?: Maybe<Scalars['String']['output']>;
  limitOptions?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  orderBy?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Scalars['String']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};


export type Field_EntriesDefaultEntryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Field_EntriesEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Field_FileUpload = FieldInterface & {
  __typename?: 'Field_FileUpload';
  allowedKinds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  labelSource?: Maybe<Scalars['String']['output']>;
  limitFiles?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  orderBy?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  sizeLimit?: Maybe<Scalars['String']['output']>;
  sizeMinLimit?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Scalars['String']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
  volumeHandle?: Maybe<Scalars['String']['output']>;
};

export type Field_Group = FieldInterface & {
  __typename?: 'Field_Group';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s nested fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s nested rows. */
  nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};


export type Field_GroupFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Field_GroupNestedRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Field_Heading = FieldInterface & {
  __typename?: 'Field_Heading';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  headingSize?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Hidden = FieldInterface & {
  __typename?: 'Field_Hidden';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  cookieName?: Maybe<Scalars['String']['output']>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  defaultOption?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  queryParameter?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Html = FieldInterface & {
  __typename?: 'Field_Html';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  htmlContent?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_MultiLineText = FieldInterface & {
  __typename?: 'Field_MultiLineText';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  richTextButtons?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  useRichText?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Name = FieldInterface & {
  __typename?: 'Field_Name';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s nested fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s nested rows. */
  nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  subFieldLabelPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  useMultipleFields?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};


export type Field_NameFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Field_NameNestedRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Field_NameFirst = FieldInterface & {
  __typename?: 'Field_NameFirst';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_NameLast = FieldInterface & {
  __typename?: 'Field_NameLast';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_NameMiddle = FieldInterface & {
  __typename?: 'Field_NameMiddle';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_NamePrefix = FieldInterface & {
  __typename?: 'Field_NamePrefix';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Number = FieldInterface & {
  __typename?: 'Field_Number';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxValue?: Maybe<Scalars['Float']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minValue?: Maybe<Scalars['Float']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Password = FieldInterface & {
  __typename?: 'Field_Password';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Payment = FieldInterface & {
  __typename?: 'Field_Payment';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  paymentIntegration?: Maybe<Scalars['String']['output']>;
  paymentIntegrationType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  providerSettings?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Phone = FieldInterface & {
  __typename?: 'Field_Phone';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  countryAllowed?: Maybe<Scalars['String']['output']>;
  countryDefaultValue?: Maybe<Scalars['String']['output']>;
  countryEnabled?: Maybe<Scalars['Boolean']['output']>;
  countryOptions?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Radio = FieldInterface & {
  __typename?: 'Field_Radio';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  layout?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Recipients = FieldInterface & {
  __typename?: 'Field_Recipients';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multiple?: Maybe<Scalars['Boolean']['output']>;
  options?: Maybe<Array<Maybe<FieldOption>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Repeater = FieldInterface & {
  __typename?: 'Field_Repeater';
  addLabel?: Maybe<Scalars['String']['output']>;
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s nested fields. */
  fields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  maxRows?: Maybe<Scalars['Int']['output']>;
  minRows?: Maybe<Scalars['Int']['output']>;
  /** The field’s nested rows. */
  nestedRows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};


export type Field_RepeaterFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Field_RepeaterNestedRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Field_Section = FieldInterface & {
  __typename?: 'Field_Section';
  borderColor?: Maybe<Scalars['String']['output']>;
  borderStyle?: Maybe<Scalars['String']['output']>;
  borderWidth?: Maybe<Scalars['Int']['output']>;
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Signature = FieldInterface & {
  __typename?: 'Field_Signature';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  penColor?: Maybe<Scalars['String']['output']>;
  penWeight?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_SingleLineText = FieldInterface & {
  __typename?: 'Field_SingleLineText';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Boolean']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  max?: Maybe<Scalars['Int']['output']>;
  maxType?: Maybe<Scalars['String']['output']>;
  min?: Maybe<Scalars['Int']['output']>;
  minType?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  uniqueValue?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Summary = FieldInterface & {
  __typename?: 'Field_Summary';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Table = FieldInterface & {
  __typename?: 'Field_Table';
  columns?: Maybe<Array<Maybe<KeyValueType>>>;
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** The field’s default value as a string. Some fields have different fields for their default value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};

export type Field_Tags = FieldInterface & {
  __typename?: 'Field_Tags';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  defaultTag?: Maybe<TagInterface>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  labelSource?: Maybe<Scalars['String']['output']>;
  limitOptions?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  orderBy?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Maybe<TagInterface>>>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};


export type Field_TagsDefaultTagArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Field_TagsTagsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Field_Users = FieldInterface & {
  __typename?: 'Field_Users';
  /** The field’s conditions as a JSON string. */
  conditions?: Maybe<Scalars['Json']['output']>;
  /** The field’s container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  defaultUser?: Maybe<UserInterface>;
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** The field’s display name (last portion of the class). */
  displayName?: Maybe<Scalars['String']['output']>;
  displayType?: Maybe<Scalars['String']['output']>;
  /** The field’s value type to use in email notifications. */
  emailValue?: Maybe<Scalars['String']['output']>;
  /** Whether the field has conditions enabled. */
  enableConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field has content encryption enabled. */
  enableContentEncryption?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the field is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s error message. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The field’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the field should be included in email content. */
  includeInEmail?: Maybe<Scalars['Boolean']['output']>;
  /** The field’s input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The field’s full GQL input type. Useful for mutations. */
  inputTypeName?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions. */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The field’s instructions position. This will be a `verbb\formie\positions` class name. */
  instructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The field’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The field’s label position. This will be a `verbb\formie\positions` class name. */
  labelPosition?: Maybe<Scalars['String']['output']>;
  labelSource?: Maybe<Scalars['String']['output']>;
  limitOptions?: Maybe<Scalars['String']['output']>;
  /** The field handle for another field that this value should match exactly. */
  matchField?: Maybe<Scalars['String']['output']>;
  multi?: Maybe<Scalars['Boolean']['output']>;
  orderBy?: Maybe<Scalars['String']['output']>;
  /** The field’s placeholder. */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** The field’s pre-populated value extracted from the query string. */
  prePopulate?: Maybe<Scalars['String']['output']>;
  /** Whether the field is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  sources?: Maybe<Scalars['String']['output']>;
  /** The field’s type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The field’s full GQL type. */
  typeName?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<Maybe<UserInterface>>>;
  /** The field’s visibility. */
  visibility?: Maybe<Scalars['String']['output']>;
};


export type Field_UsersDefaultUserArgs = {
  affiliatedSite?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  affiliatedSiteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  assetUploaders?: InputMaybe<Scalars['Boolean']['input']>;
  authors?: InputMaybe<Scalars['Boolean']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Field_UsersUsersArgs = {
  affiliatedSite?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  affiliatedSiteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  assetUploaders?: InputMaybe<Scalars['Boolean']['input']>;
  authors?: InputMaybe<Scalars['Boolean']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Contents of a file */
export type FileContents = {
  __typename?: 'FileContents';
  contents?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
};

export type FormIntegrationsType = {
  __typename?: 'FormIntegrationsType';
  /** Whether the integration is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The integration’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The integration’s name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The integration’s settings as a JSON string. */
  settings?: Maybe<Scalars['String']['output']>;
};

/** This is the interface implemented by all forms. */
export type FormInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** A list of captcha values (name and value) to assist with spam protection. */
  captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
  /** The form’s config as JSON. */
  configJson?: Maybe<Scalars['String']['output']>;
  /** A CSRF token (name and value). */
  csrfToken?: Maybe<FormieCsrfTokenType>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The form’s fields. */
  formFields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The form’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the form is considered available according to user checks, scheduling and more. */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The form’s pages. */
  pages?: Maybe<Array<Maybe<PageInterface>>>;
  /** The form’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The form’s settings. */
  settings?: Maybe<FormSettingsType>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The form’s endpoint for sending submissions to, if using POST requests. */
  submissionEndpoint?: Maybe<Scalars['String']['output']>;
  /** The form’s GQL mutation name for submissions to use. */
  submissionMutationName?: Maybe<Scalars['String']['output']>;
  /** The form’s CSS for rendering. */
  templateCss?: Maybe<Scalars['String']['output']>;
  /** The form’s rendered HTML. */
  templateHtml?: Maybe<Scalars['String']['output']>;
  /** The form’s JS for rendering and functionality. */
  templateJs?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all forms. */
export type FormInterface_CountArgs = {
  field: Scalars['String']['input'];
};


/** This is the interface implemented by all forms. */
export type FormInterfaceFormFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all forms. */
export type FormInterfaceRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all forms. */
export type FormInterfaceTemplateHtmlArgs = {
  options?: InputMaybe<Scalars['String']['input']>;
  populateFormValues?: InputMaybe<Scalars['String']['input']>;
};


/** This is the interface implemented by all forms. */
export type FormInterfaceTemplateJsArgs = {
  initJs?: InputMaybe<Scalars['Boolean']['input']>;
  useObserver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormSettingsType = {
  __typename?: 'FormSettingsType';
  /** The form’s default instructions position for fields. This will be a `verbb\formie\positions` class name. */
  defaultInstructionsPosition?: Maybe<Scalars['String']['output']>;
  /** The form’s default label position for fields. This will be a `verbb\formie\positions` class name. */
  defaultLabelPosition?: Maybe<Scalars['String']['output']>;
  /** Whether to show the form’s current page title. */
  displayCurrentPageTitle?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the form’s title. */
  displayFormTitle?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the form’s page progress. */
  displayPageProgress?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the form’s page tabs. */
  displayPageTabs?: Maybe<Scalars['Boolean']['output']>;
  /** The form’s submit error message. */
  errorMessageHtml?: Maybe<Scalars['String']['output']>;
  /** The form’s error message position. Either `null`, `top-form` or `bottom-form`. */
  errorMessagePosition?: Maybe<Scalars['String']['output']>;
  /** The form’s enabled integrations. */
  integrations?: Maybe<Array<Maybe<FormIntegrationsType>>>;
  /** The type of loading indicator to use. Either `spinner` or `text`. */
  loadingIndicator?: Maybe<Scalars['String']['output']>;
  /** The form’s loading indicator text. */
  loadingIndicatorText?: Maybe<Scalars['String']['output']>;
  /** The form’s progress bar position. Either `start` or `end`. */
  progressPosition?: Maybe<Scalars['String']['output']>;
  /** The form’s submit action entry (for redirection), if `submitAction` is `entry`. */
  redirectEntry?: Maybe<EntryInterface>;
  /** The form’s submit action redirect URL, resolved depending on `submitAction` being `entry` or `url`. */
  redirectUrl?: Maybe<Scalars['String']['output']>;
  /** The form’s required fields indicator. Either `asterisk` or `optional`. */
  requiredIndicator?: Maybe<Scalars['String']['output']>;
  /** Whether to the form should scroll to the top of the page when submitted. */
  scrollToTop?: Maybe<Scalars['Boolean']['output']>;
  /** The form’s submit action. Either `message`, `entry`, `url`, `reload`. */
  submitAction?: Maybe<Scalars['String']['output']>;
  /** Whether to hide the form’s success message. */
  submitActionFormHide?: Maybe<Scalars['Boolean']['output']>;
  /** The form’s submit success message. */
  submitActionMessageHtml?: Maybe<Scalars['String']['output']>;
  /** The form’s submit message position. Either `top-form` or `bottom-form`. */
  submitActionMessagePosition?: Maybe<Scalars['String']['output']>;
  /** The form’s submit success message timeout in seconds. */
  submitActionMessageTimeout?: Maybe<Scalars['Int']['output']>;
  /** The form’s submit redirect option (if in new tab or same tab). Either `same-tab` or `new-tab`. */
  submitActionTab?: Maybe<Scalars['String']['output']>;
  /** The form’s submit method. Either `page-reload` or `ajax`. */
  submitMethod?: Maybe<Scalars['String']['output']>;
  /** Whether to validate the form’s on focus. */
  validationOnFocus?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to validate the form’s on submit. */
  validationOnSubmit?: Maybe<Scalars['Boolean']['output']>;
};


export type FormSettingsTypeRedirectEntryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FormieCaptchaInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type FormieCaptchaType = {
  __typename?: 'FormieCaptchaType';
  /** The captcha handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The captcha name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The catpcha value. */
  value?: Maybe<Scalars['String']['output']>;
};

export type FormieCsrfTokenType = {
  __typename?: 'FormieCsrfTokenType';
  /** The CSRF name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The CSRF token. */
  value?: Maybe<Scalars['String']['output']>;
};

/** This is the interface implemented by all global sets. */
export type GlobalSetInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the global set. */
  handle: Scalars['String']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The name of the global set. */
  name: Scalars['String']['output'];
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all global sets. */
export type GlobalSetInterface_CountArgs = {
  field: Scalars['String']['input'];
};

/** An Address field as defined by the Google Maps plugin. */
export type GoogleMaps_Address = {
  __typename?: 'GoogleMaps_Address';
  /** The city. (aka: town) */
  city?: Maybe<Scalars['String']['output']>;
  /** The country. (aka: nation) */
  country?: Maybe<Scalars['String']['output']>;
  /** The country code. */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** The local county. (aka: district) */
  county?: Maybe<Scalars['String']['output']>;
  /** The distance between the Address and a proximity search target. If not conducting a proximity search, value will be `null`. */
  distance?: Maybe<Scalars['Float']['output']>;
  /** Element ID of the element containing the Address. */
  elementId?: Maybe<Scalars['Int']['output']>;
  /** Field ID of the Address field. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  /** A nicely-formatted single-line interpretation of the address, provided by Google during the initial geocoding. */
  formatted?: Maybe<Scalars['String']['output']>;
  /** ID of the Address. */
  id?: Maybe<Scalars['ID']['output']>;
  /** Latitude of location. */
  lat?: Maybe<Scalars['Float']['output']>;
  /** Longitude of location. */
  lng?: Maybe<Scalars['Float']['output']>;
  /** The location's official name. Commonly used for landmarks and business names. */
  name?: Maybe<Scalars['String']['output']>;
  /** The neighborhood. */
  neighborhood?: Maybe<Scalars['String']['output']>;
  /** The official `place_id` as specified by the Google API. */
  placeId?: Maybe<Scalars['String']['output']>;
  /** The original data used to create this Address Model. Contains the full JSON response from the original Google API call. */
  raw?: Maybe<Scalars['GoogleMaps_Raw']['output']>;
  /** The state. (aka: province) */
  state?: Maybe<Scalars['String']['output']>;
  /** The first line of the street address. Usually contains the street name & number of the location. */
  street1?: Maybe<Scalars['String']['output']>;
  /** The second line of the street address. Usually contains the apartment, unit, or suite number. */
  street2?: Maybe<Scalars['String']['output']>;
  /** The zip code. (aka: postal code) */
  zip?: Maybe<Scalars['String']['output']>;
  /** Zoom level of the map as shown in the control panel. */
  zoom?: Maybe<Scalars['Int']['output']>;
};

/** An Address field as defined by the Google Maps plugin. */
export type GoogleMaps_Near = {
  /** Latitude of the location. */
  lat: Scalars['Float']['input'];
  /** Longitude of the location. */
  lng: Scalars['Float']['input'];
  /** Distance from the location (in kilometres). */
  range: Scalars['Float']['input'];
};

/** This is the interface implemented by all link fields. */
export type HyperLinkInterface = {
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type KeyValueType = {
  __typename?: 'KeyValueType';
  handle?: Maybe<Scalars['String']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  width?: Maybe<Scalars['String']['output']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  ping?: Maybe<Scalars['String']['output']>;
  /** Save the “Contact Test” submission. */
  save_contactTest_Submission?: Maybe<ContactTest_Submission>;
  /** Save the “Enquiry Form” submission. */
  save_enquiryForm_Submission?: Maybe<EnquiryForm_Submission>;
  /** Save the “Housing Link” submission. */
  save_housingLink_Submission?: Maybe<HousingLink_Submission>;
  /** Save the “Test Form” submission. */
  save_testForm_Submission?: Maybe<TestForm_Submission>;
};


export type MutationSave_ContactTest_SubmissionArgs = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  howShouldWeContactYou?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  recaptchaCaptcha?: InputMaybe<FormieCaptchaInput>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  yourName?: InputMaybe<ContactTest_YourName_FormieNameInput>;
};


export type MutationSave_EnquiryForm_SubmissionArgs = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  recaptchaCaptcha?: InputMaybe<FormieCaptchaInput>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
  yourName?: InputMaybe<EnquiryForm_YourName_FormieNameInput>;
};


export type MutationSave_HousingLink_SubmissionArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  iAmLookingForDisabilityAccommodationFor?: InputMaybe<Scalars['String']['input']>;
  iWouldLikeSomeoneToContactMeToDiscussMyEligibilityForSdaHousingO?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  idLikeToSubscribeToTheHousingLinkNewsletter2?: InputMaybe<Scalars['String']['input']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  name1?: InputMaybe<HousingLink_Name1_FormieNameInput>;
  phone?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSave_TestForm_SubmissionArgs = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  fullName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type NameType = {
  __typename?: 'NameType';
  /** The first name value of the name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The full name value. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The last name value of the name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The middle name value of the name. */
  middleName?: Maybe<Scalars['String']['output']>;
  /** The prefix value of the name. */
  prefix?: Maybe<Scalars['String']['output']>;
};

/** This is the interface implemented by all Neo blocks. */
export type NeoBlockInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all Neo blocks. */
export type NeoBlockInterface_CountArgs = {
  field: Scalars['String']['input'];
};

export type NodeCustomAttribute = {
  __typename?: 'NodeCustomAttribute';
  attribute?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

/** This is the interface implemented by all nodes. */
export type NodeInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The node’s children. Accepts the same arguments as the `nodes` query. */
  children?: Maybe<Array<Maybe<NodeInterface>>>;
  /** Any additional classes for the node. */
  classes?: Maybe<Scalars['String']['output']>;
  /** Any additional custom attributes for the node. */
  customAttributes?: Maybe<Array<Maybe<NodeCustomAttribute>>>;
  /** Any additional data for the node. */
  data?: Maybe<Scalars['String']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The element the node links to. */
  element?: Maybe<ElementInterface>;
  /** The ID of the element this node is linked to. */
  elementId?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The handle of the navigation this node belongs to. */
  navHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the navigation this node belongs to. */
  navId?: Maybe<Scalars['Int']['output']>;
  /** The name of the navigation this node belongs to. */
  navName?: Maybe<Scalars['String']['output']>;
  /** Whether this node should open in a new window. */
  newWindow?: Maybe<Scalars['String']['output']>;
  /** The node’s URI */
  nodeUri?: Maybe<Scalars['String']['output']>;
  /** The node’s parent. */
  parent?: Maybe<NodeInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The type of node this is. */
  type?: Maybe<Scalars['String']['output']>;
  /** The display name for the type of node this is. */
  typeLabel?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The node’s full URL */
  url?: Maybe<Scalars['String']['output']>;
  /** The URL for this navigation item. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all nodes. */
export type NodeInterface_CountArgs = {
  field: Scalars['String']['input'];
};


/** This is the interface implemented by all nodes. */
export type NodeInterfaceChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nav?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navHandle?: InputMaybe<Scalars['String']['input']>;
  navId?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This is the interface implemented by all pages. */
export type PageInterface = {
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The page’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The page’s fields. */
  pageFields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The page’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The page’s settings, including buttons. */
  settings?: Maybe<PageSettingsInterface>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all pages. */
export type PageInterfacePageFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


/** This is the interface implemented by all pages. */
export type PageInterfaceRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This is the interface implemented by all pages. */
export type PageSettingsInterface = {
  /** The page’s back button label. */
  backButtonLabel?: Maybe<Scalars['String']['output']>;
  /** The page’s button (back and submit) positions. */
  buttonsPosition?: Maybe<Scalars['String']['output']>;
  /** The page’s button (back and submit) container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The page’s button (back and submit) CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** Whether the page’s next button has conditions enabled, for multi-page forms. */
  enableNextButtonConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the page has conditions enabled. */
  enablePageConditions?: Maybe<Scalars['Boolean']['output']>;
  /** The page’s button (back and submit) input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The page’s conditions for whether to show the next button, for multi-page forms as a JSON string. */
  nextButtonConditions?: Maybe<Scalars['Json']['output']>;
  /** The page’s conditions as a JSON string. */
  pageConditions?: Maybe<Scalars['Json']['output']>;
  /** The page’s draft button label. */
  saveButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Whether to show the page’s back button. */
  showBackButton?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the page’s draft button. */
  showSaveButton?: Maybe<Scalars['Boolean']['output']>;
  /** The page’s submit button label. */
  submitButtonLabel?: Maybe<Scalars['String']['output']>;
};

export type PageSettingsType = PageSettingsInterface & {
  __typename?: 'PageSettingsType';
  /** The page’s back button label. */
  backButtonLabel?: Maybe<Scalars['String']['output']>;
  /** The page’s button (back and submit) positions. */
  buttonsPosition?: Maybe<Scalars['String']['output']>;
  /** The page’s button (back and submit) container attributes. */
  containerAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The page’s button (back and submit) CSS classes. */
  cssClasses?: Maybe<Scalars['String']['output']>;
  /** Whether the page’s next button has conditions enabled, for multi-page forms. */
  enableNextButtonConditions?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the page has conditions enabled. */
  enablePageConditions?: Maybe<Scalars['Boolean']['output']>;
  /** The page’s button (back and submit) input attributes. */
  inputAttributes?: Maybe<Array<Maybe<FieldAttribute>>>;
  /** The page’s conditions for whether to show the next button, for multi-page forms as a JSON string. */
  nextButtonConditions?: Maybe<Scalars['Json']['output']>;
  /** The page’s conditions as a JSON string. */
  pageConditions?: Maybe<Scalars['Json']['output']>;
  /** The page’s draft button label. */
  saveButtonLabel?: Maybe<Scalars['String']['output']>;
  /** Whether to show the page’s back button. */
  showBackButton?: Maybe<Scalars['Boolean']['output']>;
  /** Whether to show the page’s draft button. */
  showSaveButton?: Maybe<Scalars['Boolean']['output']>;
  /** The page’s submit button label. */
  submitButtonLabel?: Maybe<Scalars['String']['output']>;
};

export type PageType = PageInterface & {
  __typename?: 'PageType';
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The page’s label. */
  label?: Maybe<Scalars['String']['output']>;
  /** The page’s fields. */
  pageFields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The page’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The page’s settings, including buttons. */
  settings?: Maybe<PageSettingsInterface>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
};


export type PageTypePageFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PageTypeRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Query = {
  __typename?: 'Query';
  /** Entries within the “Accordion Items” Matrix field. */
  accordionItemsFieldEntries?: Maybe<Array<Maybe<AccordionItemsFieldEntryUnion>>>;
  /** Entries within the “Articles” section. */
  articleEntries?: Maybe<Array<Maybe<ArticleSectionEntryUnion>>>;
  /** Entries within the “News & Events” section. */
  articleIndexEntries?: Maybe<Array<Maybe<ArticleIndexSectionEntryUnion>>>;
  /** This query is used to query for a single asset. */
  asset?: Maybe<AssetInterface>;
  /** This query is used to return the number of assets. */
  assetCount: Scalars['Int']['output'];
  /** This query is used to query for assets. */
  assets?: Maybe<Array<Maybe<AssetInterface>>>;
  /** Entries within the “Home Page Content” Matrix field. */
  blocksHomeFieldEntries?: Maybe<Array<Maybe<BlocksHomeFieldEntryUnion>>>;
  /** This query is used to query for categories. */
  categories?: Maybe<Array<Maybe<CategoryInterface>>>;
  /** This query is used to query for a single category. */
  category?: Maybe<CategoryInterface>;
  /** This query is used to return the number of categories. */
  categoryCount: Scalars['Int']['output'];
  /** This query is used to query for entries. */
  entries?: Maybe<Array<Maybe<EntryInterface>>>;
  /** This query is used to query for a single entry. */
  entry?: Maybe<EntryInterface>;
  /** This query is used to return the number of entries. */
  entryCount: Scalars['Int']['output'];
  /** Entries within the “Events” section. */
  eventEntries?: Maybe<Array<Maybe<EventSectionEntryUnion>>>;
  /** This query is used to query for a single form. */
  formieForm?: Maybe<FormInterface>;
  /** This query is used to return the number of forms. */
  formieFormCount: Scalars['Int']['output'];
  /** This query is used to query for forms. */
  formieForms?: Maybe<Array<Maybe<FormInterface>>>;
  /** This query is used to query for a single submission. */
  formieSubmission?: Maybe<SubmissionInterface>;
  /** This query is used to return the number of submissions. */
  formieSubmissionCount: Scalars['Int']['output'];
  /** This query is used to query for submissions. */
  formieSubmissions?: Maybe<Array<Maybe<SubmissionInterface>>>;
  /** This query is used to query for a single global set. */
  globalSet?: Maybe<GlobalSetInterface>;
  /** This query is used to query for global sets. */
  globalSets?: Maybe<Array<Maybe<GlobalSetInterface>>>;
  /** Entries within the “Home” section. */
  homeEntries?: Maybe<Array<Maybe<HomeSectionEntryUnion>>>;
  /** Entries within the “Locations” section. */
  locationEntries?: Maybe<Array<Maybe<LocationSectionEntryUnion>>>;
  /** Entries within the “Locations Home” section. */
  locationIndexEntries?: Maybe<Array<Maybe<LocationIndexSectionEntryUnion>>>;
  /** Entries within the “Logo Gallery” Matrix field. */
  logoGalleryFieldEntries?: Maybe<Array<Maybe<LogoGalleryFieldEntryUnion>>>;
  /** This query is used to query for a single node. */
  navigationNode?: Maybe<NodeInterface>;
  /** This query is used to query for nodes. */
  navigationNodes?: Maybe<Array<Maybe<NodeInterface>>>;
  /** Entries within the “Not Found” section. */
  notFoundEntries?: Maybe<Array<Maybe<NotFoundSectionEntryUnion>>>;
  /** Entries within the “Pages” section. */
  pageEntries?: Maybe<Array<Maybe<PageSectionEntryUnion>>>;
  ping?: Maybe<Scalars['String']['output']>;
  /** Entries within the “People” section. */
  profileEntries?: Maybe<Array<Maybe<ProfileSectionEntryUnion>>>;
  /** Entries within the “Properties” section. */
  propertyEntries?: Maybe<Array<Maybe<PropertySectionEntryUnion>>>;
  /** Entries within the “Properties Home” section. */
  propertyIndexEntries?: Maybe<Array<Maybe<PropertyIndexSectionEntryUnion>>>;
  /**
   * This query is used to query for Retour redirects.
   * @deprecated This query is deprecated and will be removed in the future. You should use `retourResolveRedirect` instead.
   */
  retour?: Maybe<RetourInterface>;
  /** This query is used to query for all Retour redirects for a site. */
  retourRedirects?: Maybe<Array<Maybe<RetourInterface>>>;
  /** This query is used to query for Retour redirects. */
  retourResolveRedirect?: Maybe<RetourInterface>;
  /** Entries within the “Search” section. */
  searchEntries?: Maybe<Array<Maybe<SearchSectionEntryUnion>>>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** Entries within the “Services” section. */
  serviceEntries?: Maybe<Array<Maybe<ServiceSectionEntryUnion>>>;
  /** Entries within the “Services Home” section. */
  serviceIndexEntries?: Maybe<Array<Maybe<ServiceIndexSectionEntryUnion>>>;
};


export type QueryAccordionItemsFieldEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryArticleEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryArticleIndexEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAssetArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAssetCountArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryAssetsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryBlocksHomeFieldEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCategoriesArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCategoryArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCategoryCountArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  addressNear?: InputMaybe<GoogleMaps_Near>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEntryArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEntryCountArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  addressNear?: InputMaybe<GoogleMaps_Near>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryEventEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryFormieFormArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFormieFormCountArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFormieFormsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFormieSubmissionArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  isSpam?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFormieSubmissionCountArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  isSpam?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryFormieSubmissionsArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  form?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  isIncomplete?: InputMaybe<Scalars['Boolean']['input']>;
  isSpam?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGlobalSetArgs = {
  copyrightEntity?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  copyrightText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  htmlContentSimple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phoneLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  socialLinks?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGlobalSetsArgs = {
  copyrightEntity?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  copyrightText?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  htmlContentSimple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  phoneLink?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  socialLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  socialLinks?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryHomeEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLocationIndexEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryLogoGalleryFieldEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNavigationNodeArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nav?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navHandle?: InputMaybe<Scalars['String']['input']>;
  navId?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNavigationNodesArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nav?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navHandle?: InputMaybe<Scalars['String']['input']>;
  navId?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryNotFoundEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPageEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryProfileEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPropertyEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryPropertyIndexEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryRetourArgs = {
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryRetourRedirectsArgs = {
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryRetourResolveRedirectArgs = {
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QuerySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type QueryServiceEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryServiceIndexEntriesArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

/** This is the interface implemented by Retour. */
export type RetourInterface = {
  /** The id of the Element associated with this redirect (unused/vestigial). */
  associatedElementId?: Maybe<Scalars['Int']['output']>;
  /** Whether the redirect is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The number of times this redirect has been hit. */
  hitCount?: Maybe<Scalars['Int']['output']>;
  /** A datetime string of when this redirect was last hit. */
  hitLastTime?: Maybe<Scalars['String']['output']>;
  /** The id of the redirect. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The URL that should be redirected to. */
  redirectDestUrl?: Maybe<Scalars['String']['output']>;
  /** The http status code that should be used for the redirect. */
  redirectHttpCode?: Maybe<Scalars['Int']['output']>;
  /** Whether an `exactmatch` or `regexmatch` should be used when matching the URL. */
  redirectMatchType?: Maybe<Scalars['String']['output']>;
  /** Should the legacy URL be matched by path or by full URL? */
  redirectSrcMatch?: Maybe<Scalars['String']['output']>;
  /** The unparsed URL pattern that Retour should match. */
  redirectSrcUrl?: Maybe<Scalars['String']['output']>;
  /** The parsed URL pattern that Retour should match. */
  redirectSrcUrlParsed?: Maybe<Scalars['String']['output']>;
  /** The site handle of the redirect (or null for all sites). */
  site?: Maybe<Scalars['String']['output']>;
  /** The siteId of the redirect (0 or null for all sites). */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
};

/** This entity has all the Retour fields */
export type RetourType = RetourInterface & {
  __typename?: 'RetourType';
  /** The id of the Element associated with this redirect (unused/vestigial). */
  associatedElementId?: Maybe<Scalars['Int']['output']>;
  /** Whether the redirect is enabled or not. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The number of times this redirect has been hit. */
  hitCount?: Maybe<Scalars['Int']['output']>;
  /** A datetime string of when this redirect was last hit. */
  hitLastTime?: Maybe<Scalars['String']['output']>;
  /** The id of the redirect. */
  id?: Maybe<Scalars['Int']['output']>;
  /** The URL that should be redirected to. */
  redirectDestUrl?: Maybe<Scalars['String']['output']>;
  /** The http status code that should be used for the redirect. */
  redirectHttpCode?: Maybe<Scalars['Int']['output']>;
  /** Whether an `exactmatch` or `regexmatch` should be used when matching the URL. */
  redirectMatchType?: Maybe<Scalars['String']['output']>;
  /** Should the legacy URL be matched by path or by full URL? */
  redirectSrcMatch?: Maybe<Scalars['String']['output']>;
  /** The unparsed URL pattern that Retour should match. */
  redirectSrcUrl?: Maybe<Scalars['String']['output']>;
  /** The parsed URL pattern that Retour should match. */
  redirectSrcUrlParsed?: Maybe<Scalars['String']['output']>;
  /** The site handle of the redirect (or null for all sites). */
  site?: Maybe<Scalars['String']['output']>;
  /** The siteId of the redirect (0 or null for all sites). */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
};

/** This is the interface implemented by all rows. */
export type RowInterface = {
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The row’s fields. */
  rowFields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all rows. */
export type RowInterfaceRowFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RowType = RowInterface & {
  __typename?: 'RowType';
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The row’s fields. */
  rowFields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
};


export type RowTypeRowFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Optional - The SEOmatic environment that should be used */
export enum SeomaticEnvironment {
  /** Live production environment, with indexing enabled */
  Live = 'live',
  /** Local Development environment, with debugging enabled and indexing disabled */
  Local = 'local',
  /** Staging environment, with indexing disabled */
  Staging = 'staging'
}

export enum SeomaticFrontendTemplate {
  /** The ads.txt file */
  Ads = 'ads',
  /** The humans.txt file */
  Humans = 'humans',
  /** The robots.txt file */
  Robots = 'robots',
  /** The security.txt file */
  Security = 'security'
}

/** This is the interface implemented by SEOmatic. */
export type SeomaticInterface = {
  /**
   * The FrontendTemplateContainer SEOmatic container.
   * @deprecated This query is deprecated and will be removed in the future. You should use `frontendTemplates` instead.
   */
  frontendTemplateContainer?: Maybe<Scalars['String']['output']>;
  frontendTemplates?: Maybe<Array<Maybe<FileContents>>>;
  /** The MetaJsonLdContainer SEOmatic container. */
  metaJsonLdContainer?: Maybe<Scalars['String']['output']>;
  /** The MetaLinkContainer SEOmatic container. */
  metaLinkContainer?: Maybe<Scalars['String']['output']>;
  /** The MetaScriptContainer SEOmatic container. */
  metaScriptContainer?: Maybe<Scalars['String']['output']>;
  /** The MetaSiteVarsContainer SEOmatic container. */
  metaSiteVarsContainer?: Maybe<Scalars['String']['output']>;
  /** The MetaTagContainer SEOmatic container. */
  metaTagContainer?: Maybe<Scalars['String']['output']>;
  /** The MetaTitleContainer SEOmatic container. */
  metaTitleContainer?: Maybe<Scalars['String']['output']>;
  sitemapIndexes?: Maybe<Array<Maybe<FileContents>>>;
  sitemapStyles?: Maybe<FileContents>;
  sitemaps?: Maybe<Array<Maybe<FileContents>>>;
};


/** This is the interface implemented by SEOmatic. */
export type SeomaticInterfaceFrontendTemplatesArgs = {
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SeomaticFrontendTemplate>;
};


/** This is the interface implemented by SEOmatic. */
export type SeomaticInterfaceSitemapIndexesArgs = {
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
};


/** This is the interface implemented by SEOmatic. */
export type SeomaticInterfaceSitemapsArgs = {
  filename?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  sourceBundleHandle?: InputMaybe<Scalars['String']['input']>;
  sourceBundleType?: InputMaybe<Scalars['String']['input']>;
};

/** This entity has all the SEOmatic fields */
export type SeomaticType = SeomaticInterface & {
  __typename?: 'SeomaticType';
  /**
   * The FrontendTemplateContainer SEOmatic container.
   * @deprecated This query is deprecated and will be removed in the future. You should use `frontendTemplates` instead.
   */
  frontendTemplateContainer?: Maybe<Scalars['String']['output']>;
  frontendTemplates?: Maybe<Array<Maybe<FileContents>>>;
  /** The MetaJsonLdContainer SEOmatic container. */
  metaJsonLdContainer?: Maybe<Scalars['String']['output']>;
  /** The MetaLinkContainer SEOmatic container. */
  metaLinkContainer?: Maybe<Scalars['String']['output']>;
  /** The MetaScriptContainer SEOmatic container. */
  metaScriptContainer?: Maybe<Scalars['String']['output']>;
  /** The MetaSiteVarsContainer SEOmatic container. */
  metaSiteVarsContainer?: Maybe<Scalars['String']['output']>;
  /** The MetaTagContainer SEOmatic container. */
  metaTagContainer?: Maybe<Scalars['String']['output']>;
  /** The MetaTitleContainer SEOmatic container. */
  metaTitleContainer?: Maybe<Scalars['String']['output']>;
  sitemapIndexes?: Maybe<Array<Maybe<FileContents>>>;
  sitemapStyles?: Maybe<FileContents>;
  sitemaps?: Maybe<Array<Maybe<FileContents>>>;
};


/** This entity has all the SEOmatic fields */
export type SeomaticTypeFrontendTemplatesArgs = {
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<SeomaticFrontendTemplate>;
};


/** This entity has all the SEOmatic fields */
export type SeomaticTypeSitemapIndexesArgs = {
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
};


/** This entity has all the SEOmatic fields */
export type SeomaticTypeSitemapsArgs = {
  filename?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  sourceBundleHandle?: InputMaybe<Scalars['String']['input']>;
  sourceBundleType?: InputMaybe<Scalars['String']['input']>;
};

/** This is the interface implemented by all submissions. */
export type SubmissionInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The submission’s IP Address. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the submission is incomplete. */
  isIncomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the submission is spam. */
  isSpam?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The submission’s spam type. */
  spamClass?: Maybe<Scalars['String']['output']>;
  /** The submission’s spam reason. */
  spamReason?: Maybe<Scalars['String']['output']>;
  /** The submission’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The submission’s status ID. */
  statusId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all submissions. */
export type SubmissionInterface_CountArgs = {
  field: Scalars['String']['input'];
};

/** This is the interface implemented by all tags. */
export type TagInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the group that contains the tag. */
  groupHandle: Scalars['String']['output'];
  /** The ID of the group that contains the tag. */
  groupId: Scalars['Int']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all tags. */
export type TagInterface_CountArgs = {
  field: Scalars['String']['input'];
};

export type TagRelationCriteriaInput = {
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the tag groups the tags belong to per the group’s handles. */
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the tag groups the tags belong to, per the groups’ IDs. */
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines which site(s) the elements should be queried in, based on their language. */
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to elements that do not relate to the provided element IDs. */
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  /** Narrows the relations based on the field they were created in. */
  relatedViaField?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the relations based on the site they were created in. */
  relatedViaSite?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type User = ElementInterface & UserInterface & {
  __typename?: 'User';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The user’s addresses. */
  addresses?: Maybe<Array<Maybe<AddressInterface>>>;
  /** The handle of the site the user is affiliated with. */
  affiliatedSiteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the user is affiliated with. */
  affiliatedSiteId?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The user’s email. */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The user’s first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The user’s first name or username. */
  friendlyName?: Maybe<Scalars['String']['output']>;
  /** The user’s full name. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The user’s last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The user’s full name or username. */
  name: Scalars['String']['output'];
  /** The user’s photo. */
  photo?: Maybe<AssetInterface>;
  /** The user’s preferences. */
  preferences: Scalars['String']['output'];
  /** The user’s preferred language. */
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The username. */
  username?: Maybe<Scalars['String']['output']>;
};


export type User_CountArgs = {
  field: Scalars['String']['input'];
};


export type UserAddressesArgs = {
  administrativeArea?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** This is the interface implemented by all users. */
export type UserInterface = {
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The user’s addresses. */
  addresses?: Maybe<Array<Maybe<AddressInterface>>>;
  /** The handle of the site the user is affiliated with. */
  affiliatedSiteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the user is affiliated with. */
  affiliatedSiteId?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The user’s email. */
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The user’s first name. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** The user’s first name or username. */
  friendlyName?: Maybe<Scalars['String']['output']>;
  /** The user’s full name. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The user’s last name. */
  lastName?: Maybe<Scalars['String']['output']>;
  /** The user’s full name or username. */
  name: Scalars['String']['output'];
  /** The user’s photo. */
  photo?: Maybe<AssetInterface>;
  /** The user’s preferences. */
  preferences: Scalars['String']['output'];
  /** The user’s preferred language. */
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The username. */
  username?: Maybe<Scalars['String']['output']>;
};


/** This is the interface implemented by all users. */
export type UserInterface_CountArgs = {
  field: Scalars['String']['input'];
};


/** This is the interface implemented by all users. */
export type UserInterfaceAddressesArgs = {
  administrativeArea?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserRelationCriteriaInput = {
  /** Determines which site(s) the users should be affiliated with. */
  affiliatedSite?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines which site(s) the users should be affiliated with. */
  affiliatedSiteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on whether the users have uploaded any assets. */
  assetUploaders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on whether the users are listed as the author of any entries. */
  authors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the elements’ creation dates. */
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ last-updated dates. */
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the users’ email addresses. */
  email?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the users’ first names. */
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Causes the query results to be returned in the order specified by the `id` argument. */
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the users’ full names. */
  fullName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the user group the users belong to. */
  group?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the user group the users belong to, per the groups’ IDs. */
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to only users that have (or don’t have) a user photo. */
  hasPhoto?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the elements’ IDs. */
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Causes the query results to be returned in reverse order. */
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Determines which site(s) the elements should be queried in, based on their language. */
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the users’ last names. */
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Sets the limit for paginated results. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Narrows the query results to elements that do not relate to the provided element IDs. */
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Sets the offset for paginated results. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Sets the field the returned elements should be ordered by. */
  orderBy?: InputMaybe<Scalars['String']['input']>;
  /** Determines which site should be selected when querying multi-site elements. */
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on a reference string. */
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to elements that relate to the provided element IDs. This argument is ignored, if `relatedToAll` is also used. */
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to elements that relate to *all* of the provided element IDs. Using this argument will cause `relatedTo` argument to be ignored. **This argument is deprecated.** `relatedTo: ["and", ...ids]` should be used instead. */
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results to elements that relate to an asset list defined with this argument. */
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a category list defined with this argument. */
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to an entry list defined with this argument. */
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a tag list defined with this argument. */
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  /** Narrows the query results to elements that relate to a use list defined with this argument. */
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  /** Narrows the relations based on the field they were created in. */
  relatedViaField?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the relations based on the site they were created in. */
  relatedViaSite?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results to only elements that match a search query. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines which site(s) the elements should be queried in. Defaults to the current (requested) site. */
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the unique identifier for an element-site relation. */
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  /** Narrows the query results based on the elements’ slugs. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ titles. */
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the elements’ UIDs. */
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Determines whether only elements with unique IDs should be returned by the query. */
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  /** Narrows the query results based on the elements’ URIs. */
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Narrows the query results based on the users’ usernames. */
  username?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type AccommodationType_Category = CategoryInterface & ElementInterface & {
  __typename?: 'accommodationType_Category';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The category’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<CategoryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The category’s children. */
  children: Array<CategoryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The category’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<CategoryInterface>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the group that contains the category. */
  groupHandle: Scalars['String']['output'];
  /** The ID of the group that contains the category. */
  groupId: Scalars['Int']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<CategoryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type AccommodationType_Category_CountArgs = {
  field: Scalars['String']['input'];
};


export type AccommodationType_CategoryAncestorsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccommodationType_CategoryChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccommodationType_CategoryDescendantsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccommodationType_CategoryLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccommodationType_CategoryNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccommodationType_CategoryParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccommodationType_CategoryPrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccommodationType_CategorySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionItem_Entry = ElementInterface & EntryInterface & {
  __typename?: 'accordionItem_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<EntryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']['output']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']['output']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children: Array<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<EntryInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']['output']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']['output']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the element is enabled for the site. */
  enabledForSite?: Maybe<Scalars['Boolean']['output']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** The handle of the field that contains the entry. */
  fieldHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the field that contains the entry. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  htmlContentDefault?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<EntryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The ID of the entry’s owner elementt. */
  ownerId?: Maybe<Scalars['Int']['output']>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']['output']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']['output']>;
  /** The revision notes (from the `revisions` table). */
  revisionNotes?: Maybe<Scalars['String']['output']>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The entry’s position within the field that contains it. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle: Scalars['String']['output'];
  /** The ID of the entry type that contains the entry. */
  typeId: Scalars['Int']['output'];
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type AccordionItem_Entry_CountArgs = {
  field: Scalars['String']['input'];
};


export type AccordionItem_EntryAncestorsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionItem_EntryChildrenArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionItem_EntryDescendantsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionItem_EntryLocalizedArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionItem_EntryNextArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionItem_EntryParentArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionItem_EntryPrevArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type AccordionItem_EntrySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type AccordionItemsFieldEntryUnion = AccordionItem_Entry;

export type AccordionItems_MatrixField = AccordionItem_Entry;

export type AcknowledgmentOfCountry_GlobalSet = ElementInterface & GlobalSetInterface & {
  __typename?: 'acknowledgmentOfCountry_GlobalSet';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the global set. */
  handle: Scalars['String']['output'];
  htmlContentSimple?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The name of the global set. */
  name: Scalars['String']['output'];
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type AcknowledgmentOfCountry_GlobalSet_CountArgs = {
  field: Scalars['String']['input'];
};

export type ArticleCategory_Category = CategoryInterface & ElementInterface & {
  __typename?: 'articleCategory_Category';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The category’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<CategoryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The category’s children. */
  children: Array<CategoryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The category’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<CategoryInterface>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the group that contains the category. */
  groupHandle: Scalars['String']['output'];
  /** The ID of the group that contains the category. */
  groupId: Scalars['Int']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<CategoryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type ArticleCategory_Category_CountArgs = {
  field: Scalars['String']['input'];
};


export type ArticleCategory_CategoryAncestorsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleCategory_CategoryChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleCategory_CategoryDescendantsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleCategory_CategoryLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleCategory_CategoryNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleCategory_CategoryParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleCategory_CategoryPrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ArticleCategory_CategorySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type ArticleIndexSectionEntryUnion = Page_Entry;

export type ArticleSectionEntryUnion = Page_Entry;

export type Assets_Asset = AssetInterface & ElementInterface & {
  __typename?: 'assets_Asset';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Alternative text for the asset. */
  alt?: Maybe<Scalars['String']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the asset file was last modified. */
  dateModified?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The file extension for the asset file. */
  extension: Scalars['String']['output'];
  /** The filename of the asset file. */
  filename: Scalars['String']['output'];
  /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
  focalPoint?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** The ID of the folder that the asset belongs to. */
  folderId: Scalars['Int']['output'];
  /** Returns the file’s format. */
  format?: Maybe<Scalars['String']['output']>;
  /** Whether a user-defined focal point is set on the asset. */
  hasFocalPoint: Scalars['Boolean']['output'];
  /** The height in pixels or null if it’s not an image. */
  height?: Maybe<Scalars['Int']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** An `<img>` tag based on this asset. */
  img?: Maybe<Scalars['String']['output']>;
  /** The file kind. */
  kind: Scalars['String']['output'];
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The file’s MIME type, if it can be determined. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<AssetInterface>;
  /** The asset’s path in the volume. */
  path: Scalars['String']['output'];
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<AssetInterface>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The file size in bytes. */
  size?: Maybe<Scalars['String']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
  srcset?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
  url?: Maybe<Scalars['String']['output']>;
  /** The ID of the volume that the asset belongs to. */
  volumeId?: Maybe<Scalars['Int']['output']>;
  /** The width in pixels or null if it’s not an image. */
  width?: Maybe<Scalars['Int']['output']>;
};


export type Assets_Asset_CountArgs = {
  field: Scalars['String']['input'];
};


export type Assets_AssetFormatArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type Assets_AssetHeightArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type Assets_AssetNextArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Assets_AssetPrevArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Assets_AssetSrcsetArgs = {
  sizes: Array<Scalars['String']['input']>;
};


export type Assets_AssetUrlArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type Assets_AssetWidthArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type Awards_GlobalSet = ElementInterface & GlobalSetInterface & {
  __typename?: 'awards_GlobalSet';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the global set. */
  handle: Scalars['String']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  logoGallery: Array<Maybe<LogoGallery_MatrixField>>;
  /** The name of the global set. */
  name: Scalars['String']['output'];
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Awards_GlobalSet_CountArgs = {
  field: Scalars['String']['input'];
};


export type Awards_GlobalSetLogoGalleryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BlockHomeHeroBanner_Entry = ElementInterface & EntryInterface & {
  __typename?: 'blockHomeHeroBanner_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<EntryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']['output']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']['output']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children: Array<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<EntryInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']['output']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']['output']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the element is enabled for the site. */
  enabledForSite?: Maybe<Scalars['Boolean']['output']>;
  entryLinkMultiple: Array<Maybe<HyperLinkInterface>>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** The handle of the field that contains the entry. */
  fieldHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the field that contains the entry. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heroHeading?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  images: Array<Maybe<AssetInterface>>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  linkSingle: Array<Maybe<HyperLinkInterface>>;
  /** The same element in other locales. */
  localized: Array<EntryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The ID of the entry’s owner elementt. */
  ownerId?: Maybe<Scalars['Int']['output']>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']['output']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  quickLinksLabel?: Maybe<Scalars['String']['output']>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']['output']>;
  /** The revision notes (from the `revisions` table). */
  revisionNotes?: Maybe<Scalars['String']['output']>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The entry’s position within the field that contains it. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle: Scalars['String']['output'];
  /** The ID of the entry type that contains the entry. */
  typeId: Scalars['Int']['output'];
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type BlockHomeHeroBanner_Entry_CountArgs = {
  field: Scalars['String']['input'];
};


export type BlockHomeHeroBanner_EntryAncestorsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHomeHeroBanner_EntryChildrenArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHomeHeroBanner_EntryDescendantsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHomeHeroBanner_EntryImagesArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type BlockHomeHeroBanner_EntryLocalizedArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHomeHeroBanner_EntryNextArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHomeHeroBanner_EntryParentArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHomeHeroBanner_EntryPrevArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type BlockHomeHeroBanner_EntrySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type BlocksHomeFieldEntryUnion = BlockHomeHeroBanner_Entry;

export type BlocksHome_MatrixField = BlockHomeHeroBanner_Entry;

export type Blocks_NeoField = Blocks_BlockAccordion_BlockType | Blocks_BlockBlockquote_BlockType | Blocks_BlockCta_BlockType | Blocks_BlockDownloads_BlockType | Blocks_BlockForm_BlockType | Blocks_BlockImageAndText_BlockType | Blocks_BlockImageCarousel_BlockType | Blocks_BlockImage_BlockType | Blocks_BlockInternalPageCards_BlockType | Blocks_BlockLatestNews_BlockType | Blocks_BlockMap_BlockType | Blocks_BlockRichText_BlockType | Blocks_BlockServices_BlockType | Blocks_BlockVideo_BlockType | Blocks_ProfileAccordionItem_BlockType | Blocks_ProfileAccordion_BlockType;

export type Blocks_BlockAccordion_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockAccordion_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  accordionItems: Array<Maybe<AccordionItems_MatrixField>>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockAccordion_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};


export type Blocks_BlockAccordion_BlockTypeAccordionItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Blocks_BlockBlockquote_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockBlockquote_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  htmlContentSimple?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockBlockquote_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};

export type Blocks_BlockCta_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockCta_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  htmlContentSimple?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  linkSingle: Array<Maybe<HyperLinkInterface>>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockCta_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};

export type Blocks_BlockDownloads_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockDownloads_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  linkAssetMultiple: Array<Maybe<HyperLinkInterface>>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockDownloads_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};

export type Blocks_BlockForm_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockForm_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  form?: Maybe<Array<Maybe<FormInterface>>>;
  heading?: Maybe<Scalars['String']['output']>;
  htmlContentSimple?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockForm_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};


export type Blocks_BlockForm_BlockTypeFormArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  handle?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Blocks_BlockImageAndText_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockImageAndText_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  htmlContentSimple?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  image: Array<Maybe<AssetInterface>>;
  imageAlignment?: Maybe<Scalars['String']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  linkSingle: Array<Maybe<HyperLinkInterface>>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockImageAndText_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};


export type Blocks_BlockImageAndText_BlockTypeImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Blocks_BlockImageAndText_BlockTypeImageAlignmentArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Blocks_BlockImageCarousel_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockImageCarousel_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  images: Array<Maybe<AssetInterface>>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockImageCarousel_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};


export type Blocks_BlockImageCarousel_BlockTypeImagesArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Blocks_BlockImage_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockImage_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  image: Array<Maybe<AssetInterface>>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockImage_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};


export type Blocks_BlockImage_BlockTypeImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type Blocks_BlockInternalPageCards_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockInternalPageCards_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entryMultiple: Array<Maybe<EntryInterface>>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockInternalPageCards_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};


export type Blocks_BlockInternalPageCards_BlockTypeEntryMultipleArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Blocks_BlockLatestNews_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockLatestNews_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entryLinkSingle: Array<Maybe<HyperLinkInterface>>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockLatestNews_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};

export type Blocks_BlockMap_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockMap_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  address?: Maybe<GoogleMaps_Address>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  htmlContentSimple?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  showPreciseAddress?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockMap_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};

export type Blocks_BlockRichText_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockRichText_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  htmlContentDefault?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  linkSingle: Array<Maybe<HyperLinkInterface>>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockRichText_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};

export type Blocks_BlockServices_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockServices_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  entryLinkSingle: Array<Maybe<HyperLinkInterface>>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  serviceMultiple: Array<Maybe<EntryInterface>>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockServices_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};


export type Blocks_BlockServices_BlockTypeServiceMultipleArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Blocks_BlockVideo_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_blockVideo_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  videoUrl?: Maybe<Scalars['String']['output']>;
};


export type Blocks_BlockVideo_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};

export type Blocks_ProfileAccordionItem_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_profileAccordionItem_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  heading?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  profileMultiple: Array<Maybe<EntryInterface>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_ProfileAccordionItem_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};


export type Blocks_ProfileAccordionItem_BlockTypeProfileMultipleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Blocks_ProfileAccordion_BlockType = ElementInterface & NeoBlockInterface & {
  __typename?: 'blocks_profileAccordion_BlockType';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The child block types for this Neo block */
  children?: Maybe<Array<Maybe<NeoBlockInterface>>>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the field that owns the Neo block. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The Neo block’s level. */
  level?: Maybe<Scalars['Int']['output']>;
  /** The ID of the primary owner of the Neo block. */
  primaryOwnerId?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The sort order of the Neo block within the owner element field. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the Neo block’s type. */
  typeHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the Neo block’s type. */
  typeId?: Maybe<Scalars['Int']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Blocks_ProfileAccordion_BlockType_CountArgs = {
  field: Scalars['String']['input'];
};

export type ContactTest_Form = ElementInterface & FormInterface & {
  __typename?: 'contactTest_Form';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** A list of captcha values (name and value) to assist with spam protection. */
  captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
  /** The form’s config as JSON. */
  configJson?: Maybe<Scalars['String']['output']>;
  /** A CSRF token (name and value). */
  csrfToken?: Maybe<FormieCsrfTokenType>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The form’s fields. */
  formFields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The form’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  howShouldWeContactYou?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the form is considered available according to user checks, scheduling and more. */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** The form’s pages. */
  pages?: Maybe<Array<Maybe<PageInterface>>>;
  /** The form’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The form’s settings. */
  settings?: Maybe<FormSettingsType>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The form’s endpoint for sending submissions to, if using POST requests. */
  submissionEndpoint?: Maybe<Scalars['String']['output']>;
  /** The form’s GQL mutation name for submissions to use. */
  submissionMutationName?: Maybe<Scalars['String']['output']>;
  /** The form’s CSS for rendering. */
  templateCss?: Maybe<Scalars['String']['output']>;
  /** The form’s rendered HTML. */
  templateHtml?: Maybe<Scalars['String']['output']>;
  /** The form’s JS for rendering and functionality. */
  templateJs?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  yourName?: Maybe<NameType>;
};


export type ContactTest_Form_CountArgs = {
  field: Scalars['String']['input'];
};


export type ContactTest_FormFormFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContactTest_FormHowShouldWeContactYouArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContactTest_FormRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ContactTest_FormTemplateHtmlArgs = {
  options?: InputMaybe<Scalars['String']['input']>;
  populateFormValues?: InputMaybe<Scalars['String']['input']>;
};


export type ContactTest_FormTemplateJsArgs = {
  initJs?: InputMaybe<Scalars['Boolean']['input']>;
  useObserver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactTest_Submission = ElementInterface & SubmissionInterface & {
  __typename?: 'contactTest_Submission';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  howShouldWeContactYou?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The submission’s IP Address. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the submission is incomplete. */
  isIncomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the submission is spam. */
  isSpam?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The submission’s spam type. */
  spamClass?: Maybe<Scalars['String']['output']>;
  /** The submission’s spam reason. */
  spamReason?: Maybe<Scalars['String']['output']>;
  /** The submission’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The submission’s status ID. */
  statusId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  yourName?: Maybe<NameType>;
};


export type ContactTest_Submission_CountArgs = {
  field: Scalars['String']['input'];
};


export type ContactTest_SubmissionHowShouldWeContactYouArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContactTest_YourName_FormieNameInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type EnquiryForm_Form = ElementInterface & FormInterface & {
  __typename?: 'enquiryForm_Form';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** A list of captcha values (name and value) to assist with spam protection. */
  captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
  /** The form’s config as JSON. */
  configJson?: Maybe<Scalars['String']['output']>;
  /** A CSRF token (name and value). */
  csrfToken?: Maybe<FormieCsrfTokenType>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The form’s fields. */
  formFields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The form’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the form is considered available according to user checks, scheduling and more. */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** The form’s pages. */
  pages?: Maybe<Array<Maybe<PageInterface>>>;
  /** The form’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The form’s settings. */
  settings?: Maybe<FormSettingsType>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The form’s endpoint for sending submissions to, if using POST requests. */
  submissionEndpoint?: Maybe<Scalars['String']['output']>;
  /** The form’s GQL mutation name for submissions to use. */
  submissionMutationName?: Maybe<Scalars['String']['output']>;
  /** The form’s CSS for rendering. */
  templateCss?: Maybe<Scalars['String']['output']>;
  /** The form’s rendered HTML. */
  templateHtml?: Maybe<Scalars['String']['output']>;
  /** The form’s JS for rendering and functionality. */
  templateJs?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  yourName?: Maybe<NameType>;
};


export type EnquiryForm_Form_CountArgs = {
  field: Scalars['String']['input'];
};


export type EnquiryForm_FormFormFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnquiryForm_FormRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type EnquiryForm_FormTemplateHtmlArgs = {
  options?: InputMaybe<Scalars['String']['input']>;
  populateFormValues?: InputMaybe<Scalars['String']['input']>;
};


export type EnquiryForm_FormTemplateJsArgs = {
  initJs?: InputMaybe<Scalars['Boolean']['input']>;
  useObserver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EnquiryForm_Submission = ElementInterface & SubmissionInterface & {
  __typename?: 'enquiryForm_Submission';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The submission’s IP Address. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the submission is incomplete. */
  isIncomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the submission is spam. */
  isSpam?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The submission’s spam type. */
  spamClass?: Maybe<Scalars['String']['output']>;
  /** The submission’s spam reason. */
  spamReason?: Maybe<Scalars['String']['output']>;
  /** The submission’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The submission’s status ID. */
  statusId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  yourName?: Maybe<NameType>;
};


export type EnquiryForm_Submission_CountArgs = {
  field: Scalars['String']['input'];
};

export type EnquiryForm_YourName_FormieNameInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type EntryLinkMultiple_Asset_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkMultiple_Asset_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkMultiple_Category_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkMultiple_Category_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkMultiple_Custom_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkMultiple_Custom_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkMultiple_Email_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkMultiple_Email_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkMultiple_Embed_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkMultiple_Embed_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkMultiple_Entry_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkMultiple_Entry_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkMultiple_Phone_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkMultiple_Phone_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkMultiple_Site_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkMultiple_Site_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkMultiple_Url_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkMultiple_Url_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkMultiple_User_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkMultiple_User_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkSingle_Asset_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkSingle_Asset_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkSingle_Category_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkSingle_Category_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkSingle_Custom_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkSingle_Custom_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkSingle_Email_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkSingle_Email_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkSingle_Embed_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkSingle_Embed_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkSingle_Entry_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkSingle_Entry_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkSingle_Phone_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkSingle_Phone_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkSingle_Site_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkSingle_Site_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkSingle_Url_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkSingle_Url_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EntryLinkSingle_User_LinkType = HyperLinkInterface & {
  __typename?: 'entryLinkSingle_User_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type EventSectionEntryUnion = Page_Entry;

export type FooterCtasNav_Node = ElementInterface & NodeInterface & {
  __typename?: 'footerCtasNav_Node';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The node’s children. Accepts the same arguments as the `nodes` query. */
  children?: Maybe<Array<Maybe<NodeInterface>>>;
  /** Any additional classes for the node. */
  classes?: Maybe<Scalars['String']['output']>;
  /** Any additional custom attributes for the node. */
  customAttributes?: Maybe<Array<Maybe<NodeCustomAttribute>>>;
  /** Any additional data for the node. */
  data?: Maybe<Scalars['String']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The element the node links to. */
  element?: Maybe<ElementInterface>;
  /** The ID of the element this node is linked to. */
  elementId?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The handle of the navigation this node belongs to. */
  navHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the navigation this node belongs to. */
  navId?: Maybe<Scalars['Int']['output']>;
  /** The name of the navigation this node belongs to. */
  navName?: Maybe<Scalars['String']['output']>;
  /** Whether this node should open in a new window. */
  newWindow?: Maybe<Scalars['String']['output']>;
  /** The node’s URI */
  nodeUri?: Maybe<Scalars['String']['output']>;
  /** The node’s parent. */
  parent?: Maybe<NodeInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The type of node this is. */
  type?: Maybe<Scalars['String']['output']>;
  /** The display name for the type of node this is. */
  typeLabel?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The node’s full URL */
  url?: Maybe<Scalars['String']['output']>;
  /** The URL for this navigation item. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};


export type FooterCtasNav_Node_CountArgs = {
  field: Scalars['String']['input'];
};


export type FooterCtasNav_NodeChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nav?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navHandle?: InputMaybe<Scalars['String']['input']>;
  navId?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FooterNav_Node = ElementInterface & NodeInterface & {
  __typename?: 'footerNav_Node';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The node’s children. Accepts the same arguments as the `nodes` query. */
  children?: Maybe<Array<Maybe<NodeInterface>>>;
  /** Any additional classes for the node. */
  classes?: Maybe<Scalars['String']['output']>;
  /** Any additional custom attributes for the node. */
  customAttributes?: Maybe<Array<Maybe<NodeCustomAttribute>>>;
  /** Any additional data for the node. */
  data?: Maybe<Scalars['String']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The element the node links to. */
  element?: Maybe<ElementInterface>;
  /** The ID of the element this node is linked to. */
  elementId?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The handle of the navigation this node belongs to. */
  navHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the navigation this node belongs to. */
  navId?: Maybe<Scalars['Int']['output']>;
  /** The name of the navigation this node belongs to. */
  navName?: Maybe<Scalars['String']['output']>;
  /** Whether this node should open in a new window. */
  newWindow?: Maybe<Scalars['String']['output']>;
  /** The node’s URI */
  nodeUri?: Maybe<Scalars['String']['output']>;
  /** The node’s parent. */
  parent?: Maybe<NodeInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The type of node this is. */
  type?: Maybe<Scalars['String']['output']>;
  /** The display name for the type of node this is. */
  typeLabel?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The node’s full URL */
  url?: Maybe<Scalars['String']['output']>;
  /** The URL for this navigation item. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};


export type FooterNav_Node_CountArgs = {
  field: Scalars['String']['input'];
};


export type FooterNav_NodeChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nav?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navHandle?: InputMaybe<Scalars['String']['input']>;
  navId?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeSectionEntryUnion = Page_Entry;

export type HousingLink_Form = ElementInterface & FormInterface & {
  __typename?: 'housingLink_Form';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** A list of captcha values (name and value) to assist with spam protection. */
  captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
  /** The form’s config as JSON. */
  configJson?: Maybe<Scalars['String']['output']>;
  /** A CSRF token (name and value). */
  csrfToken?: Maybe<FormieCsrfTokenType>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The form’s fields. */
  formFields?: Maybe<Array<Maybe<FieldInterface>>>;
  /** The form’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  iAmLookingForDisabilityAccommodationFor?: Maybe<Scalars['String']['output']>;
  iWouldLikeSomeoneToContactMeToDiscussMyEligibilityForSdaHousingO?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  idLikeToSubscribeToTheHousingLinkNewsletter2?: Maybe<Scalars['String']['output']>;
  /** Whether the form is considered available according to user checks, scheduling and more. */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  name1?: Maybe<NameType>;
  /** The form’s pages. */
  pages?: Maybe<Array<Maybe<PageInterface>>>;
  phone?: Maybe<Scalars['String']['output']>;
  /** The form’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The form’s settings. */
  settings?: Maybe<FormSettingsType>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The form’s endpoint for sending submissions to, if using POST requests. */
  submissionEndpoint?: Maybe<Scalars['String']['output']>;
  /** The form’s GQL mutation name for submissions to use. */
  submissionMutationName?: Maybe<Scalars['String']['output']>;
  /** The form’s CSS for rendering. */
  templateCss?: Maybe<Scalars['String']['output']>;
  /** The form’s rendered HTML. */
  templateHtml?: Maybe<Scalars['String']['output']>;
  /** The form’s JS for rendering and functionality. */
  templateJs?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type HousingLink_Form_CountArgs = {
  field: Scalars['String']['input'];
};


export type HousingLink_FormFormFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HousingLink_FormIAmLookingForDisabilityAccommodationForArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HousingLink_FormIWouldLikeSomeoneToContactMeToDiscussMyEligibilityForSdaHousingOArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HousingLink_FormIdLikeToSubscribeToTheHousingLinkNewsletter2Args = {
  label?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HousingLink_FormRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HousingLink_FormTemplateHtmlArgs = {
  options?: InputMaybe<Scalars['String']['input']>;
  populateFormValues?: InputMaybe<Scalars['String']['input']>;
};


export type HousingLink_FormTemplateJsArgs = {
  initJs?: InputMaybe<Scalars['Boolean']['input']>;
  useObserver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HousingLink_Submission = ElementInterface & SubmissionInterface & {
  __typename?: 'housingLink_Submission';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  iAmLookingForDisabilityAccommodationFor?: Maybe<Scalars['String']['output']>;
  iWouldLikeSomeoneToContactMeToDiscussMyEligibilityForSdaHousingO?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  idLikeToSubscribeToTheHousingLinkNewsletter2?: Maybe<Scalars['String']['output']>;
  /** The submission’s IP Address. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the submission is incomplete. */
  isIncomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the submission is spam. */
  isSpam?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  name1?: Maybe<NameType>;
  phone?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The submission’s spam type. */
  spamClass?: Maybe<Scalars['String']['output']>;
  /** The submission’s spam reason. */
  spamReason?: Maybe<Scalars['String']['output']>;
  /** The submission’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The submission’s status ID. */
  statusId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type HousingLink_Submission_CountArgs = {
  field: Scalars['String']['input'];
};


export type HousingLink_SubmissionIAmLookingForDisabilityAccommodationForArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HousingLink_SubmissionIWouldLikeSomeoneToContactMeToDiscussMyEligibilityForSdaHousingOArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>;
};


export type HousingLink_SubmissionIdLikeToSubscribeToTheHousingLinkNewsletter2Args = {
  label?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HousingLink_Name1_FormieNameInput = {
  firstName: Scalars['String']['input'];
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type Icons_Asset = AssetInterface & ElementInterface & {
  __typename?: 'icons_Asset';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Alternative text for the asset. */
  alt?: Maybe<Scalars['String']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the asset file was last modified. */
  dateModified?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The file extension for the asset file. */
  extension: Scalars['String']['output'];
  /** The filename of the asset file. */
  filename: Scalars['String']['output'];
  /** The focal point represented as an array with `x` and `y` keys, or null if it’s not an image. */
  focalPoint?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  /** The ID of the folder that the asset belongs to. */
  folderId: Scalars['Int']['output'];
  /** Returns the file’s format. */
  format?: Maybe<Scalars['String']['output']>;
  /** Whether a user-defined focal point is set on the asset. */
  hasFocalPoint: Scalars['Boolean']['output'];
  /** The height in pixels or null if it’s not an image. */
  height?: Maybe<Scalars['Int']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** An `<img>` tag based on this asset. */
  img?: Maybe<Scalars['String']['output']>;
  /** The file kind. */
  kind: Scalars['String']['output'];
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The file’s MIME type, if it can be determined. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<AssetInterface>;
  /** The asset’s path in the volume. */
  path: Scalars['String']['output'];
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<AssetInterface>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The file size in bytes. */
  size?: Maybe<Scalars['String']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** Returns a `srcset` attribute value based on the given widths or x-descriptors. */
  srcset?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The full URL of the asset. This field accepts the same fields as the `transform` directive. */
  url?: Maybe<Scalars['String']['output']>;
  /** The ID of the volume that the asset belongs to. */
  volumeId?: Maybe<Scalars['Int']['output']>;
  /** The width in pixels or null if it’s not an image. */
  width?: Maybe<Scalars['Int']['output']>;
};


export type Icons_Asset_CountArgs = {
  field: Scalars['String']['input'];
};


export type Icons_AssetFormatArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type Icons_AssetHeightArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type Icons_AssetNextArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Icons_AssetPrevArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Icons_AssetSrcsetArgs = {
  sizes: Array<Scalars['String']['input']>;
};


export type Icons_AssetUrlArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};


export type Icons_AssetWidthArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  handle?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  immediately?: InputMaybe<Scalars['Boolean']['input']>;
  interlace?: InputMaybe<Scalars['String']['input']>;
  mode?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['String']['input']>;
  quality?: InputMaybe<Scalars['Int']['input']>;
  transform?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type Legal_GlobalSet = ElementInterface & GlobalSetInterface & {
  __typename?: 'legal_GlobalSet';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  copyrightEntity?: Maybe<Scalars['String']['output']>;
  copyrightText?: Maybe<Scalars['String']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the global set. */
  handle: Scalars['String']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The name of the global set. */
  name: Scalars['String']['output'];
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Legal_GlobalSet_CountArgs = {
  field: Scalars['String']['input'];
};

export type LinkAssetMultiple_Asset_LinkType = HyperLinkInterface & {
  __typename?: 'linkAssetMultiple_Asset_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkAssetMultiple_Category_LinkType = HyperLinkInterface & {
  __typename?: 'linkAssetMultiple_Category_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkAssetMultiple_Custom_LinkType = HyperLinkInterface & {
  __typename?: 'linkAssetMultiple_Custom_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkAssetMultiple_Email_LinkType = HyperLinkInterface & {
  __typename?: 'linkAssetMultiple_Email_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkAssetMultiple_Embed_LinkType = HyperLinkInterface & {
  __typename?: 'linkAssetMultiple_Embed_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkAssetMultiple_Entry_LinkType = HyperLinkInterface & {
  __typename?: 'linkAssetMultiple_Entry_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkAssetMultiple_Phone_LinkType = HyperLinkInterface & {
  __typename?: 'linkAssetMultiple_Phone_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkAssetMultiple_Site_LinkType = HyperLinkInterface & {
  __typename?: 'linkAssetMultiple_Site_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkAssetMultiple_Url_LinkType = HyperLinkInterface & {
  __typename?: 'linkAssetMultiple_Url_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkAssetMultiple_User_LinkType = HyperLinkInterface & {
  __typename?: 'linkAssetMultiple_User_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkSingle_Asset_LinkType = HyperLinkInterface & {
  __typename?: 'linkSingle_Asset_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkSingle_Category_LinkType = HyperLinkInterface & {
  __typename?: 'linkSingle_Category_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkSingle_Custom_LinkType = HyperLinkInterface & {
  __typename?: 'linkSingle_Custom_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkSingle_Email_LinkType = HyperLinkInterface & {
  __typename?: 'linkSingle_Email_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkSingle_Embed_LinkType = HyperLinkInterface & {
  __typename?: 'linkSingle_Embed_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkSingle_Entry_LinkType = HyperLinkInterface & {
  __typename?: 'linkSingle_Entry_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkSingle_Phone_LinkType = HyperLinkInterface & {
  __typename?: 'linkSingle_Phone_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkSingle_Site_LinkType = HyperLinkInterface & {
  __typename?: 'linkSingle_Site_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkSingle_Url_LinkType = HyperLinkInterface & {
  __typename?: 'linkSingle_Url_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkSingle_User_LinkType = HyperLinkInterface & {
  __typename?: 'linkSingle_User_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type LinkedImage_Entry = ElementInterface & EntryInterface & {
  __typename?: 'linkedImage_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<EntryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']['output']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']['output']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children: Array<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<EntryInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']['output']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']['output']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the element is enabled for the site. */
  enabledForSite?: Maybe<Scalars['Boolean']['output']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  /** The handle of the field that contains the entry. */
  fieldHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the field that contains the entry. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  image: Array<Maybe<AssetInterface>>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The same element in other locales. */
  localized: Array<EntryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The ID of the entry’s owner elementt. */
  ownerId?: Maybe<Scalars['Int']['output']>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']['output']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']['output']>;
  /** The revision notes (from the `revisions` table). */
  revisionNotes?: Maybe<Scalars['String']['output']>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The entry’s position within the field that contains it. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle: Scalars['String']['output'];
  /** The ID of the entry type that contains the entry. */
  typeId: Scalars['Int']['output'];
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type LinkedImage_Entry_CountArgs = {
  field: Scalars['String']['input'];
};


export type LinkedImage_EntryAncestorsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkedImage_EntryChildrenArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkedImage_EntryDescendantsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkedImage_EntryImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type LinkedImage_EntryLocalizedArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkedImage_EntryNextArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkedImage_EntryParentArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkedImage_EntryPrevArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type LinkedImage_EntrySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type LocationIndexSectionEntryUnion = Page_Entry;

export type LocationSectionEntryUnion = Page_Entry;

export type LogoGalleryFieldEntryUnion = LinkedImage_Entry;

export type LogoGallery_MatrixField = LinkedImage_Entry;

export type NotFoundSectionEntryUnion = Page_Entry;

export type PageSectionEntryUnion = Page_Entry;

export type Page_Entry = ElementInterface & EntryInterface & {
  __typename?: 'page_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  accommodationTypeMultiple: Array<Maybe<CategoryInterface>>;
  address?: Maybe<GoogleMaps_Address>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<EntryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  articleCategoryMultiple: Array<Maybe<CategoryInterface>>;
  blocks?: Maybe<Array<Maybe<Blocks_NeoField>>>;
  blocksHome: Array<Maybe<BlocksHome_MatrixField>>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']['output']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']['output']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children: Array<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<EntryInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']['output']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']['output']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the element is enabled for the site. */
  enabledForSite?: Maybe<Scalars['Boolean']['output']>;
  endDate?: Maybe<Scalars['DateTime']['output']>;
  endTime?: Maybe<Scalars['DateTime']['output']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  featureImage: Array<Maybe<AssetInterface>>;
  /** The handle of the field that contains the entry. */
  fieldHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the field that contains the entry. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  floorplan: Array<Maybe<AssetInterface>>;
  iconAsset: Array<Maybe<AssetInterface>>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  images: Array<Maybe<AssetInterface>>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<EntryInterface>;
  nBathrooms?: Maybe<Scalars['Number']['output']>;
  nBeds?: Maybe<Scalars['Number']['output']>;
  nCars?: Maybe<Scalars['Number']['output']>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  openingHoursHtml?: Maybe<Scalars['String']['output']>;
  /** The ID of the entry’s owner elementt. */
  ownerId?: Maybe<Scalars['Int']['output']>;
  pageLayout?: Maybe<Scalars['String']['output']>;
  pageTitle?: Maybe<Scalars['String']['output']>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  phoneLinkMultiple: Array<Maybe<HyperLinkInterface>>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']['output']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  propertyCategoryMultiple: Array<Maybe<CategoryInterface>>;
  propertyTypeMultiple: Array<Maybe<CategoryInterface>>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']['output']>;
  /** The revision notes (from the `revisions` table). */
  revisionNotes?: Maybe<Scalars['String']['output']>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']['output']>;
  seoSettings?: Maybe<Scalars['String']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  serviceCategoryMultiple: Array<Maybe<CategoryInterface>>;
  serviceMultiple: Array<Maybe<EntryInterface>>;
  showAnchorLinks?: Maybe<Scalars['Boolean']['output']>;
  showPreciseAddress?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The entry’s position within the field that contains it. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
  startTime?: Maybe<Scalars['DateTime']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  ticketsCta: Array<Maybe<HyperLinkInterface>>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle: Scalars['String']['output'];
  /** The ID of the entry type that contains the entry. */
  typeId: Scalars['Int']['output'];
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type Page_Entry_CountArgs = {
  field: Scalars['String']['input'];
};


export type Page_EntryAccommodationTypeMultipleArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryAncestorsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryArticleCategoryMultipleArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryBlocksArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  level?: InputMaybe<Scalars['QueryArgument']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Page_EntryBlocksHomeArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryChildrenArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryDescendantsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryFeatureImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Page_EntryFloorplanArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Page_EntryIconAssetArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Page_EntryImagesArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Page_EntryLocalizedArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryNextArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryPageLayoutArgs = {
  label?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryParentArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryPrevArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryPropertyCategoryMultipleArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryPropertyTypeMultipleArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntrySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};


export type Page_EntryServiceCategoryMultipleArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Page_EntryServiceMultipleArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PhoneLinkMultiple_Asset_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLinkMultiple_Asset_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLinkMultiple_Category_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLinkMultiple_Category_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLinkMultiple_Custom_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLinkMultiple_Custom_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLinkMultiple_Email_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLinkMultiple_Email_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLinkMultiple_Embed_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLinkMultiple_Embed_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLinkMultiple_Entry_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLinkMultiple_Entry_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLinkMultiple_Phone_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLinkMultiple_Phone_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLinkMultiple_Site_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLinkMultiple_Site_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLinkMultiple_Url_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLinkMultiple_Url_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLinkMultiple_User_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLinkMultiple_User_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLink_Asset_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLink_Asset_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLink_Category_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLink_Category_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLink_Custom_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLink_Custom_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLink_Email_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLink_Email_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLink_Embed_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLink_Embed_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLink_Entry_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLink_Entry_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLink_Phone_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLink_Phone_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLink_Site_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLink_Site_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLink_Url_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLink_Url_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PhoneLink_User_LinkType = HyperLinkInterface & {
  __typename?: 'phoneLink_User_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type PoliciesNav_Node = ElementInterface & NodeInterface & {
  __typename?: 'policiesNav_Node';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The node’s children. Accepts the same arguments as the `nodes` query. */
  children?: Maybe<Array<Maybe<NodeInterface>>>;
  /** Any additional classes for the node. */
  classes?: Maybe<Scalars['String']['output']>;
  /** Any additional custom attributes for the node. */
  customAttributes?: Maybe<Array<Maybe<NodeCustomAttribute>>>;
  /** Any additional data for the node. */
  data?: Maybe<Scalars['String']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The element the node links to. */
  element?: Maybe<ElementInterface>;
  /** The ID of the element this node is linked to. */
  elementId?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The handle of the navigation this node belongs to. */
  navHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the navigation this node belongs to. */
  navId?: Maybe<Scalars['Int']['output']>;
  /** The name of the navigation this node belongs to. */
  navName?: Maybe<Scalars['String']['output']>;
  /** Whether this node should open in a new window. */
  newWindow?: Maybe<Scalars['String']['output']>;
  /** The node’s URI */
  nodeUri?: Maybe<Scalars['String']['output']>;
  /** The node’s parent. */
  parent?: Maybe<NodeInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The type of node this is. */
  type?: Maybe<Scalars['String']['output']>;
  /** The display name for the type of node this is. */
  typeLabel?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The node’s full URL */
  url?: Maybe<Scalars['String']['output']>;
  /** The URL for this navigation item. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};


export type PoliciesNav_Node_CountArgs = {
  field: Scalars['String']['input'];
};


export type PoliciesNav_NodeChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nav?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navHandle?: InputMaybe<Scalars['String']['input']>;
  navId?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PrimaryNav_Node = ElementInterface & NodeInterface & {
  __typename?: 'primaryNav_Node';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The node’s children. Accepts the same arguments as the `nodes` query. */
  children?: Maybe<Array<Maybe<NodeInterface>>>;
  /** Any additional classes for the node. */
  classes?: Maybe<Scalars['String']['output']>;
  /** Any additional custom attributes for the node. */
  customAttributes?: Maybe<Array<Maybe<NodeCustomAttribute>>>;
  /** Any additional data for the node. */
  data?: Maybe<Scalars['String']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The element the node links to. */
  element?: Maybe<ElementInterface>;
  /** The ID of the element this node is linked to. */
  elementId?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The handle of the navigation this node belongs to. */
  navHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the navigation this node belongs to. */
  navId?: Maybe<Scalars['Int']['output']>;
  /** The name of the navigation this node belongs to. */
  navName?: Maybe<Scalars['String']['output']>;
  /** Whether this node should open in a new window. */
  newWindow?: Maybe<Scalars['String']['output']>;
  /** The node’s URI */
  nodeUri?: Maybe<Scalars['String']['output']>;
  /** The node’s parent. */
  parent?: Maybe<NodeInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The type of node this is. */
  type?: Maybe<Scalars['String']['output']>;
  /** The display name for the type of node this is. */
  typeLabel?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The node’s full URL */
  url?: Maybe<Scalars['String']['output']>;
  /** The URL for this navigation item. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};


export type PrimaryNav_Node_CountArgs = {
  field: Scalars['String']['input'];
};


export type PrimaryNav_NodeChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nav?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navHandle?: InputMaybe<Scalars['String']['input']>;
  navId?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProfileGroup_Category = CategoryInterface & ElementInterface & {
  __typename?: 'profileGroup_Category';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The category’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<CategoryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The category’s children. */
  children: Array<CategoryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The category’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<CategoryInterface>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the group that contains the category. */
  groupHandle: Scalars['String']['output'];
  /** The ID of the group that contains the category. */
  groupId: Scalars['Int']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<CategoryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type ProfileGroup_Category_CountArgs = {
  field: Scalars['String']['input'];
};


export type ProfileGroup_CategoryAncestorsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileGroup_CategoryChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileGroup_CategoryDescendantsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileGroup_CategoryLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileGroup_CategoryNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileGroup_CategoryParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileGroup_CategoryPrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileGroup_CategorySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileRole_Category = CategoryInterface & ElementInterface & {
  __typename?: 'profileRole_Category';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The category’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<CategoryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The category’s children. */
  children: Array<CategoryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The category’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<CategoryInterface>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the group that contains the category. */
  groupHandle: Scalars['String']['output'];
  /** The ID of the group that contains the category. */
  groupId: Scalars['Int']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<CategoryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type ProfileRole_Category_CountArgs = {
  field: Scalars['String']['input'];
};


export type ProfileRole_CategoryAncestorsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileRole_CategoryChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileRole_CategoryDescendantsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileRole_CategoryLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileRole_CategoryNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileRole_CategoryParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileRole_CategoryPrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ProfileRole_CategorySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type ProfileSectionEntryUnion = Profile_Entry;

export type Profile_Entry = ElementInterface & EntryInterface & {
  __typename?: 'profile_Entry';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The entry’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<EntryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** Returns the entry’s canonical ID. */
  canonicalId?: Maybe<Scalars['Int']['output']>;
  /** Returns the entry’s canonical UUID. */
  canonicalUid?: Maybe<Scalars['String']['output']>;
  /** The entry’s children, if the section is a structure. Accepts the same arguments as the `entries` query. */
  children: Array<EntryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The entry’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<EntryInterface>;
  /** The draft ID (from the `drafts` table). */
  draftId?: Maybe<Scalars['Int']['output']>;
  /** The name of the draft. */
  draftName?: Maybe<Scalars['String']['output']>;
  /** The notes for the draft. */
  draftNotes?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the element is enabled for the site. */
  enabledForSite?: Maybe<Scalars['Boolean']['output']>;
  /** The expiry date of the entry. */
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  featureImage: Array<Maybe<AssetInterface>>;
  /** The handle of the field that contains the entry. */
  fieldHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the field that contains the entry. */
  fieldId?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  honorific?: Maybe<Scalars['String']['output']>;
  htmlContentDefault?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Returns whether this is a draft. */
  isDraft?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is a revision. */
  isRevision?: Maybe<Scalars['Boolean']['output']>;
  /** Returns whether this is an unpublished draft. */
  isUnpublishedDraft?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<EntryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<EntryInterface>;
  /** The ID of the entry’s owner elementt. */
  ownerId?: Maybe<Scalars['Int']['output']>;
  /** The entry’s parent, if the section is a structure. */
  parent?: Maybe<EntryInterface>;
  /** The entry’s post date. */
  postDate?: Maybe<Scalars['DateTime']['output']>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<EntryInterface>;
  profileGroupMultiple: Array<Maybe<CategoryInterface>>;
  profileRoleMultiple: Array<Maybe<CategoryInterface>>;
  /** The revision ID (from the `revisions` table). */
  revisionId?: Maybe<Scalars['Int']['output']>;
  /** The revision notes (from the `revisions` table). */
  revisionNotes?: Maybe<Scalars['String']['output']>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the section that contains the entry. */
  sectionHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the section that contains the entry. */
  sectionId?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The entry’s position within the field that contains it. */
  sortOrder?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical ID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalId` instead.
   */
  sourceId?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns the entry’s canonical UUID.
   * @deprecated this field has been deprecated since Craft 3.7.7. Use `canonicalUid` instead.
   */
  sourceUid?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the entry type that contains the entry. */
  typeHandle: Scalars['String']['output'];
  /** The ID of the entry type that contains the entry. */
  typeId: Scalars['Int']['output'];
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type Profile_Entry_CountArgs = {
  field: Scalars['String']['input'];
};


export type Profile_EntryAncestorsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Profile_EntryChildrenArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Profile_EntryDescendantsArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Profile_EntryFeatureImageArgs = {
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateModified?: InputMaybe<Scalars['String']['input']>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  folderId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasAlt?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  includeSubfolders?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  size?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uploader?: InputMaybe<Scalars['QueryArgument']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volume?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  volumeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  width?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withTransforms?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type Profile_EntryLocalizedArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Profile_EntryNextArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Profile_EntryParentArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Profile_EntryPrevArgs = {
  accommodationTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  articleCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorGroup?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  authorGroupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  authorId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  endTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  entryLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  expiryDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  featureImage?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fieldId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  floorplan?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  heroHeading?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  honorific?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  htmlContentDefault?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  iconAsset?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  image?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  images?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  linkSingle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  linkUri?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBathrooms?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nBeds?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nCars?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  openingHoursHtml?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  ownerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageLayout?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  pageTitle?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  phoneLinkMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  postDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  primaryOwnerId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileGroupMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  profileRoleMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  propertyTypeMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  quickLinksLabel?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sectionId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  seoSettings?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceCategoryMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  serviceMultiple?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  showAnchorLinks?: InputMaybe<Scalars['Boolean']['input']>;
  showPreciseAddress?: InputMaybe<Scalars['Boolean']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  startTime?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  summary?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  ticketsCta?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Profile_EntryProfileGroupMultipleArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Profile_EntryProfileRoleMultipleArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type Profile_EntrySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyCategory_Category = CategoryInterface & ElementInterface & {
  __typename?: 'propertyCategory_Category';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The category’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<CategoryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The category’s children. */
  children: Array<CategoryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The category’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<CategoryInterface>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the group that contains the category. */
  groupHandle: Scalars['String']['output'];
  /** The ID of the group that contains the category. */
  groupId: Scalars['Int']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<CategoryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type PropertyCategory_Category_CountArgs = {
  field: Scalars['String']['input'];
};


export type PropertyCategory_CategoryAncestorsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyCategory_CategoryChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyCategory_CategoryDescendantsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyCategory_CategoryLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyCategory_CategoryNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyCategory_CategoryParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyCategory_CategoryPrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyCategory_CategorySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type PropertyIndexSectionEntryUnion = Page_Entry;

export type PropertySectionEntryUnion = Page_Entry;

export type PropertyType_Category = CategoryInterface & ElementInterface & {
  __typename?: 'propertyType_Category';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The category’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<CategoryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The category’s children. */
  children: Array<CategoryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The category’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<CategoryInterface>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the group that contains the category. */
  groupHandle: Scalars['String']['output'];
  /** The ID of the group that contains the category. */
  groupId: Scalars['Int']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<CategoryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type PropertyType_Category_CountArgs = {
  field: Scalars['String']['input'];
};


export type PropertyType_CategoryAncestorsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyType_CategoryChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyType_CategoryDescendantsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyType_CategoryLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyType_CategoryNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyType_CategoryParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyType_CategoryPrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type PropertyType_CategorySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type SearchSectionEntryUnion = Page_Entry;

export type ServiceCategory_Category = CategoryInterface & ElementInterface & {
  __typename?: 'serviceCategory_Category';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** The category’s ancestors, if the section is a structure. Accepts the same arguments as the `entries` query. */
  ancestors: Array<CategoryInterface>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The category’s children. */
  children: Array<CategoryInterface>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The category’s descendants, if the section is a structure. Accepts the same arguments as the `entries` query. */
  descendants: Array<CategoryInterface>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the group that contains the category. */
  groupHandle: Scalars['String']['output'];
  /** The ID of the group that contains the category. */
  groupId: Scalars['Int']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The same element in other locales. */
  localized: Array<CategoryInterface>;
  /** Returns the next element relative to this one, from a given set of criteria. */
  next?: Maybe<CategoryInterface>;
  /** The category’s parent. */
  parent?: Maybe<CategoryInterface>;
  /** Returns the previous element relative to this one, from a given set of criteria. */
  prev?: Maybe<CategoryInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** This query is used to query for SEOmatic meta data. */
  seomatic?: Maybe<SeomaticInterface>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The element’s full URL */
  url?: Maybe<Scalars['String']['output']>;
};


export type ServiceCategory_Category_CountArgs = {
  field: Scalars['String']['input'];
};


export type ServiceCategory_CategoryAncestorsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceCategory_CategoryChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceCategory_CategoryDescendantsArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceCategory_CategoryLocalizedArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceCategory_CategoryNextArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceCategory_CategoryParentArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceCategory_CategoryPrevArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  editable?: InputMaybe<Scalars['Boolean']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  groupId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};


export type ServiceCategory_CategorySeomaticArgs = {
  asArray?: InputMaybe<Scalars['Boolean']['input']>;
  environment?: InputMaybe<SeomaticEnvironment>;
  site?: InputMaybe<Scalars['String']['input']>;
  siteId?: InputMaybe<Scalars['Int']['input']>;
  uri?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceIndexSectionEntryUnion = Page_Entry;

export type ServiceSectionEntryUnion = Page_Entry;

export type SocialLinks_Asset_LinkType = HyperLinkInterface & {
  __typename?: 'socialLinks_Asset_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type SocialLinks_Category_LinkType = HyperLinkInterface & {
  __typename?: 'socialLinks_Category_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type SocialLinks_Custom_LinkType = HyperLinkInterface & {
  __typename?: 'socialLinks_Custom_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type SocialLinks_Email_LinkType = HyperLinkInterface & {
  __typename?: 'socialLinks_Email_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type SocialLinks_Embed_LinkType = HyperLinkInterface & {
  __typename?: 'socialLinks_Embed_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type SocialLinks_Entry_LinkType = HyperLinkInterface & {
  __typename?: 'socialLinks_Entry_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type SocialLinks_Phone_LinkType = HyperLinkInterface & {
  __typename?: 'socialLinks_Phone_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type SocialLinks_Site_LinkType = HyperLinkInterface & {
  __typename?: 'socialLinks_Site_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type SocialLinks_Url_LinkType = HyperLinkInterface & {
  __typename?: 'socialLinks_Url_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  icon?: Maybe<Scalars['String']['output']>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type SocialLinks_User_LinkType = HyperLinkInterface & {
  __typename?: 'socialLinks_User_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type Social_GlobalSet = ElementInterface & GlobalSetInterface & {
  __typename?: 'social_GlobalSet';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The handle of the global set. */
  handle: Scalars['String']['output'];
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The name of the global set. */
  name: Scalars['String']['output'];
  phoneLink: Array<Maybe<HyperLinkInterface>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  socialLabel?: Maybe<Scalars['String']['output']>;
  socialLinks: Array<Maybe<HyperLinkInterface>>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type Social_GlobalSet_CountArgs = {
  field: Scalars['String']['input'];
};

export type TestForm_Form = ElementInterface & FormInterface & {
  __typename?: 'testForm_Form';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** A list of captcha values (name and value) to assist with spam protection. */
  captchas?: Maybe<Array<Maybe<FormieCaptchaType>>>;
  /** The form’s config as JSON. */
  configJson?: Maybe<Scalars['String']['output']>;
  /** A CSRF token (name and value). */
  csrfToken?: Maybe<FormieCsrfTokenType>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The form’s fields. */
  formFields?: Maybe<Array<Maybe<FieldInterface>>>;
  fullName?: Maybe<Scalars['String']['output']>;
  /** The form’s handle. */
  handle?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** Whether the form is considered available according to user checks, scheduling and more. */
  isAvailable?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The form’s pages. */
  pages?: Maybe<Array<Maybe<PageInterface>>>;
  /** The form’s rows. */
  rows?: Maybe<Array<Maybe<RowInterface>>>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The form’s settings. */
  settings?: Maybe<FormSettingsType>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The form’s endpoint for sending submissions to, if using POST requests. */
  submissionEndpoint?: Maybe<Scalars['String']['output']>;
  /** The form’s GQL mutation name for submissions to use. */
  submissionMutationName?: Maybe<Scalars['String']['output']>;
  /** The form’s CSS for rendering. */
  templateCss?: Maybe<Scalars['String']['output']>;
  /** The form’s rendered HTML. */
  templateHtml?: Maybe<Scalars['String']['output']>;
  /** The form’s JS for rendering and functionality. */
  templateJs?: Maybe<Scalars['String']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type TestForm_Form_CountArgs = {
  field: Scalars['String']['input'];
};


export type TestForm_FormFormFieldsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TestForm_FormRowsArgs = {
  includeDisabled?: InputMaybe<Scalars['Boolean']['input']>;
};


export type TestForm_FormTemplateHtmlArgs = {
  options?: InputMaybe<Scalars['String']['input']>;
  populateFormValues?: InputMaybe<Scalars['String']['input']>;
};


export type TestForm_FormTemplateJsArgs = {
  initJs?: InputMaybe<Scalars['Boolean']['input']>;
  useObserver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TestForm_Submission = ElementInterface & SubmissionInterface & {
  __typename?: 'testForm_Submission';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  fullName?: Maybe<Scalars['String']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The submission’s IP Address. */
  ipAddress?: Maybe<Scalars['String']['output']>;
  /** Whether the submission is incomplete. */
  isIncomplete?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the submission is spam. */
  isSpam?: Maybe<Scalars['Boolean']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The submission’s spam type. */
  spamClass?: Maybe<Scalars['String']['output']>;
  /** The submission’s spam reason. */
  spamReason?: Maybe<Scalars['String']['output']>;
  /** The submission’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The submission’s status ID. */
  statusId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
};


export type TestForm_Submission_CountArgs = {
  field: Scalars['String']['input'];
};

export type TicketsCta_Asset_LinkType = HyperLinkInterface & {
  __typename?: 'ticketsCta_Asset_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type TicketsCta_Category_LinkType = HyperLinkInterface & {
  __typename?: 'ticketsCta_Category_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type TicketsCta_Custom_LinkType = HyperLinkInterface & {
  __typename?: 'ticketsCta_Custom_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type TicketsCta_Email_LinkType = HyperLinkInterface & {
  __typename?: 'ticketsCta_Email_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type TicketsCta_Embed_LinkType = HyperLinkInterface & {
  __typename?: 'ticketsCta_Embed_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type TicketsCta_Entry_LinkType = HyperLinkInterface & {
  __typename?: 'ticketsCta_Entry_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type TicketsCta_Phone_LinkType = HyperLinkInterface & {
  __typename?: 'ticketsCta_Phone_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type TicketsCta_Site_LinkType = HyperLinkInterface & {
  __typename?: 'ticketsCta_Site_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type TicketsCta_Url_LinkType = HyperLinkInterface & {
  __typename?: 'ticketsCta_Url_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type TicketsCta_User_LinkType = HyperLinkInterface & {
  __typename?: 'ticketsCta_User_LinkType';
  /** The `aria-label` attribute for the link. */
  ariaLabel?: Maybe<Scalars['String']['output']>;
  /** The `class` attribute for the link. */
  classes?: Maybe<Scalars['String']['output']>;
  /** The custom attributes for the link. */
  customAttributes?: Maybe<Scalars['Array']['output']>;
  /** The element (if provided) for the link. */
  element?: Maybe<ElementInterface>;
  /** Whether the chosen link value is an element. */
  isElement?: Maybe<Scalars['Boolean']['output']>;
  /** Whether a link has been set for the field. */
  isEmpty?: Maybe<Scalars['Boolean']['output']>;
  /** The HTML output for a `<a>` element. */
  link?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  linkText?: Maybe<Scalars['String']['output']>;
  /** The uri for the link (if an element-based link). */
  linkUri?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  linkUrl?: Maybe<Scalars['String']['output']>;
  /** The raw link data. */
  linkValue?: Maybe<Scalars['String']['output']>;
  /** Whether the link should open in a new window. */
  newWindow?: Maybe<Scalars['Boolean']['output']>;
  /** The `target` attribute for the link. */
  target?: Maybe<Scalars['String']['output']>;
  /** The text for the link. */
  text?: Maybe<Scalars['String']['output']>;
  /** The `title` attribute for the link. */
  title?: Maybe<Scalars['String']['output']>;
  /** The link type. */
  type?: Maybe<Scalars['String']['output']>;
  /** The url for the link. */
  url?: Maybe<Scalars['String']['output']>;
  /** The url prefix for the link. */
  urlPrefix?: Maybe<Scalars['String']['output']>;
  /** The url suffix for the link. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};

export type UtilitiesNav_Node = ElementInterface & NodeInterface & {
  __typename?: 'utilitiesNav_Node';
  /** Return a number of related elements for a field. */
  _count?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is archived. */
  archived?: Maybe<Scalars['Boolean']['output']>;
  /** The node’s children. Accepts the same arguments as the `nodes` query. */
  children?: Maybe<Array<Maybe<NodeInterface>>>;
  /** Any additional classes for the node. */
  classes?: Maybe<Scalars['String']['output']>;
  /** Any additional custom attributes for the node. */
  customAttributes?: Maybe<Array<Maybe<NodeCustomAttribute>>>;
  /** Any additional data for the node. */
  data?: Maybe<Scalars['String']['output']>;
  /** The date the element was created. */
  dateCreated?: Maybe<Scalars['DateTime']['output']>;
  /** The date the element was last updated. */
  dateUpdated?: Maybe<Scalars['DateTime']['output']>;
  /** The element the node links to. */
  element?: Maybe<ElementInterface>;
  /** The ID of the element this node is linked to. */
  elementId?: Maybe<Scalars['Int']['output']>;
  /** Whether the element is enabled. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** The ID of the entity */
  id?: Maybe<Scalars['ID']['output']>;
  /** The language of the site element is associated with. */
  language?: Maybe<Scalars['String']['output']>;
  /** The element’s level within its structure */
  level?: Maybe<Scalars['Int']['output']>;
  /** The element’s left position within its structure. */
  lft?: Maybe<Scalars['Int']['output']>;
  /** The handle of the navigation this node belongs to. */
  navHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the navigation this node belongs to. */
  navId?: Maybe<Scalars['Int']['output']>;
  /** The name of the navigation this node belongs to. */
  navName?: Maybe<Scalars['String']['output']>;
  /** Whether this node should open in a new window. */
  newWindow?: Maybe<Scalars['String']['output']>;
  /** The node’s URI */
  nodeUri?: Maybe<Scalars['String']['output']>;
  /** The node’s parent. */
  parent?: Maybe<NodeInterface>;
  /** The element’s right position within its structure. */
  rgt?: Maybe<Scalars['Int']['output']>;
  /** The element’s structure’s root ID */
  root?: Maybe<Scalars['Int']['output']>;
  /** The element’s search score, if the `search` parameter was used when querying for the element. */
  searchScore?: Maybe<Scalars['Int']['output']>;
  /** The handle of the site the element is associated with. */
  siteHandle?: Maybe<Scalars['String']['output']>;
  /** The ID of the site the element is associated with. */
  siteId?: Maybe<Scalars['Int']['output']>;
  /** The unique identifier for an element-site relation. */
  siteSettingsId?: Maybe<Scalars['ID']['output']>;
  /** The element’s slug. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The element’s status. */
  status?: Maybe<Scalars['String']['output']>;
  /** The element’s structure ID. */
  structureId?: Maybe<Scalars['Int']['output']>;
  /** The element’s title. */
  title?: Maybe<Scalars['String']['output']>;
  /** Whether the element has been soft-deleted. */
  trashed?: Maybe<Scalars['Boolean']['output']>;
  /** The type of node this is. */
  type?: Maybe<Scalars['String']['output']>;
  /** The display name for the type of node this is. */
  typeLabel?: Maybe<Scalars['String']['output']>;
  /** The UID of the entity */
  uid?: Maybe<Scalars['String']['output']>;
  /** The element’s URI. */
  uri?: Maybe<Scalars['String']['output']>;
  /** The node’s full URL */
  url?: Maybe<Scalars['String']['output']>;
  /** The URL for this navigation item. */
  urlSuffix?: Maybe<Scalars['String']['output']>;
};


export type UtilitiesNav_Node_CountArgs = {
  field: Scalars['String']['input'];
};


export type UtilitiesNav_NodeChildrenArgs = {
  ancestorDist?: InputMaybe<Scalars['Int']['input']>;
  ancestorOf?: InputMaybe<Scalars['Int']['input']>;
  dateCreated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dateUpdated?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  descendantDist?: InputMaybe<Scalars['Int']['input']>;
  descendantOf?: InputMaybe<Scalars['Int']['input']>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  hasDescendants?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  inReverse?: InputMaybe<Scalars['Boolean']['input']>;
  language?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  leaves?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  nav?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  navHandle?: InputMaybe<Scalars['String']['input']>;
  navId?: InputMaybe<Scalars['Int']['input']>;
  nextSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  notRelatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  positionedAfter?: InputMaybe<Scalars['Int']['input']>;
  positionedBefore?: InputMaybe<Scalars['Int']['input']>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  prevSiblingOf?: InputMaybe<Scalars['Int']['input']>;
  ref?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  relatedTo?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAll?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  relatedToAssets?: InputMaybe<Array<InputMaybe<AssetRelationCriteriaInput>>>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>>>;
  relatedToTags?: InputMaybe<Array<InputMaybe<TagRelationCriteriaInput>>>;
  relatedToUsers?: InputMaybe<Array<InputMaybe<UserRelationCriteriaInput>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  siteId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  siteSettingsId?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  structureId?: InputMaybe<Scalars['Int']['input']>;
  title?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withStructure?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LatestNewsQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestNewsQuery = { __typename?: 'Query', entries?: Array<{ __typename?: 'accordionItem_Entry', id?: string | null, title?: string | null, postDate?: any | null, uri?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, title?: string | null, postDate?: any | null, uri?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, title?: string | null, postDate?: any | null, uri?: string | null } | { __typename?: 'page_Entry', summary?: string | null, id?: string | null, title?: string | null, postDate?: any | null, uri?: string | null, featureImage: Array<(
      { __typename?: 'assets_Asset' }
      & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
    ) | (
      { __typename?: 'icons_Asset' }
      & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
    ) | null> } | { __typename?: 'profile_Entry', id?: string | null, title?: string | null, postDate?: any | null, uri?: string | null } | null> | null };

type ImageAsset_Assets_Asset_Fragment = { __typename?: 'assets_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, alt?: string | null, filename: string } & { ' $fragmentName'?: 'ImageAsset_Assets_Asset_Fragment' };

type ImageAsset_Icons_Asset_Fragment = { __typename?: 'icons_Asset', id?: string | null, url?: string | null, width?: number | null, height?: number | null, alt?: string | null, filename: string } & { ' $fragmentName'?: 'ImageAsset_Icons_Asset_Fragment' };

export type ImageAssetFragment = ImageAsset_Assets_Asset_Fragment | ImageAsset_Icons_Asset_Fragment;

type Blocks_Blocks_BlockAccordion_BlockType_Fragment = (
  { __typename: 'blocks_blockAccordion_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'AccordionBlockFragment': AccordionBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockAccordion_BlockType_Fragment' };

type Blocks_Blocks_BlockBlockquote_BlockType_Fragment = (
  { __typename: 'blocks_blockBlockquote_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'BlockquoteBlockFragment': BlockquoteBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockBlockquote_BlockType_Fragment' };

type Blocks_Blocks_BlockCta_BlockType_Fragment = (
  { __typename: 'blocks_blockCta_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'CtaBlockFragment': CtaBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockCta_BlockType_Fragment' };

type Blocks_Blocks_BlockDownloads_BlockType_Fragment = (
  { __typename: 'blocks_blockDownloads_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'DownloadsBlockFragment': DownloadsBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockDownloads_BlockType_Fragment' };

type Blocks_Blocks_BlockForm_BlockType_Fragment = (
  { __typename: 'blocks_blockForm_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'FormBlockFragment': FormBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockForm_BlockType_Fragment' };

type Blocks_Blocks_BlockImageAndText_BlockType_Fragment = (
  { __typename: 'blocks_blockImageAndText_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'ImageAndTextBlockFragment': ImageAndTextBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockImageAndText_BlockType_Fragment' };

type Blocks_Blocks_BlockImageCarousel_BlockType_Fragment = (
  { __typename: 'blocks_blockImageCarousel_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'ImageCarouselBlockFragment': ImageCarouselBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockImageCarousel_BlockType_Fragment' };

type Blocks_Blocks_BlockImage_BlockType_Fragment = (
  { __typename: 'blocks_blockImage_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'ImageBlockFragment': ImageBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockImage_BlockType_Fragment' };

type Blocks_Blocks_BlockInternalPageCards_BlockType_Fragment = (
  { __typename: 'blocks_blockInternalPageCards_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'InternalPageCardsBlockFragment': InternalPageCardsBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockInternalPageCards_BlockType_Fragment' };

type Blocks_Blocks_BlockLatestNews_BlockType_Fragment = (
  { __typename: 'blocks_blockLatestNews_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'LatestNewsBlockFragment': LatestNewsBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockLatestNews_BlockType_Fragment' };

type Blocks_Blocks_BlockMap_BlockType_Fragment = (
  { __typename: 'blocks_blockMap_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'MapBlockFragment': MapBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockMap_BlockType_Fragment' };

type Blocks_Blocks_BlockRichText_BlockType_Fragment = (
  { __typename: 'blocks_blockRichText_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'RichTextBlockFragment': RichTextBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockRichText_BlockType_Fragment' };

type Blocks_Blocks_BlockServices_BlockType_Fragment = (
  { __typename: 'blocks_blockServices_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'ServicesBlockFragment': ServicesBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockServices_BlockType_Fragment' };

type Blocks_Blocks_BlockVideo_BlockType_Fragment = (
  { __typename: 'blocks_blockVideo_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'VideoBlockFragment': VideoBlockFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_BlockVideo_BlockType_Fragment' };

type Blocks_Blocks_ProfileAccordionItem_BlockType_Fragment = { __typename: 'blocks_profileAccordionItem_BlockType', id?: string | null } & { ' $fragmentName'?: 'Blocks_Blocks_ProfileAccordionItem_BlockType_Fragment' };

type Blocks_Blocks_ProfileAccordion_BlockType_Fragment = (
  { __typename: 'blocks_profileAccordion_BlockType', id?: string | null }
  & { ' $fragmentRefs'?: { 'ProfileAccordionFragment': ProfileAccordionFragment } }
) & { ' $fragmentName'?: 'Blocks_Blocks_ProfileAccordion_BlockType_Fragment' };

export type BlocksFragment = Blocks_Blocks_BlockAccordion_BlockType_Fragment | Blocks_Blocks_BlockBlockquote_BlockType_Fragment | Blocks_Blocks_BlockCta_BlockType_Fragment | Blocks_Blocks_BlockDownloads_BlockType_Fragment | Blocks_Blocks_BlockForm_BlockType_Fragment | Blocks_Blocks_BlockImageAndText_BlockType_Fragment | Blocks_Blocks_BlockImageCarousel_BlockType_Fragment | Blocks_Blocks_BlockImage_BlockType_Fragment | Blocks_Blocks_BlockInternalPageCards_BlockType_Fragment | Blocks_Blocks_BlockLatestNews_BlockType_Fragment | Blocks_Blocks_BlockMap_BlockType_Fragment | Blocks_Blocks_BlockRichText_BlockType_Fragment | Blocks_Blocks_BlockServices_BlockType_Fragment | Blocks_Blocks_BlockVideo_BlockType_Fragment | Blocks_Blocks_ProfileAccordionItem_BlockType_Fragment | Blocks_Blocks_ProfileAccordion_BlockType_Fragment;

export type AccordionItemFragment = { __typename?: 'accordionItem_Entry', id?: string | null, title?: string | null, htmlContentDefault?: string | null } & { ' $fragmentName'?: 'AccordionItemFragment' };

export type AccordionBlockFragment = { __typename?: 'blocks_blockAccordion_BlockType', id?: string | null, heading?: string | null, accordionItems: Array<(
    { __typename?: 'accordionItem_Entry' }
    & { ' $fragmentRefs'?: { 'AccordionItemFragment': AccordionItemFragment } }
  ) | null> } & { ' $fragmentName'?: 'AccordionBlockFragment' };

export type BlockquoteBlockFragment = { __typename?: 'blocks_blockBlockquote_BlockType', id?: string | null, htmlContentSimple?: string | null } & { ' $fragmentName'?: 'BlockquoteBlockFragment' };

export type CtaBlockFragment = { __typename?: 'blocks_blockCta_BlockType', id?: string | null, heading?: string | null, htmlContentSimple?: string | null, linkSingle: Array<(
    { __typename?: 'entryLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'CtaBlockFragment' };

export type DownloadsBlockFragment = { __typename?: 'blocks_blockDownloads_BlockType', id?: string | null, heading?: string | null, linkAssetMultiple: Array<(
    { __typename?: 'entryLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'DownloadsBlockFragment' };

export type FormBlockFragment = { __typename?: 'blocks_blockForm_BlockType', heading?: string | null, htmlContentSimple?: string | null, form?: Array<{ __typename?: 'contactTest_Form', id?: string | null } | { __typename?: 'enquiryForm_Form', id?: string | null } | { __typename?: 'housingLink_Form', id?: string | null } | { __typename?: 'testForm_Form', id?: string | null } | null> | null } & { ' $fragmentName'?: 'FormBlockFragment' };

export type ImageAndTextBlockFragment = { __typename?: 'blocks_blockImageAndText_BlockType', id?: string | null, heading?: string | null, htmlContentSimple?: string | null, imageAlignment?: string | null, linkSingle: Array<(
    { __typename?: 'entryLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
  ) | null>, image: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'ImageAndTextBlockFragment' };

export type ImageBlockFragment = { __typename?: 'blocks_blockImage_BlockType', id?: string | null, caption?: string | null, image: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'ImageBlockFragment' };

export type ImageCarouselBlockFragment = { __typename?: 'blocks_blockImageCarousel_BlockType', id?: string | null, heading?: string | null, caption?: string | null, images: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'ImageCarouselBlockFragment' };

export type InternalPageCardsBlockFragment = { __typename?: 'blocks_blockInternalPageCards_BlockType', id?: string | null, heading?: string | null, entryMultiple: Array<{ __typename?: 'accordionItem_Entry' } | { __typename?: 'blockHomeHeroBanner_Entry' } | { __typename?: 'linkedImage_Entry' } | (
    { __typename?: 'page_Entry' }
    & { ' $fragmentRefs'?: { 'PageCardFragment': PageCardFragment } }
  ) | { __typename?: 'profile_Entry' } | null> } & { ' $fragmentName'?: 'InternalPageCardsBlockFragment' };

export type LatestNewsBlockFragment = { __typename?: 'blocks_blockLatestNews_BlockType', id?: string | null, heading?: string | null, entryLinkSingle: Array<(
    { __typename?: 'entryLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'LatestNewsBlockFragment' };

export type MapBlockFragment = { __typename?: 'blocks_blockMap_BlockType', id?: string | null, heading?: string | null, showPreciseAddress?: boolean | null, htmlContentSimple?: string | null, address?: (
    { __typename?: 'GoogleMaps_Address' }
    & { ' $fragmentRefs'?: { 'MapAddressFragment': MapAddressFragment } }
  ) | null } & { ' $fragmentName'?: 'MapBlockFragment' };

export type ProfileAccordionItemFragment = { __typename?: 'blocks_profileAccordionItem_BlockType', id?: string | null, heading?: string | null, profileMultiple: Array<{ __typename?: 'accordionItem_Entry' } | { __typename?: 'blockHomeHeroBanner_Entry' } | { __typename?: 'linkedImage_Entry' } | { __typename?: 'page_Entry' } | (
    { __typename?: 'profile_Entry' }
    & { ' $fragmentRefs'?: { 'ProfileEntryFragment': ProfileEntryFragment } }
  ) | null> } & { ' $fragmentName'?: 'ProfileAccordionItemFragment' };

export type ProfileAccordionFragment = { __typename?: 'blocks_profileAccordion_BlockType', id?: string | null, children?: Array<{ __typename?: 'blocks_blockAccordion_BlockType' } | { __typename?: 'blocks_blockBlockquote_BlockType' } | { __typename?: 'blocks_blockCta_BlockType' } | { __typename?: 'blocks_blockDownloads_BlockType' } | { __typename?: 'blocks_blockForm_BlockType' } | { __typename?: 'blocks_blockImageAndText_BlockType' } | { __typename?: 'blocks_blockImageCarousel_BlockType' } | { __typename?: 'blocks_blockImage_BlockType' } | { __typename?: 'blocks_blockInternalPageCards_BlockType' } | { __typename?: 'blocks_blockLatestNews_BlockType' } | { __typename?: 'blocks_blockMap_BlockType' } | { __typename?: 'blocks_blockRichText_BlockType' } | { __typename?: 'blocks_blockServices_BlockType' } | { __typename?: 'blocks_blockVideo_BlockType' } | (
    { __typename?: 'blocks_profileAccordionItem_BlockType' }
    & { ' $fragmentRefs'?: { 'ProfileAccordionItemFragment': ProfileAccordionItemFragment } }
  ) | { __typename?: 'blocks_profileAccordion_BlockType' } | null> | null } & { ' $fragmentName'?: 'ProfileAccordionFragment' };

export type RichTextBlockFragment = { __typename?: 'blocks_blockRichText_BlockType', id?: string | null, heading?: string | null, htmlContentDefault?: string | null, linkSingle: Array<(
    { __typename?: 'entryLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'RichTextBlockFragment' };

export type ServicesBlockFragment = { __typename?: 'blocks_blockServices_BlockType', id?: string | null, heading?: string | null, entryLinkSingle: Array<(
    { __typename?: 'entryLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
  ) | null>, serviceMultiple: Array<{ __typename?: 'accordionItem_Entry' } | { __typename?: 'blockHomeHeroBanner_Entry' } | { __typename?: 'linkedImage_Entry' } | (
    { __typename?: 'page_Entry' }
    & { ' $fragmentRefs'?: { 'ServiceCardFragment': ServiceCardFragment } }
  ) | { __typename?: 'profile_Entry' } | null> } & { ' $fragmentName'?: 'ServicesBlockFragment' };

export type VideoBlockFragment = { __typename?: 'blocks_blockVideo_BlockType', id?: string | null, videoUrl?: string | null, caption?: string | null } & { ' $fragmentName'?: 'VideoBlockFragment' };

export type ArticleCardFragment = { __typename: 'page_Entry', id?: string | null, title?: string | null, uri?: string | null, summary?: string | null, postDate?: any | null, startDate?: any | null, sectionHandle?: string | null, featureImage: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null>, articleCategoryMultiple: Array<(
    { __typename?: 'accommodationType_Category' }
    & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
  ) | (
    { __typename?: 'articleCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
  ) | (
    { __typename?: 'profileGroup_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
  ) | (
    { __typename?: 'profileRole_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
  ) | (
    { __typename?: 'propertyCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
  ) | (
    { __typename?: 'propertyType_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
  ) | (
    { __typename?: 'serviceCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'ArticleCardFragment' };

export type EventCardFragment = { __typename: 'page_Entry', id?: string | null, title?: string | null, url?: string | null, summary?: string | null, startDate?: any | null, sectionHandle?: string | null, featureImage: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'EventCardFragment' };

export type PageCardFragment = { __typename: 'page_Entry', id?: string | null, title?: string | null, url?: string | null, summary?: string | null, sectionHandle?: string | null, featureImage: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'PageCardFragment' };

export type ServiceCardFragment = { __typename: 'page_Entry', id?: string | null, title?: string | null, summary?: string | null, url?: string | null, uri?: string | null, iconAsset: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null>, serviceCategoryMultiple: Array<(
    { __typename?: 'accommodationType_Category' }
    & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
  ) | (
    { __typename?: 'articleCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
  ) | (
    { __typename?: 'profileGroup_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
  ) | (
    { __typename?: 'profileRole_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
  ) | (
    { __typename?: 'propertyCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
  ) | (
    { __typename?: 'propertyType_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
  ) | (
    { __typename?: 'serviceCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'ServiceCardFragment' };

export type HomeHeroBannerFragment = { __typename?: 'blockHomeHeroBanner_Entry', heroHeading?: string | null, summary?: string | null, quickLinksLabel?: string | null, linkSingle: Array<(
    { __typename?: 'entryLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
  ) | null>, images: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null>, entryLinkMultiple: Array<(
    { __typename?: 'entryLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'HomeHeroBannerFragment' };

export type LatestArticlesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type LatestArticlesQuery = { __typename?: 'Query', articleEntries?: Array<(
    { __typename?: 'page_Entry' }
    & { ' $fragmentRefs'?: { 'ArticleCardFragment': ArticleCardFragment } }
  ) | null> | null };

export type LatestArticlesWithCategoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>> | InputMaybe<Scalars['QueryArgument']['input']>>;
}>;


export type LatestArticlesWithCategoryQuery = { __typename?: 'Query', articleEntries?: Array<(
    { __typename?: 'page_Entry' }
    & { ' $fragmentRefs'?: { 'ArticleCardFragment': ArticleCardFragment } }
  ) | null> | null };

export type SearchEntriesQueryVariables = Exact<{
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>> | InputMaybe<Scalars['QueryArgument']['input']>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  addressNear?: InputMaybe<GoogleMaps_Near>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  search?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  relatedToCategories?: InputMaybe<Array<InputMaybe<CategoryRelationCriteriaInput>> | InputMaybe<CategoryRelationCriteriaInput>>;
  relatedToEntries?: InputMaybe<Array<InputMaybe<EntryRelationCriteriaInput>> | InputMaybe<EntryRelationCriteriaInput>>;
  fixedOrder?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>> | InputMaybe<Scalars['QueryArgument']['input']>>;
}>;


export type SearchEntriesQuery = { __typename?: 'Query', entryCount: number, entries?: Array<{ __typename?: 'accordionItem_Entry' } | { __typename?: 'blockHomeHeroBanner_Entry' } | { __typename?: 'linkedImage_Entry' } | (
    { __typename?: 'page_Entry' }
    & { ' $fragmentRefs'?: { 'PropertyCardFragment': PropertyCardFragment;'LocationCardFragment': LocationCardFragment;'ArticleCardFragment': ArticleCardFragment;'EventCardFragment': EventCardFragment;'ServiceCardFragment': ServiceCardFragment } }
  ) | { __typename?: 'profile_Entry' } | null> | null };

export type RelatedServiceFragment = { __typename?: 'page_Entry', id?: string | null, title?: string | null, uri?: string | null } & { ' $fragmentName'?: 'RelatedServiceFragment' };

export type LocationCardFragment = { __typename: 'page_Entry', id?: string | null, uri?: string | null, summary?: string | null, title?: string | null, address?: { __typename?: 'GoogleMaps_Address', formatted?: string | null, lat?: number | null, lng?: number | null } | null, featureImage: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null>, serviceMultiple: Array<{ __typename?: 'accordionItem_Entry' } | { __typename?: 'blockHomeHeroBanner_Entry' } | { __typename?: 'linkedImage_Entry' } | (
    { __typename?: 'page_Entry' }
    & { ' $fragmentRefs'?: { 'RelatedServiceFragment': RelatedServiceFragment } }
  ) | { __typename?: 'profile_Entry' } | null> } & { ' $fragmentName'?: 'LocationCardFragment' };

export type LatestPropertyQueryVariables = Exact<{ [key: string]: never; }>;


export type LatestPropertyQuery = { __typename?: 'Query', entries?: Array<{ __typename?: 'accordionItem_Entry', id?: string | null, title?: string | null, postDate?: any | null, uri?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, title?: string | null, postDate?: any | null, uri?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, title?: string | null, postDate?: any | null, uri?: string | null } | { __typename?: 'page_Entry', summary?: string | null, nBeds?: any | null, nBathrooms?: any | null, id?: string | null, title?: string | null, postDate?: any | null, uri?: string | null, featureImage: Array<(
      { __typename?: 'assets_Asset' }
      & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
    ) | (
      { __typename?: 'icons_Asset' }
      & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
    ) | null>, address?: { __typename?: 'GoogleMaps_Address', formatted?: string | null, state?: string | null, city?: string | null } | null } | { __typename?: 'profile_Entry', id?: string | null, title?: string | null, postDate?: any | null, uri?: string | null } | null> | null };

export type AccommodationTypeCategoryFragment = { __typename?: 'accommodationType_Category', id?: string | null, title?: string | null, uri?: string | null } & { ' $fragmentName'?: 'AccommodationTypeCategoryFragment' };

export type PropertyCardFragment = { __typename: 'page_Entry', id?: string | null, nBeds?: any | null, nBathrooms?: any | null, uri?: string | null, summary?: string | null, title?: string | null, propertyTypeMultiple: Array<(
    { __typename?: 'accommodationType_Category' }
    & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
  ) | (
    { __typename?: 'articleCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
  ) | (
    { __typename?: 'profileGroup_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
  ) | (
    { __typename?: 'profileRole_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
  ) | (
    { __typename?: 'propertyCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
  ) | (
    { __typename?: 'propertyType_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
  ) | (
    { __typename?: 'serviceCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
  ) | null>, address?: { __typename?: 'GoogleMaps_Address', formatted?: string | null, state?: string | null, city?: string | null } | null, featureImage: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null> } & { ' $fragmentName'?: 'PropertyCardFragment' };

export type SearchResultsFragment = { __typename?: 'page_Entry', id?: string | null, title?: string | null, uri?: string | null, summary?: string | null } & { ' $fragmentName'?: 'SearchResultsFragment' };

export type FieldAddressFragment = (
  { __typename: 'Field_Address', nestedRows?: Array<(
    { __typename: 'RowType' }
    & { ' $fragmentRefs'?: { 'FormieNestedRowFragment': FormieNestedRowFragment } }
  ) | null> | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Address_Fragment': FieldBase_Field_Address_Fragment } }
) & { ' $fragmentName'?: 'FieldAddressFragment' };

export type FieldAddressCountryFragment = (
  { __typename: 'Field_AddressCountry', options?: Array<(
    { __typename?: 'FieldOption' }
    & { ' $fragmentRefs'?: { 'FieldOptionFragment': FieldOptionFragment } }
  ) | null> | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressCountry_Fragment': FieldBase_Field_AddressCountry_Fragment } }
) & { ' $fragmentName'?: 'FieldAddressCountryFragment' };

export type FieldAgreeFragment = (
  { __typename: 'Field_Agree', uncheckedValue?: string | null, checkedValue?: string | null, descriptionHtml?: string | null, defaultState?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Agree_Fragment': FieldBase_Field_Agree_Fragment } }
) & { ' $fragmentName'?: 'FieldAgreeFragment' };

export type FieldCheckboxesFragment = (
  { __typename: 'Field_Checkboxes', multi?: boolean | null, layout?: string | null, options?: Array<(
    { __typename?: 'FieldOption' }
    & { ' $fragmentRefs'?: { 'FieldOptionFragment': FieldOptionFragment } }
  ) | null> | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Checkboxes_Fragment': FieldBase_Field_Checkboxes_Fragment } }
) & { ' $fragmentName'?: 'FieldCheckboxesFragment' };

export type FieldDateFragment = (
  { __typename: 'Field_Date', defaultDate?: any | null, fields?: Array<(
    { __typename?: 'Field_Address' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Address_Fragment': FieldBase_Field_Address_Fragment } }
  ) | (
    { __typename?: 'Field_Address1' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Address1_Fragment': FieldBase_Field_Address1_Fragment } }
  ) | (
    { __typename?: 'Field_Address2' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Address2_Fragment': FieldBase_Field_Address2_Fragment } }
  ) | (
    { __typename?: 'Field_Address3' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Address3_Fragment': FieldBase_Field_Address3_Fragment } }
  ) | (
    { __typename?: 'Field_AddressAutoComplete' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressAutoComplete_Fragment': FieldBase_Field_AddressAutoComplete_Fragment } }
  ) | (
    { __typename?: 'Field_AddressCity' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressCity_Fragment': FieldBase_Field_AddressCity_Fragment } }
  ) | (
    { __typename?: 'Field_AddressCountry' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressCountry_Fragment': FieldBase_Field_AddressCountry_Fragment } }
  ) | (
    { __typename?: 'Field_AddressState' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressState_Fragment': FieldBase_Field_AddressState_Fragment } }
  ) | (
    { __typename?: 'Field_AddressZip' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressZip_Fragment': FieldBase_Field_AddressZip_Fragment } }
  ) | (
    { __typename?: 'Field_Agree' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Agree_Fragment': FieldBase_Field_Agree_Fragment } }
  ) | (
    { __typename?: 'Field_Calculations' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Calculations_Fragment': FieldBase_Field_Calculations_Fragment } }
  ) | (
    { __typename?: 'Field_Categories' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Categories_Fragment': FieldBase_Field_Categories_Fragment } }
  ) | (
    { __typename?: 'Field_Checkboxes' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Checkboxes_Fragment': FieldBase_Field_Checkboxes_Fragment } }
  ) | (
    { __typename?: 'Field_Date' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Date_Fragment': FieldBase_Field_Date_Fragment } }
  ) | (
    { __typename?: 'Field_DateAmPmDropdown' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateAmPmDropdown_Fragment': FieldBase_Field_DateAmPmDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateAmPmNumber' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateAmPmNumber_Fragment': FieldBase_Field_DateAmPmNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateDayDropdown' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateDayDropdown_Fragment': FieldBase_Field_DateDayDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateDayNumber' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateDayNumber_Fragment': FieldBase_Field_DateDayNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateHourDropdown' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateHourDropdown_Fragment': FieldBase_Field_DateHourDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateHourNumber' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateHourNumber_Fragment': FieldBase_Field_DateHourNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateMinuteDropdown' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMinuteDropdown_Fragment': FieldBase_Field_DateMinuteDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateMinuteNumber' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMinuteNumber_Fragment': FieldBase_Field_DateMinuteNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateMonthDropdown' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMonthDropdown_Fragment': FieldBase_Field_DateMonthDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateMonthNumber' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMonthNumber_Fragment': FieldBase_Field_DateMonthNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateSecondDropdown' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateSecondDropdown_Fragment': FieldBase_Field_DateSecondDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateSecondNumber' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateSecondNumber_Fragment': FieldBase_Field_DateSecondNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateYearDropdown' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateYearDropdown_Fragment': FieldBase_Field_DateYearDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateYearNumber' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateYearNumber_Fragment': FieldBase_Field_DateYearNumber_Fragment } }
  ) | (
    { __typename?: 'Field_Dropdown' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Dropdown_Fragment': FieldBase_Field_Dropdown_Fragment } }
  ) | (
    { __typename?: 'Field_Email' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Email_Fragment': FieldBase_Field_Email_Fragment } }
  ) | (
    { __typename?: 'Field_Entries' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Entries_Fragment': FieldBase_Field_Entries_Fragment } }
  ) | (
    { __typename?: 'Field_FileUpload' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_FileUpload_Fragment': FieldBase_Field_FileUpload_Fragment } }
  ) | (
    { __typename?: 'Field_Group' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Group_Fragment': FieldBase_Field_Group_Fragment } }
  ) | (
    { __typename?: 'Field_Heading' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Heading_Fragment': FieldBase_Field_Heading_Fragment } }
  ) | (
    { __typename?: 'Field_Hidden' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Hidden_Fragment': FieldBase_Field_Hidden_Fragment } }
  ) | (
    { __typename?: 'Field_Html' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Html_Fragment': FieldBase_Field_Html_Fragment } }
  ) | (
    { __typename?: 'Field_MultiLineText' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_MultiLineText_Fragment': FieldBase_Field_MultiLineText_Fragment } }
  ) | (
    { __typename?: 'Field_Name' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Name_Fragment': FieldBase_Field_Name_Fragment } }
  ) | (
    { __typename?: 'Field_NameFirst' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_NameFirst_Fragment': FieldBase_Field_NameFirst_Fragment } }
  ) | (
    { __typename?: 'Field_NameLast' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_NameLast_Fragment': FieldBase_Field_NameLast_Fragment } }
  ) | (
    { __typename?: 'Field_NameMiddle' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_NameMiddle_Fragment': FieldBase_Field_NameMiddle_Fragment } }
  ) | (
    { __typename?: 'Field_NamePrefix' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_NamePrefix_Fragment': FieldBase_Field_NamePrefix_Fragment } }
  ) | (
    { __typename?: 'Field_Number' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Number_Fragment': FieldBase_Field_Number_Fragment } }
  ) | (
    { __typename?: 'Field_Password' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Password_Fragment': FieldBase_Field_Password_Fragment } }
  ) | (
    { __typename?: 'Field_Payment' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Payment_Fragment': FieldBase_Field_Payment_Fragment } }
  ) | (
    { __typename?: 'Field_Phone' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Phone_Fragment': FieldBase_Field_Phone_Fragment } }
  ) | (
    { __typename?: 'Field_Radio' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Radio_Fragment': FieldBase_Field_Radio_Fragment } }
  ) | (
    { __typename?: 'Field_Recipients' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Recipients_Fragment': FieldBase_Field_Recipients_Fragment } }
  ) | (
    { __typename?: 'Field_Repeater' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Repeater_Fragment': FieldBase_Field_Repeater_Fragment } }
  ) | (
    { __typename?: 'Field_Section' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Section_Fragment': FieldBase_Field_Section_Fragment } }
  ) | (
    { __typename?: 'Field_Signature' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Signature_Fragment': FieldBase_Field_Signature_Fragment } }
  ) | (
    { __typename?: 'Field_SingleLineText' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_SingleLineText_Fragment': FieldBase_Field_SingleLineText_Fragment } }
  ) | (
    { __typename?: 'Field_Summary' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Summary_Fragment': FieldBase_Field_Summary_Fragment } }
  ) | (
    { __typename?: 'Field_Table' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Table_Fragment': FieldBase_Field_Table_Fragment } }
  ) | (
    { __typename?: 'Field_Tags' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Tags_Fragment': FieldBase_Field_Tags_Fragment } }
  ) | (
    { __typename?: 'Field_Users' }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Users_Fragment': FieldBase_Field_Users_Fragment } }
  ) | null> | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Date_Fragment': FieldBase_Field_Date_Fragment } }
) & { ' $fragmentName'?: 'FieldDateFragment' };

export type FieldDropdownFragment = (
  { __typename: 'Field_Dropdown', multi?: boolean | null, options?: Array<(
    { __typename?: 'FieldOption' }
    & { ' $fragmentRefs'?: { 'FieldOptionFragment': FieldOptionFragment } }
  ) | null> | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Dropdown_Fragment': FieldBase_Field_Dropdown_Fragment } }
) & { ' $fragmentName'?: 'FieldDropdownFragment' };

export type FieldFileUploadFragment = (
  { __typename: 'Field_FileUpload', allowedKinds?: Array<string | null> | null, limitFiles?: string | null, sizeLimit?: string | null, sizeMinLimit?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_FileUpload_Fragment': FieldBase_Field_FileUpload_Fragment } }
) & { ' $fragmentName'?: 'FieldFileUploadFragment' };

export type FieldHeadingFragment = (
  { __typename: 'Field_Heading' }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Heading_Fragment': FieldBase_Field_Heading_Fragment } }
) & { ' $fragmentName'?: 'FieldHeadingFragment' };

export type FieldNameFragment = (
  { __typename: 'Field_Name', useMultipleFields?: boolean | null, nestedRows?: Array<(
    { __typename?: 'RowType' }
    & { ' $fragmentRefs'?: { 'FormieNestedRowFragment': FormieNestedRowFragment } }
  ) | null> | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Name_Fragment': FieldBase_Field_Name_Fragment } }
) & { ' $fragmentName'?: 'FieldNameFragment' };

export type FieldNamePrefixFragment = (
  { __typename: 'Field_NamePrefix', options?: Array<(
    { __typename?: 'FieldOption' }
    & { ' $fragmentRefs'?: { 'FieldOptionFragment': FieldOptionFragment } }
  ) | null> | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_NamePrefix_Fragment': FieldBase_Field_NamePrefix_Fragment } }
) & { ' $fragmentName'?: 'FieldNamePrefixFragment' };

export type FieldPaymentFragment = (
  { __typename: 'Field_Payment', paymentIntegration?: string | null, paymentIntegrationType?: string | null, providerSettings?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Payment_Fragment': FieldBase_Field_Payment_Fragment } }
) & { ' $fragmentName'?: 'FieldPaymentFragment' };

export type FieldRadioFragment = (
  { __typename: 'Field_Radio', layout?: string | null, options?: Array<(
    { __typename?: 'FieldOption' }
    & { ' $fragmentRefs'?: { 'FieldOptionFragment': FieldOptionFragment } }
  ) | null> | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Radio_Fragment': FieldBase_Field_Radio_Fragment } }
) & { ' $fragmentName'?: 'FieldRadioFragment' };

export type FieldSectionFragment = (
  { __typename: 'Field_Section' }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Section_Fragment': FieldBase_Field_Section_Fragment } }
) & { ' $fragmentName'?: 'FieldSectionFragment' };

export type FormieRowFragment = { __typename: 'RowType', id?: string | null, rowFields?: Array<(
    { __typename?: 'Field_Address' }
    & { ' $fragmentRefs'?: { 'Field_Field_Address_Fragment': Field_Field_Address_Fragment } }
  ) | (
    { __typename?: 'Field_Address1' }
    & { ' $fragmentRefs'?: { 'Field_Field_Address1_Fragment': Field_Field_Address1_Fragment } }
  ) | (
    { __typename?: 'Field_Address2' }
    & { ' $fragmentRefs'?: { 'Field_Field_Address2_Fragment': Field_Field_Address2_Fragment } }
  ) | (
    { __typename?: 'Field_Address3' }
    & { ' $fragmentRefs'?: { 'Field_Field_Address3_Fragment': Field_Field_Address3_Fragment } }
  ) | (
    { __typename?: 'Field_AddressAutoComplete' }
    & { ' $fragmentRefs'?: { 'Field_Field_AddressAutoComplete_Fragment': Field_Field_AddressAutoComplete_Fragment } }
  ) | (
    { __typename?: 'Field_AddressCity' }
    & { ' $fragmentRefs'?: { 'Field_Field_AddressCity_Fragment': Field_Field_AddressCity_Fragment } }
  ) | (
    { __typename?: 'Field_AddressCountry' }
    & { ' $fragmentRefs'?: { 'Field_Field_AddressCountry_Fragment': Field_Field_AddressCountry_Fragment } }
  ) | (
    { __typename?: 'Field_AddressState' }
    & { ' $fragmentRefs'?: { 'Field_Field_AddressState_Fragment': Field_Field_AddressState_Fragment } }
  ) | (
    { __typename?: 'Field_AddressZip' }
    & { ' $fragmentRefs'?: { 'Field_Field_AddressZip_Fragment': Field_Field_AddressZip_Fragment } }
  ) | (
    { __typename?: 'Field_Agree' }
    & { ' $fragmentRefs'?: { 'Field_Field_Agree_Fragment': Field_Field_Agree_Fragment } }
  ) | (
    { __typename?: 'Field_Calculations' }
    & { ' $fragmentRefs'?: { 'Field_Field_Calculations_Fragment': Field_Field_Calculations_Fragment } }
  ) | (
    { __typename?: 'Field_Categories' }
    & { ' $fragmentRefs'?: { 'Field_Field_Categories_Fragment': Field_Field_Categories_Fragment } }
  ) | (
    { __typename?: 'Field_Checkboxes' }
    & { ' $fragmentRefs'?: { 'Field_Field_Checkboxes_Fragment': Field_Field_Checkboxes_Fragment } }
  ) | (
    { __typename?: 'Field_Date' }
    & { ' $fragmentRefs'?: { 'Field_Field_Date_Fragment': Field_Field_Date_Fragment } }
  ) | (
    { __typename?: 'Field_DateAmPmDropdown' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateAmPmDropdown_Fragment': Field_Field_DateAmPmDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateAmPmNumber' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateAmPmNumber_Fragment': Field_Field_DateAmPmNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateDayDropdown' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateDayDropdown_Fragment': Field_Field_DateDayDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateDayNumber' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateDayNumber_Fragment': Field_Field_DateDayNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateHourDropdown' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateHourDropdown_Fragment': Field_Field_DateHourDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateHourNumber' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateHourNumber_Fragment': Field_Field_DateHourNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateMinuteDropdown' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateMinuteDropdown_Fragment': Field_Field_DateMinuteDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateMinuteNumber' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateMinuteNumber_Fragment': Field_Field_DateMinuteNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateMonthDropdown' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateMonthDropdown_Fragment': Field_Field_DateMonthDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateMonthNumber' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateMonthNumber_Fragment': Field_Field_DateMonthNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateSecondDropdown' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateSecondDropdown_Fragment': Field_Field_DateSecondDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateSecondNumber' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateSecondNumber_Fragment': Field_Field_DateSecondNumber_Fragment } }
  ) | (
    { __typename?: 'Field_DateYearDropdown' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateYearDropdown_Fragment': Field_Field_DateYearDropdown_Fragment } }
  ) | (
    { __typename?: 'Field_DateYearNumber' }
    & { ' $fragmentRefs'?: { 'Field_Field_DateYearNumber_Fragment': Field_Field_DateYearNumber_Fragment } }
  ) | (
    { __typename?: 'Field_Dropdown' }
    & { ' $fragmentRefs'?: { 'Field_Field_Dropdown_Fragment': Field_Field_Dropdown_Fragment } }
  ) | (
    { __typename?: 'Field_Email' }
    & { ' $fragmentRefs'?: { 'Field_Field_Email_Fragment': Field_Field_Email_Fragment } }
  ) | (
    { __typename?: 'Field_Entries' }
    & { ' $fragmentRefs'?: { 'Field_Field_Entries_Fragment': Field_Field_Entries_Fragment } }
  ) | (
    { __typename?: 'Field_FileUpload' }
    & { ' $fragmentRefs'?: { 'Field_Field_FileUpload_Fragment': Field_Field_FileUpload_Fragment } }
  ) | (
    { __typename?: 'Field_Group' }
    & { ' $fragmentRefs'?: { 'Field_Field_Group_Fragment': Field_Field_Group_Fragment } }
  ) | (
    { __typename?: 'Field_Heading' }
    & { ' $fragmentRefs'?: { 'Field_Field_Heading_Fragment': Field_Field_Heading_Fragment } }
  ) | (
    { __typename?: 'Field_Hidden' }
    & { ' $fragmentRefs'?: { 'Field_Field_Hidden_Fragment': Field_Field_Hidden_Fragment } }
  ) | (
    { __typename?: 'Field_Html' }
    & { ' $fragmentRefs'?: { 'Field_Field_Html_Fragment': Field_Field_Html_Fragment } }
  ) | (
    { __typename?: 'Field_MultiLineText' }
    & { ' $fragmentRefs'?: { 'Field_Field_MultiLineText_Fragment': Field_Field_MultiLineText_Fragment } }
  ) | (
    { __typename?: 'Field_Name' }
    & { ' $fragmentRefs'?: { 'Field_Field_Name_Fragment': Field_Field_Name_Fragment } }
  ) | (
    { __typename?: 'Field_NameFirst' }
    & { ' $fragmentRefs'?: { 'Field_Field_NameFirst_Fragment': Field_Field_NameFirst_Fragment } }
  ) | (
    { __typename?: 'Field_NameLast' }
    & { ' $fragmentRefs'?: { 'Field_Field_NameLast_Fragment': Field_Field_NameLast_Fragment } }
  ) | (
    { __typename?: 'Field_NameMiddle' }
    & { ' $fragmentRefs'?: { 'Field_Field_NameMiddle_Fragment': Field_Field_NameMiddle_Fragment } }
  ) | (
    { __typename?: 'Field_NamePrefix' }
    & { ' $fragmentRefs'?: { 'Field_Field_NamePrefix_Fragment': Field_Field_NamePrefix_Fragment } }
  ) | (
    { __typename?: 'Field_Number' }
    & { ' $fragmentRefs'?: { 'Field_Field_Number_Fragment': Field_Field_Number_Fragment } }
  ) | (
    { __typename?: 'Field_Password' }
    & { ' $fragmentRefs'?: { 'Field_Field_Password_Fragment': Field_Field_Password_Fragment } }
  ) | (
    { __typename?: 'Field_Payment' }
    & { ' $fragmentRefs'?: { 'Field_Field_Payment_Fragment': Field_Field_Payment_Fragment } }
  ) | (
    { __typename?: 'Field_Phone' }
    & { ' $fragmentRefs'?: { 'Field_Field_Phone_Fragment': Field_Field_Phone_Fragment } }
  ) | (
    { __typename?: 'Field_Radio' }
    & { ' $fragmentRefs'?: { 'Field_Field_Radio_Fragment': Field_Field_Radio_Fragment } }
  ) | (
    { __typename?: 'Field_Recipients' }
    & { ' $fragmentRefs'?: { 'Field_Field_Recipients_Fragment': Field_Field_Recipients_Fragment } }
  ) | (
    { __typename?: 'Field_Repeater' }
    & { ' $fragmentRefs'?: { 'Field_Field_Repeater_Fragment': Field_Field_Repeater_Fragment } }
  ) | (
    { __typename?: 'Field_Section' }
    & { ' $fragmentRefs'?: { 'Field_Field_Section_Fragment': Field_Field_Section_Fragment } }
  ) | (
    { __typename?: 'Field_Signature' }
    & { ' $fragmentRefs'?: { 'Field_Field_Signature_Fragment': Field_Field_Signature_Fragment } }
  ) | (
    { __typename?: 'Field_SingleLineText' }
    & { ' $fragmentRefs'?: { 'Field_Field_SingleLineText_Fragment': Field_Field_SingleLineText_Fragment } }
  ) | (
    { __typename?: 'Field_Summary' }
    & { ' $fragmentRefs'?: { 'Field_Field_Summary_Fragment': Field_Field_Summary_Fragment } }
  ) | (
    { __typename?: 'Field_Table' }
    & { ' $fragmentRefs'?: { 'Field_Field_Table_Fragment': Field_Field_Table_Fragment } }
  ) | (
    { __typename?: 'Field_Tags' }
    & { ' $fragmentRefs'?: { 'Field_Field_Tags_Fragment': Field_Field_Tags_Fragment } }
  ) | (
    { __typename?: 'Field_Users' }
    & { ' $fragmentRefs'?: { 'Field_Field_Users_Fragment': Field_Field_Users_Fragment } }
  ) | null> | null } & { ' $fragmentName'?: 'FormieRowFragment' };

export type FormieCaptchaFragment = { __typename: 'FormieCaptchaType', handle?: string | null, name?: string | null, value?: string | null } & { ' $fragmentName'?: 'FormieCaptchaFragment' };

type FieldBase_Field_Address_Fragment = { __typename: 'Field_Address', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Address_Fragment' };

type FieldBase_Field_Address1_Fragment = { __typename: 'Field_Address1', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Address1_Fragment' };

type FieldBase_Field_Address2_Fragment = { __typename: 'Field_Address2', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Address2_Fragment' };

type FieldBase_Field_Address3_Fragment = { __typename: 'Field_Address3', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Address3_Fragment' };

type FieldBase_Field_AddressAutoComplete_Fragment = { __typename: 'Field_AddressAutoComplete', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_AddressAutoComplete_Fragment' };

type FieldBase_Field_AddressCity_Fragment = { __typename: 'Field_AddressCity', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_AddressCity_Fragment' };

type FieldBase_Field_AddressCountry_Fragment = { __typename: 'Field_AddressCountry', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_AddressCountry_Fragment' };

type FieldBase_Field_AddressState_Fragment = { __typename: 'Field_AddressState', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_AddressState_Fragment' };

type FieldBase_Field_AddressZip_Fragment = { __typename: 'Field_AddressZip', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_AddressZip_Fragment' };

type FieldBase_Field_Agree_Fragment = { __typename: 'Field_Agree', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Agree_Fragment' };

type FieldBase_Field_Calculations_Fragment = { __typename: 'Field_Calculations', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Calculations_Fragment' };

type FieldBase_Field_Categories_Fragment = { __typename: 'Field_Categories', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Categories_Fragment' };

type FieldBase_Field_Checkboxes_Fragment = { __typename: 'Field_Checkboxes', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Checkboxes_Fragment' };

type FieldBase_Field_Date_Fragment = { __typename: 'Field_Date', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Date_Fragment' };

type FieldBase_Field_DateAmPmDropdown_Fragment = { __typename: 'Field_DateAmPmDropdown', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateAmPmDropdown_Fragment' };

type FieldBase_Field_DateAmPmNumber_Fragment = { __typename: 'Field_DateAmPmNumber', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateAmPmNumber_Fragment' };

type FieldBase_Field_DateDayDropdown_Fragment = { __typename: 'Field_DateDayDropdown', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateDayDropdown_Fragment' };

type FieldBase_Field_DateDayNumber_Fragment = { __typename: 'Field_DateDayNumber', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateDayNumber_Fragment' };

type FieldBase_Field_DateHourDropdown_Fragment = { __typename: 'Field_DateHourDropdown', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateHourDropdown_Fragment' };

type FieldBase_Field_DateHourNumber_Fragment = { __typename: 'Field_DateHourNumber', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateHourNumber_Fragment' };

type FieldBase_Field_DateMinuteDropdown_Fragment = { __typename: 'Field_DateMinuteDropdown', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateMinuteDropdown_Fragment' };

type FieldBase_Field_DateMinuteNumber_Fragment = { __typename: 'Field_DateMinuteNumber', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateMinuteNumber_Fragment' };

type FieldBase_Field_DateMonthDropdown_Fragment = { __typename: 'Field_DateMonthDropdown', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateMonthDropdown_Fragment' };

type FieldBase_Field_DateMonthNumber_Fragment = { __typename: 'Field_DateMonthNumber', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateMonthNumber_Fragment' };

type FieldBase_Field_DateSecondDropdown_Fragment = { __typename: 'Field_DateSecondDropdown', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateSecondDropdown_Fragment' };

type FieldBase_Field_DateSecondNumber_Fragment = { __typename: 'Field_DateSecondNumber', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateSecondNumber_Fragment' };

type FieldBase_Field_DateYearDropdown_Fragment = { __typename: 'Field_DateYearDropdown', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateYearDropdown_Fragment' };

type FieldBase_Field_DateYearNumber_Fragment = { __typename: 'Field_DateYearNumber', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_DateYearNumber_Fragment' };

type FieldBase_Field_Dropdown_Fragment = { __typename: 'Field_Dropdown', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Dropdown_Fragment' };

type FieldBase_Field_Email_Fragment = { __typename: 'Field_Email', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Email_Fragment' };

type FieldBase_Field_Entries_Fragment = { __typename: 'Field_Entries', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Entries_Fragment' };

type FieldBase_Field_FileUpload_Fragment = { __typename: 'Field_FileUpload', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_FileUpload_Fragment' };

type FieldBase_Field_Group_Fragment = { __typename: 'Field_Group', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Group_Fragment' };

type FieldBase_Field_Heading_Fragment = { __typename: 'Field_Heading', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Heading_Fragment' };

type FieldBase_Field_Hidden_Fragment = { __typename: 'Field_Hidden', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Hidden_Fragment' };

type FieldBase_Field_Html_Fragment = { __typename: 'Field_Html', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Html_Fragment' };

type FieldBase_Field_MultiLineText_Fragment = { __typename: 'Field_MultiLineText', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_MultiLineText_Fragment' };

type FieldBase_Field_Name_Fragment = { __typename: 'Field_Name', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Name_Fragment' };

type FieldBase_Field_NameFirst_Fragment = { __typename: 'Field_NameFirst', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_NameFirst_Fragment' };

type FieldBase_Field_NameLast_Fragment = { __typename: 'Field_NameLast', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_NameLast_Fragment' };

type FieldBase_Field_NameMiddle_Fragment = { __typename: 'Field_NameMiddle', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_NameMiddle_Fragment' };

type FieldBase_Field_NamePrefix_Fragment = { __typename: 'Field_NamePrefix', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_NamePrefix_Fragment' };

type FieldBase_Field_Number_Fragment = { __typename: 'Field_Number', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Number_Fragment' };

type FieldBase_Field_Password_Fragment = { __typename: 'Field_Password', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Password_Fragment' };

type FieldBase_Field_Payment_Fragment = { __typename: 'Field_Payment', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Payment_Fragment' };

type FieldBase_Field_Phone_Fragment = { __typename: 'Field_Phone', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Phone_Fragment' };

type FieldBase_Field_Radio_Fragment = { __typename: 'Field_Radio', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Radio_Fragment' };

type FieldBase_Field_Recipients_Fragment = { __typename: 'Field_Recipients', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Recipients_Fragment' };

type FieldBase_Field_Repeater_Fragment = { __typename: 'Field_Repeater', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Repeater_Fragment' };

type FieldBase_Field_Section_Fragment = { __typename: 'Field_Section', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Section_Fragment' };

type FieldBase_Field_Signature_Fragment = { __typename: 'Field_Signature', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Signature_Fragment' };

type FieldBase_Field_SingleLineText_Fragment = { __typename: 'Field_SingleLineText', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_SingleLineText_Fragment' };

type FieldBase_Field_Summary_Fragment = { __typename: 'Field_Summary', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Summary_Fragment' };

type FieldBase_Field_Table_Fragment = { __typename: 'Field_Table', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Table_Fragment' };

type FieldBase_Field_Tags_Fragment = { __typename: 'Field_Tags', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Tags_Fragment' };

type FieldBase_Field_Users_Fragment = { __typename: 'Field_Users', id?: string | null, conditions?: any | null, cssClasses?: string | null, defaultValue?: string | null, displayName?: string | null, emailValue?: string | null, enableConditions?: boolean | null, enabled?: boolean | null, errorMessage?: string | null, handle?: string | null, inputTypeName?: string | null, instructions?: string | null, label?: string | null, labelPosition?: string | null, matchField?: string | null, placeholder?: string | null, prePopulate?: string | null, required?: boolean | null, type?: string | null, typeName?: string | null, uid?: string | null, visibility?: string | null, containerAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null, inputAttributes?: Array<{ __typename?: 'FieldAttribute', label?: string | null, value?: string | null } | null> | null } & { ' $fragmentName'?: 'FieldBase_Field_Users_Fragment' };

export type FieldBaseFragment = FieldBase_Field_Address_Fragment | FieldBase_Field_Address1_Fragment | FieldBase_Field_Address2_Fragment | FieldBase_Field_Address3_Fragment | FieldBase_Field_AddressAutoComplete_Fragment | FieldBase_Field_AddressCity_Fragment | FieldBase_Field_AddressCountry_Fragment | FieldBase_Field_AddressState_Fragment | FieldBase_Field_AddressZip_Fragment | FieldBase_Field_Agree_Fragment | FieldBase_Field_Calculations_Fragment | FieldBase_Field_Categories_Fragment | FieldBase_Field_Checkboxes_Fragment | FieldBase_Field_Date_Fragment | FieldBase_Field_DateAmPmDropdown_Fragment | FieldBase_Field_DateAmPmNumber_Fragment | FieldBase_Field_DateDayDropdown_Fragment | FieldBase_Field_DateDayNumber_Fragment | FieldBase_Field_DateHourDropdown_Fragment | FieldBase_Field_DateHourNumber_Fragment | FieldBase_Field_DateMinuteDropdown_Fragment | FieldBase_Field_DateMinuteNumber_Fragment | FieldBase_Field_DateMonthDropdown_Fragment | FieldBase_Field_DateMonthNumber_Fragment | FieldBase_Field_DateSecondDropdown_Fragment | FieldBase_Field_DateSecondNumber_Fragment | FieldBase_Field_DateYearDropdown_Fragment | FieldBase_Field_DateYearNumber_Fragment | FieldBase_Field_Dropdown_Fragment | FieldBase_Field_Email_Fragment | FieldBase_Field_Entries_Fragment | FieldBase_Field_FileUpload_Fragment | FieldBase_Field_Group_Fragment | FieldBase_Field_Heading_Fragment | FieldBase_Field_Hidden_Fragment | FieldBase_Field_Html_Fragment | FieldBase_Field_MultiLineText_Fragment | FieldBase_Field_Name_Fragment | FieldBase_Field_NameFirst_Fragment | FieldBase_Field_NameLast_Fragment | FieldBase_Field_NameMiddle_Fragment | FieldBase_Field_NamePrefix_Fragment | FieldBase_Field_Number_Fragment | FieldBase_Field_Password_Fragment | FieldBase_Field_Payment_Fragment | FieldBase_Field_Phone_Fragment | FieldBase_Field_Radio_Fragment | FieldBase_Field_Recipients_Fragment | FieldBase_Field_Repeater_Fragment | FieldBase_Field_Section_Fragment | FieldBase_Field_Signature_Fragment | FieldBase_Field_SingleLineText_Fragment | FieldBase_Field_Summary_Fragment | FieldBase_Field_Table_Fragment | FieldBase_Field_Tags_Fragment | FieldBase_Field_Users_Fragment;

type Field_Field_Address_Fragment = (
  { __typename: 'Field_Address', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Address_Fragment': FieldBase_Field_Address_Fragment;'FieldAddressFragment': FieldAddressFragment } }
) & { ' $fragmentName'?: 'Field_Field_Address_Fragment' };

type Field_Field_Address1_Fragment = (
  { __typename: 'Field_Address1', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Address1_Fragment': FieldBase_Field_Address1_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Address1_Fragment' };

type Field_Field_Address2_Fragment = (
  { __typename: 'Field_Address2', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Address2_Fragment': FieldBase_Field_Address2_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Address2_Fragment' };

type Field_Field_Address3_Fragment = (
  { __typename: 'Field_Address3', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Address3_Fragment': FieldBase_Field_Address3_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Address3_Fragment' };

type Field_Field_AddressAutoComplete_Fragment = (
  { __typename: 'Field_AddressAutoComplete', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressAutoComplete_Fragment': FieldBase_Field_AddressAutoComplete_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_AddressAutoComplete_Fragment' };

type Field_Field_AddressCity_Fragment = (
  { __typename: 'Field_AddressCity', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressCity_Fragment': FieldBase_Field_AddressCity_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_AddressCity_Fragment' };

type Field_Field_AddressCountry_Fragment = (
  { __typename: 'Field_AddressCountry', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressCountry_Fragment': FieldBase_Field_AddressCountry_Fragment;'FieldAddressCountryFragment': FieldAddressCountryFragment } }
) & { ' $fragmentName'?: 'Field_Field_AddressCountry_Fragment' };

type Field_Field_AddressState_Fragment = (
  { __typename: 'Field_AddressState', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressState_Fragment': FieldBase_Field_AddressState_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_AddressState_Fragment' };

type Field_Field_AddressZip_Fragment = (
  { __typename: 'Field_AddressZip', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressZip_Fragment': FieldBase_Field_AddressZip_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_AddressZip_Fragment' };

type Field_Field_Agree_Fragment = (
  { __typename: 'Field_Agree', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Agree_Fragment': FieldBase_Field_Agree_Fragment;'FieldAgreeFragment': FieldAgreeFragment } }
) & { ' $fragmentName'?: 'Field_Field_Agree_Fragment' };

type Field_Field_Calculations_Fragment = (
  { __typename: 'Field_Calculations', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Calculations_Fragment': FieldBase_Field_Calculations_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Calculations_Fragment' };

type Field_Field_Categories_Fragment = (
  { __typename: 'Field_Categories', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Categories_Fragment': FieldBase_Field_Categories_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Categories_Fragment' };

type Field_Field_Checkboxes_Fragment = (
  { __typename: 'Field_Checkboxes', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Checkboxes_Fragment': FieldBase_Field_Checkboxes_Fragment;'FieldCheckboxesFragment': FieldCheckboxesFragment } }
) & { ' $fragmentName'?: 'Field_Field_Checkboxes_Fragment' };

type Field_Field_Date_Fragment = (
  { __typename: 'Field_Date', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Date_Fragment': FieldBase_Field_Date_Fragment;'FieldDateFragment': FieldDateFragment } }
) & { ' $fragmentName'?: 'Field_Field_Date_Fragment' };

type Field_Field_DateAmPmDropdown_Fragment = (
  { __typename: 'Field_DateAmPmDropdown', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateAmPmDropdown_Fragment': FieldBase_Field_DateAmPmDropdown_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateAmPmDropdown_Fragment' };

type Field_Field_DateAmPmNumber_Fragment = (
  { __typename: 'Field_DateAmPmNumber', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateAmPmNumber_Fragment': FieldBase_Field_DateAmPmNumber_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateAmPmNumber_Fragment' };

type Field_Field_DateDayDropdown_Fragment = (
  { __typename: 'Field_DateDayDropdown', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateDayDropdown_Fragment': FieldBase_Field_DateDayDropdown_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateDayDropdown_Fragment' };

type Field_Field_DateDayNumber_Fragment = (
  { __typename: 'Field_DateDayNumber', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateDayNumber_Fragment': FieldBase_Field_DateDayNumber_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateDayNumber_Fragment' };

type Field_Field_DateHourDropdown_Fragment = (
  { __typename: 'Field_DateHourDropdown', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateHourDropdown_Fragment': FieldBase_Field_DateHourDropdown_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateHourDropdown_Fragment' };

type Field_Field_DateHourNumber_Fragment = (
  { __typename: 'Field_DateHourNumber', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateHourNumber_Fragment': FieldBase_Field_DateHourNumber_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateHourNumber_Fragment' };

type Field_Field_DateMinuteDropdown_Fragment = (
  { __typename: 'Field_DateMinuteDropdown', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMinuteDropdown_Fragment': FieldBase_Field_DateMinuteDropdown_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateMinuteDropdown_Fragment' };

type Field_Field_DateMinuteNumber_Fragment = (
  { __typename: 'Field_DateMinuteNumber', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMinuteNumber_Fragment': FieldBase_Field_DateMinuteNumber_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateMinuteNumber_Fragment' };

type Field_Field_DateMonthDropdown_Fragment = (
  { __typename: 'Field_DateMonthDropdown', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMonthDropdown_Fragment': FieldBase_Field_DateMonthDropdown_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateMonthDropdown_Fragment' };

type Field_Field_DateMonthNumber_Fragment = (
  { __typename: 'Field_DateMonthNumber', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMonthNumber_Fragment': FieldBase_Field_DateMonthNumber_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateMonthNumber_Fragment' };

type Field_Field_DateSecondDropdown_Fragment = (
  { __typename: 'Field_DateSecondDropdown', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateSecondDropdown_Fragment': FieldBase_Field_DateSecondDropdown_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateSecondDropdown_Fragment' };

type Field_Field_DateSecondNumber_Fragment = (
  { __typename: 'Field_DateSecondNumber', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateSecondNumber_Fragment': FieldBase_Field_DateSecondNumber_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateSecondNumber_Fragment' };

type Field_Field_DateYearDropdown_Fragment = (
  { __typename: 'Field_DateYearDropdown', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateYearDropdown_Fragment': FieldBase_Field_DateYearDropdown_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateYearDropdown_Fragment' };

type Field_Field_DateYearNumber_Fragment = (
  { __typename: 'Field_DateYearNumber', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateYearNumber_Fragment': FieldBase_Field_DateYearNumber_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_DateYearNumber_Fragment' };

type Field_Field_Dropdown_Fragment = (
  { __typename: 'Field_Dropdown', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Dropdown_Fragment': FieldBase_Field_Dropdown_Fragment;'FieldDropdownFragment': FieldDropdownFragment } }
) & { ' $fragmentName'?: 'Field_Field_Dropdown_Fragment' };

type Field_Field_Email_Fragment = (
  { __typename: 'Field_Email', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Email_Fragment': FieldBase_Field_Email_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Email_Fragment' };

type Field_Field_Entries_Fragment = (
  { __typename: 'Field_Entries', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Entries_Fragment': FieldBase_Field_Entries_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Entries_Fragment' };

type Field_Field_FileUpload_Fragment = (
  { __typename: 'Field_FileUpload', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_FileUpload_Fragment': FieldBase_Field_FileUpload_Fragment;'FieldFileUploadFragment': FieldFileUploadFragment } }
) & { ' $fragmentName'?: 'Field_Field_FileUpload_Fragment' };

type Field_Field_Group_Fragment = (
  { __typename: 'Field_Group', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Group_Fragment': FieldBase_Field_Group_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Group_Fragment' };

type Field_Field_Heading_Fragment = (
  { __typename: 'Field_Heading', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Heading_Fragment': FieldBase_Field_Heading_Fragment;'FieldHeadingFragment': FieldHeadingFragment } }
) & { ' $fragmentName'?: 'Field_Field_Heading_Fragment' };

type Field_Field_Hidden_Fragment = (
  { __typename: 'Field_Hidden', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Hidden_Fragment': FieldBase_Field_Hidden_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Hidden_Fragment' };

type Field_Field_Html_Fragment = (
  { __typename: 'Field_Html', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Html_Fragment': FieldBase_Field_Html_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Html_Fragment' };

type Field_Field_MultiLineText_Fragment = (
  { __typename: 'Field_MultiLineText', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_MultiLineText_Fragment': FieldBase_Field_MultiLineText_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_MultiLineText_Fragment' };

type Field_Field_Name_Fragment = (
  { __typename: 'Field_Name', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Name_Fragment': FieldBase_Field_Name_Fragment;'FieldNameFragment': FieldNameFragment } }
) & { ' $fragmentName'?: 'Field_Field_Name_Fragment' };

type Field_Field_NameFirst_Fragment = (
  { __typename: 'Field_NameFirst', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_NameFirst_Fragment': FieldBase_Field_NameFirst_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_NameFirst_Fragment' };

type Field_Field_NameLast_Fragment = (
  { __typename: 'Field_NameLast', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_NameLast_Fragment': FieldBase_Field_NameLast_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_NameLast_Fragment' };

type Field_Field_NameMiddle_Fragment = (
  { __typename: 'Field_NameMiddle', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_NameMiddle_Fragment': FieldBase_Field_NameMiddle_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_NameMiddle_Fragment' };

type Field_Field_NamePrefix_Fragment = (
  { __typename: 'Field_NamePrefix', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_NamePrefix_Fragment': FieldBase_Field_NamePrefix_Fragment;'FieldNamePrefixFragment': FieldNamePrefixFragment } }
) & { ' $fragmentName'?: 'Field_Field_NamePrefix_Fragment' };

type Field_Field_Number_Fragment = (
  { __typename: 'Field_Number', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Number_Fragment': FieldBase_Field_Number_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Number_Fragment' };

type Field_Field_Password_Fragment = (
  { __typename: 'Field_Password', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Password_Fragment': FieldBase_Field_Password_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Password_Fragment' };

type Field_Field_Payment_Fragment = (
  { __typename: 'Field_Payment', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Payment_Fragment': FieldBase_Field_Payment_Fragment;'FieldPaymentFragment': FieldPaymentFragment } }
) & { ' $fragmentName'?: 'Field_Field_Payment_Fragment' };

type Field_Field_Phone_Fragment = (
  { __typename: 'Field_Phone', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Phone_Fragment': FieldBase_Field_Phone_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Phone_Fragment' };

type Field_Field_Radio_Fragment = (
  { __typename: 'Field_Radio', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Radio_Fragment': FieldBase_Field_Radio_Fragment;'FieldRadioFragment': FieldRadioFragment } }
) & { ' $fragmentName'?: 'Field_Field_Radio_Fragment' };

type Field_Field_Recipients_Fragment = (
  { __typename: 'Field_Recipients', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Recipients_Fragment': FieldBase_Field_Recipients_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Recipients_Fragment' };

type Field_Field_Repeater_Fragment = (
  { __typename: 'Field_Repeater', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Repeater_Fragment': FieldBase_Field_Repeater_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Repeater_Fragment' };

type Field_Field_Section_Fragment = (
  { __typename: 'Field_Section', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Section_Fragment': FieldBase_Field_Section_Fragment;'FieldSectionFragment': FieldSectionFragment } }
) & { ' $fragmentName'?: 'Field_Field_Section_Fragment' };

type Field_Field_Signature_Fragment = (
  { __typename: 'Field_Signature', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Signature_Fragment': FieldBase_Field_Signature_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Signature_Fragment' };

type Field_Field_SingleLineText_Fragment = (
  { __typename: 'Field_SingleLineText', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_SingleLineText_Fragment': FieldBase_Field_SingleLineText_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_SingleLineText_Fragment' };

type Field_Field_Summary_Fragment = (
  { __typename: 'Field_Summary', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Summary_Fragment': FieldBase_Field_Summary_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Summary_Fragment' };

type Field_Field_Table_Fragment = (
  { __typename: 'Field_Table', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Table_Fragment': FieldBase_Field_Table_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Table_Fragment' };

type Field_Field_Tags_Fragment = (
  { __typename: 'Field_Tags', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Tags_Fragment': FieldBase_Field_Tags_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Tags_Fragment' };

type Field_Field_Users_Fragment = (
  { __typename: 'Field_Users', id?: string | null, handle?: string | null, conditions?: any | null, enableConditions?: boolean | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Users_Fragment': FieldBase_Field_Users_Fragment } }
) & { ' $fragmentName'?: 'Field_Field_Users_Fragment' };

export type FieldFragment = Field_Field_Address_Fragment | Field_Field_Address1_Fragment | Field_Field_Address2_Fragment | Field_Field_Address3_Fragment | Field_Field_AddressAutoComplete_Fragment | Field_Field_AddressCity_Fragment | Field_Field_AddressCountry_Fragment | Field_Field_AddressState_Fragment | Field_Field_AddressZip_Fragment | Field_Field_Agree_Fragment | Field_Field_Calculations_Fragment | Field_Field_Categories_Fragment | Field_Field_Checkboxes_Fragment | Field_Field_Date_Fragment | Field_Field_DateAmPmDropdown_Fragment | Field_Field_DateAmPmNumber_Fragment | Field_Field_DateDayDropdown_Fragment | Field_Field_DateDayNumber_Fragment | Field_Field_DateHourDropdown_Fragment | Field_Field_DateHourNumber_Fragment | Field_Field_DateMinuteDropdown_Fragment | Field_Field_DateMinuteNumber_Fragment | Field_Field_DateMonthDropdown_Fragment | Field_Field_DateMonthNumber_Fragment | Field_Field_DateSecondDropdown_Fragment | Field_Field_DateSecondNumber_Fragment | Field_Field_DateYearDropdown_Fragment | Field_Field_DateYearNumber_Fragment | Field_Field_Dropdown_Fragment | Field_Field_Email_Fragment | Field_Field_Entries_Fragment | Field_Field_FileUpload_Fragment | Field_Field_Group_Fragment | Field_Field_Heading_Fragment | Field_Field_Hidden_Fragment | Field_Field_Html_Fragment | Field_Field_MultiLineText_Fragment | Field_Field_Name_Fragment | Field_Field_NameFirst_Fragment | Field_Field_NameLast_Fragment | Field_Field_NameMiddle_Fragment | Field_Field_NamePrefix_Fragment | Field_Field_Number_Fragment | Field_Field_Password_Fragment | Field_Field_Payment_Fragment | Field_Field_Phone_Fragment | Field_Field_Radio_Fragment | Field_Field_Recipients_Fragment | Field_Field_Repeater_Fragment | Field_Field_Section_Fragment | Field_Field_Signature_Fragment | Field_Field_SingleLineText_Fragment | Field_Field_Summary_Fragment | Field_Field_Table_Fragment | Field_Field_Tags_Fragment | Field_Field_Users_Fragment;

export type FieldOptionFragment = { __typename: 'FieldOption', value?: string | null, label?: string | null, isDefault?: boolean | null } & { ' $fragmentName'?: 'FieldOptionFragment' };

type FormieForm_ContactTest_Form_Fragment = { __typename: 'contactTest_Form', id?: string | null, uid?: string | null, handle?: string | null, submissionMutationName?: string | null, slug?: string | null, rows?: Array<(
    { __typename?: 'RowType' }
    & { ' $fragmentRefs'?: { 'FormieRowFragment': FormieRowFragment } }
  ) | null> | null, captchas?: Array<(
    { __typename?: 'FormieCaptchaType' }
    & { ' $fragmentRefs'?: { 'FormieCaptchaFragment': FormieCaptchaFragment } }
  ) | null> | null, settings?: { __typename?: 'FormSettingsType', submitActionMessageHtml?: string | null, errorMessageHtml?: string | null } | null, paymentFields?: Array<{ __typename?: 'Field_Address' } | { __typename?: 'Field_Address1' } | { __typename?: 'Field_Address2' } | { __typename?: 'Field_Address3' } | { __typename?: 'Field_AddressAutoComplete' } | { __typename?: 'Field_AddressCity' } | { __typename?: 'Field_AddressCountry' } | { __typename?: 'Field_AddressState' } | { __typename?: 'Field_AddressZip' } | { __typename?: 'Field_Agree' } | { __typename?: 'Field_Calculations' } | { __typename?: 'Field_Categories' } | { __typename?: 'Field_Checkboxes' } | { __typename?: 'Field_Date' } | { __typename?: 'Field_DateAmPmDropdown' } | { __typename?: 'Field_DateAmPmNumber' } | { __typename?: 'Field_DateDayDropdown' } | { __typename?: 'Field_DateDayNumber' } | { __typename?: 'Field_DateHourDropdown' } | { __typename?: 'Field_DateHourNumber' } | { __typename?: 'Field_DateMinuteDropdown' } | { __typename?: 'Field_DateMinuteNumber' } | { __typename?: 'Field_DateMonthDropdown' } | { __typename?: 'Field_DateMonthNumber' } | { __typename?: 'Field_DateSecondDropdown' } | { __typename?: 'Field_DateSecondNumber' } | { __typename?: 'Field_DateYearDropdown' } | { __typename?: 'Field_DateYearNumber' } | { __typename?: 'Field_Dropdown' } | { __typename?: 'Field_Email' } | { __typename?: 'Field_Entries' } | { __typename?: 'Field_FileUpload' } | { __typename?: 'Field_Group' } | { __typename?: 'Field_Heading' } | { __typename?: 'Field_Hidden' } | { __typename?: 'Field_Html' } | { __typename?: 'Field_MultiLineText' } | { __typename?: 'Field_Name' } | { __typename?: 'Field_NameFirst' } | { __typename?: 'Field_NameLast' } | { __typename?: 'Field_NameMiddle' } | { __typename?: 'Field_NamePrefix' } | { __typename?: 'Field_Number' } | { __typename?: 'Field_Password' } | (
    { __typename?: 'Field_Payment' }
    & { ' $fragmentRefs'?: { 'FieldPaymentFragment': FieldPaymentFragment } }
  ) | { __typename?: 'Field_Phone' } | { __typename?: 'Field_Radio' } | { __typename?: 'Field_Recipients' } | { __typename?: 'Field_Repeater' } | { __typename?: 'Field_Section' } | { __typename?: 'Field_Signature' } | { __typename?: 'Field_SingleLineText' } | { __typename?: 'Field_Summary' } | { __typename?: 'Field_Table' } | { __typename?: 'Field_Tags' } | { __typename?: 'Field_Users' } | null> | null } & { ' $fragmentName'?: 'FormieForm_ContactTest_Form_Fragment' };

type FormieForm_EnquiryForm_Form_Fragment = { __typename: 'enquiryForm_Form', id?: string | null, uid?: string | null, handle?: string | null, submissionMutationName?: string | null, slug?: string | null, rows?: Array<(
    { __typename?: 'RowType' }
    & { ' $fragmentRefs'?: { 'FormieRowFragment': FormieRowFragment } }
  ) | null> | null, captchas?: Array<(
    { __typename?: 'FormieCaptchaType' }
    & { ' $fragmentRefs'?: { 'FormieCaptchaFragment': FormieCaptchaFragment } }
  ) | null> | null, settings?: { __typename?: 'FormSettingsType', submitActionMessageHtml?: string | null, errorMessageHtml?: string | null } | null, paymentFields?: Array<{ __typename?: 'Field_Address' } | { __typename?: 'Field_Address1' } | { __typename?: 'Field_Address2' } | { __typename?: 'Field_Address3' } | { __typename?: 'Field_AddressAutoComplete' } | { __typename?: 'Field_AddressCity' } | { __typename?: 'Field_AddressCountry' } | { __typename?: 'Field_AddressState' } | { __typename?: 'Field_AddressZip' } | { __typename?: 'Field_Agree' } | { __typename?: 'Field_Calculations' } | { __typename?: 'Field_Categories' } | { __typename?: 'Field_Checkboxes' } | { __typename?: 'Field_Date' } | { __typename?: 'Field_DateAmPmDropdown' } | { __typename?: 'Field_DateAmPmNumber' } | { __typename?: 'Field_DateDayDropdown' } | { __typename?: 'Field_DateDayNumber' } | { __typename?: 'Field_DateHourDropdown' } | { __typename?: 'Field_DateHourNumber' } | { __typename?: 'Field_DateMinuteDropdown' } | { __typename?: 'Field_DateMinuteNumber' } | { __typename?: 'Field_DateMonthDropdown' } | { __typename?: 'Field_DateMonthNumber' } | { __typename?: 'Field_DateSecondDropdown' } | { __typename?: 'Field_DateSecondNumber' } | { __typename?: 'Field_DateYearDropdown' } | { __typename?: 'Field_DateYearNumber' } | { __typename?: 'Field_Dropdown' } | { __typename?: 'Field_Email' } | { __typename?: 'Field_Entries' } | { __typename?: 'Field_FileUpload' } | { __typename?: 'Field_Group' } | { __typename?: 'Field_Heading' } | { __typename?: 'Field_Hidden' } | { __typename?: 'Field_Html' } | { __typename?: 'Field_MultiLineText' } | { __typename?: 'Field_Name' } | { __typename?: 'Field_NameFirst' } | { __typename?: 'Field_NameLast' } | { __typename?: 'Field_NameMiddle' } | { __typename?: 'Field_NamePrefix' } | { __typename?: 'Field_Number' } | { __typename?: 'Field_Password' } | (
    { __typename?: 'Field_Payment' }
    & { ' $fragmentRefs'?: { 'FieldPaymentFragment': FieldPaymentFragment } }
  ) | { __typename?: 'Field_Phone' } | { __typename?: 'Field_Radio' } | { __typename?: 'Field_Recipients' } | { __typename?: 'Field_Repeater' } | { __typename?: 'Field_Section' } | { __typename?: 'Field_Signature' } | { __typename?: 'Field_SingleLineText' } | { __typename?: 'Field_Summary' } | { __typename?: 'Field_Table' } | { __typename?: 'Field_Tags' } | { __typename?: 'Field_Users' } | null> | null } & { ' $fragmentName'?: 'FormieForm_EnquiryForm_Form_Fragment' };

type FormieForm_HousingLink_Form_Fragment = { __typename: 'housingLink_Form', id?: string | null, uid?: string | null, handle?: string | null, submissionMutationName?: string | null, slug?: string | null, rows?: Array<(
    { __typename?: 'RowType' }
    & { ' $fragmentRefs'?: { 'FormieRowFragment': FormieRowFragment } }
  ) | null> | null, captchas?: Array<(
    { __typename?: 'FormieCaptchaType' }
    & { ' $fragmentRefs'?: { 'FormieCaptchaFragment': FormieCaptchaFragment } }
  ) | null> | null, settings?: { __typename?: 'FormSettingsType', submitActionMessageHtml?: string | null, errorMessageHtml?: string | null } | null, paymentFields?: Array<{ __typename?: 'Field_Address' } | { __typename?: 'Field_Address1' } | { __typename?: 'Field_Address2' } | { __typename?: 'Field_Address3' } | { __typename?: 'Field_AddressAutoComplete' } | { __typename?: 'Field_AddressCity' } | { __typename?: 'Field_AddressCountry' } | { __typename?: 'Field_AddressState' } | { __typename?: 'Field_AddressZip' } | { __typename?: 'Field_Agree' } | { __typename?: 'Field_Calculations' } | { __typename?: 'Field_Categories' } | { __typename?: 'Field_Checkboxes' } | { __typename?: 'Field_Date' } | { __typename?: 'Field_DateAmPmDropdown' } | { __typename?: 'Field_DateAmPmNumber' } | { __typename?: 'Field_DateDayDropdown' } | { __typename?: 'Field_DateDayNumber' } | { __typename?: 'Field_DateHourDropdown' } | { __typename?: 'Field_DateHourNumber' } | { __typename?: 'Field_DateMinuteDropdown' } | { __typename?: 'Field_DateMinuteNumber' } | { __typename?: 'Field_DateMonthDropdown' } | { __typename?: 'Field_DateMonthNumber' } | { __typename?: 'Field_DateSecondDropdown' } | { __typename?: 'Field_DateSecondNumber' } | { __typename?: 'Field_DateYearDropdown' } | { __typename?: 'Field_DateYearNumber' } | { __typename?: 'Field_Dropdown' } | { __typename?: 'Field_Email' } | { __typename?: 'Field_Entries' } | { __typename?: 'Field_FileUpload' } | { __typename?: 'Field_Group' } | { __typename?: 'Field_Heading' } | { __typename?: 'Field_Hidden' } | { __typename?: 'Field_Html' } | { __typename?: 'Field_MultiLineText' } | { __typename?: 'Field_Name' } | { __typename?: 'Field_NameFirst' } | { __typename?: 'Field_NameLast' } | { __typename?: 'Field_NameMiddle' } | { __typename?: 'Field_NamePrefix' } | { __typename?: 'Field_Number' } | { __typename?: 'Field_Password' } | (
    { __typename?: 'Field_Payment' }
    & { ' $fragmentRefs'?: { 'FieldPaymentFragment': FieldPaymentFragment } }
  ) | { __typename?: 'Field_Phone' } | { __typename?: 'Field_Radio' } | { __typename?: 'Field_Recipients' } | { __typename?: 'Field_Repeater' } | { __typename?: 'Field_Section' } | { __typename?: 'Field_Signature' } | { __typename?: 'Field_SingleLineText' } | { __typename?: 'Field_Summary' } | { __typename?: 'Field_Table' } | { __typename?: 'Field_Tags' } | { __typename?: 'Field_Users' } | null> | null } & { ' $fragmentName'?: 'FormieForm_HousingLink_Form_Fragment' };

type FormieForm_TestForm_Form_Fragment = { __typename: 'testForm_Form', id?: string | null, uid?: string | null, handle?: string | null, submissionMutationName?: string | null, slug?: string | null, rows?: Array<(
    { __typename?: 'RowType' }
    & { ' $fragmentRefs'?: { 'FormieRowFragment': FormieRowFragment } }
  ) | null> | null, captchas?: Array<(
    { __typename?: 'FormieCaptchaType' }
    & { ' $fragmentRefs'?: { 'FormieCaptchaFragment': FormieCaptchaFragment } }
  ) | null> | null, settings?: { __typename?: 'FormSettingsType', submitActionMessageHtml?: string | null, errorMessageHtml?: string | null } | null, paymentFields?: Array<{ __typename?: 'Field_Address' } | { __typename?: 'Field_Address1' } | { __typename?: 'Field_Address2' } | { __typename?: 'Field_Address3' } | { __typename?: 'Field_AddressAutoComplete' } | { __typename?: 'Field_AddressCity' } | { __typename?: 'Field_AddressCountry' } | { __typename?: 'Field_AddressState' } | { __typename?: 'Field_AddressZip' } | { __typename?: 'Field_Agree' } | { __typename?: 'Field_Calculations' } | { __typename?: 'Field_Categories' } | { __typename?: 'Field_Checkboxes' } | { __typename?: 'Field_Date' } | { __typename?: 'Field_DateAmPmDropdown' } | { __typename?: 'Field_DateAmPmNumber' } | { __typename?: 'Field_DateDayDropdown' } | { __typename?: 'Field_DateDayNumber' } | { __typename?: 'Field_DateHourDropdown' } | { __typename?: 'Field_DateHourNumber' } | { __typename?: 'Field_DateMinuteDropdown' } | { __typename?: 'Field_DateMinuteNumber' } | { __typename?: 'Field_DateMonthDropdown' } | { __typename?: 'Field_DateMonthNumber' } | { __typename?: 'Field_DateSecondDropdown' } | { __typename?: 'Field_DateSecondNumber' } | { __typename?: 'Field_DateYearDropdown' } | { __typename?: 'Field_DateYearNumber' } | { __typename?: 'Field_Dropdown' } | { __typename?: 'Field_Email' } | { __typename?: 'Field_Entries' } | { __typename?: 'Field_FileUpload' } | { __typename?: 'Field_Group' } | { __typename?: 'Field_Heading' } | { __typename?: 'Field_Hidden' } | { __typename?: 'Field_Html' } | { __typename?: 'Field_MultiLineText' } | { __typename?: 'Field_Name' } | { __typename?: 'Field_NameFirst' } | { __typename?: 'Field_NameLast' } | { __typename?: 'Field_NameMiddle' } | { __typename?: 'Field_NamePrefix' } | { __typename?: 'Field_Number' } | { __typename?: 'Field_Password' } | (
    { __typename?: 'Field_Payment' }
    & { ' $fragmentRefs'?: { 'FieldPaymentFragment': FieldPaymentFragment } }
  ) | { __typename?: 'Field_Phone' } | { __typename?: 'Field_Radio' } | { __typename?: 'Field_Recipients' } | { __typename?: 'Field_Repeater' } | { __typename?: 'Field_Section' } | { __typename?: 'Field_Signature' } | { __typename?: 'Field_SingleLineText' } | { __typename?: 'Field_Summary' } | { __typename?: 'Field_Table' } | { __typename?: 'Field_Tags' } | { __typename?: 'Field_Users' } | null> | null } & { ' $fragmentName'?: 'FormieForm_TestForm_Form_Fragment' };

export type FormieFormFragment = FormieForm_ContactTest_Form_Fragment | FormieForm_EnquiryForm_Form_Fragment | FormieForm_HousingLink_Form_Fragment | FormieForm_TestForm_Form_Fragment;

export type FormieNestedRowFragment = { __typename: 'RowType', id?: string | null, rowFields?: Array<(
    { __typename: 'Field_Address', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Address_Fragment': FieldBase_Field_Address_Fragment } }
  ) | (
    { __typename: 'Field_Address1', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Address1_Fragment': FieldBase_Field_Address1_Fragment } }
  ) | (
    { __typename: 'Field_Address2', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Address2_Fragment': FieldBase_Field_Address2_Fragment } }
  ) | (
    { __typename: 'Field_Address3', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Address3_Fragment': FieldBase_Field_Address3_Fragment } }
  ) | (
    { __typename: 'Field_AddressAutoComplete', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressAutoComplete_Fragment': FieldBase_Field_AddressAutoComplete_Fragment } }
  ) | (
    { __typename: 'Field_AddressCity', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressCity_Fragment': FieldBase_Field_AddressCity_Fragment } }
  ) | (
    { __typename: 'Field_AddressCountry', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressCountry_Fragment': FieldBase_Field_AddressCountry_Fragment;'FieldAddressCountryFragment': FieldAddressCountryFragment } }
  ) | (
    { __typename: 'Field_AddressState', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressState_Fragment': FieldBase_Field_AddressState_Fragment } }
  ) | (
    { __typename: 'Field_AddressZip', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressZip_Fragment': FieldBase_Field_AddressZip_Fragment } }
  ) | (
    { __typename: 'Field_Agree', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Agree_Fragment': FieldBase_Field_Agree_Fragment } }
  ) | (
    { __typename: 'Field_Calculations', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Calculations_Fragment': FieldBase_Field_Calculations_Fragment } }
  ) | (
    { __typename: 'Field_Categories', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Categories_Fragment': FieldBase_Field_Categories_Fragment } }
  ) | (
    { __typename: 'Field_Checkboxes', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Checkboxes_Fragment': FieldBase_Field_Checkboxes_Fragment } }
  ) | (
    { __typename: 'Field_Date', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Date_Fragment': FieldBase_Field_Date_Fragment } }
  ) | (
    { __typename: 'Field_DateAmPmDropdown', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateAmPmDropdown_Fragment': FieldBase_Field_DateAmPmDropdown_Fragment } }
  ) | (
    { __typename: 'Field_DateAmPmNumber', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateAmPmNumber_Fragment': FieldBase_Field_DateAmPmNumber_Fragment } }
  ) | (
    { __typename: 'Field_DateDayDropdown', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateDayDropdown_Fragment': FieldBase_Field_DateDayDropdown_Fragment } }
  ) | (
    { __typename: 'Field_DateDayNumber', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateDayNumber_Fragment': FieldBase_Field_DateDayNumber_Fragment } }
  ) | (
    { __typename: 'Field_DateHourDropdown', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateHourDropdown_Fragment': FieldBase_Field_DateHourDropdown_Fragment } }
  ) | (
    { __typename: 'Field_DateHourNumber', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateHourNumber_Fragment': FieldBase_Field_DateHourNumber_Fragment } }
  ) | (
    { __typename: 'Field_DateMinuteDropdown', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMinuteDropdown_Fragment': FieldBase_Field_DateMinuteDropdown_Fragment } }
  ) | (
    { __typename: 'Field_DateMinuteNumber', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMinuteNumber_Fragment': FieldBase_Field_DateMinuteNumber_Fragment } }
  ) | (
    { __typename: 'Field_DateMonthDropdown', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMonthDropdown_Fragment': FieldBase_Field_DateMonthDropdown_Fragment } }
  ) | (
    { __typename: 'Field_DateMonthNumber', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMonthNumber_Fragment': FieldBase_Field_DateMonthNumber_Fragment } }
  ) | (
    { __typename: 'Field_DateSecondDropdown', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateSecondDropdown_Fragment': FieldBase_Field_DateSecondDropdown_Fragment } }
  ) | (
    { __typename: 'Field_DateSecondNumber', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateSecondNumber_Fragment': FieldBase_Field_DateSecondNumber_Fragment } }
  ) | (
    { __typename: 'Field_DateYearDropdown', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateYearDropdown_Fragment': FieldBase_Field_DateYearDropdown_Fragment } }
  ) | (
    { __typename: 'Field_DateYearNumber', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_DateYearNumber_Fragment': FieldBase_Field_DateYearNumber_Fragment } }
  ) | (
    { __typename: 'Field_Dropdown', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Dropdown_Fragment': FieldBase_Field_Dropdown_Fragment } }
  ) | (
    { __typename: 'Field_Email', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Email_Fragment': FieldBase_Field_Email_Fragment } }
  ) | (
    { __typename: 'Field_Entries', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Entries_Fragment': FieldBase_Field_Entries_Fragment } }
  ) | (
    { __typename: 'Field_FileUpload', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_FileUpload_Fragment': FieldBase_Field_FileUpload_Fragment } }
  ) | (
    { __typename: 'Field_Group', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Group_Fragment': FieldBase_Field_Group_Fragment } }
  ) | (
    { __typename: 'Field_Heading', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Heading_Fragment': FieldBase_Field_Heading_Fragment } }
  ) | (
    { __typename: 'Field_Hidden', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Hidden_Fragment': FieldBase_Field_Hidden_Fragment } }
  ) | (
    { __typename: 'Field_Html', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Html_Fragment': FieldBase_Field_Html_Fragment } }
  ) | (
    { __typename: 'Field_MultiLineText', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_MultiLineText_Fragment': FieldBase_Field_MultiLineText_Fragment } }
  ) | (
    { __typename: 'Field_Name', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Name_Fragment': FieldBase_Field_Name_Fragment } }
  ) | (
    { __typename: 'Field_NameFirst', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_NameFirst_Fragment': FieldBase_Field_NameFirst_Fragment } }
  ) | (
    { __typename: 'Field_NameLast', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_NameLast_Fragment': FieldBase_Field_NameLast_Fragment } }
  ) | (
    { __typename: 'Field_NameMiddle', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_NameMiddle_Fragment': FieldBase_Field_NameMiddle_Fragment } }
  ) | (
    { __typename: 'Field_NamePrefix', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_NamePrefix_Fragment': FieldBase_Field_NamePrefix_Fragment } }
  ) | (
    { __typename: 'Field_Number', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Number_Fragment': FieldBase_Field_Number_Fragment } }
  ) | (
    { __typename: 'Field_Password', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Password_Fragment': FieldBase_Field_Password_Fragment } }
  ) | (
    { __typename: 'Field_Payment', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Payment_Fragment': FieldBase_Field_Payment_Fragment } }
  ) | (
    { __typename: 'Field_Phone', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Phone_Fragment': FieldBase_Field_Phone_Fragment } }
  ) | (
    { __typename: 'Field_Radio', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Radio_Fragment': FieldBase_Field_Radio_Fragment } }
  ) | (
    { __typename: 'Field_Recipients', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Recipients_Fragment': FieldBase_Field_Recipients_Fragment } }
  ) | (
    { __typename: 'Field_Repeater', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Repeater_Fragment': FieldBase_Field_Repeater_Fragment } }
  ) | (
    { __typename: 'Field_Section', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Section_Fragment': FieldBase_Field_Section_Fragment } }
  ) | (
    { __typename: 'Field_Signature', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Signature_Fragment': FieldBase_Field_Signature_Fragment } }
  ) | (
    { __typename: 'Field_SingleLineText', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_SingleLineText_Fragment': FieldBase_Field_SingleLineText_Fragment } }
  ) | (
    { __typename: 'Field_Summary', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Summary_Fragment': FieldBase_Field_Summary_Fragment } }
  ) | (
    { __typename: 'Field_Table', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Table_Fragment': FieldBase_Field_Table_Fragment } }
  ) | (
    { __typename: 'Field_Tags', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Tags_Fragment': FieldBase_Field_Tags_Fragment } }
  ) | (
    { __typename: 'Field_Users', id?: string | null, handle?: string | null }
    & { ' $fragmentRefs'?: { 'FieldBase_Field_Users_Fragment': FieldBase_Field_Users_Fragment } }
  ) | null> | null } & { ' $fragmentName'?: 'FormieNestedRowFragment' };

type NestedField_Field_Address_Fragment = (
  { __typename: 'Field_Address', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Address_Fragment': FieldBase_Field_Address_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Address_Fragment' };

type NestedField_Field_Address1_Fragment = (
  { __typename: 'Field_Address1', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Address1_Fragment': FieldBase_Field_Address1_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Address1_Fragment' };

type NestedField_Field_Address2_Fragment = (
  { __typename: 'Field_Address2', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Address2_Fragment': FieldBase_Field_Address2_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Address2_Fragment' };

type NestedField_Field_Address3_Fragment = (
  { __typename: 'Field_Address3', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Address3_Fragment': FieldBase_Field_Address3_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Address3_Fragment' };

type NestedField_Field_AddressAutoComplete_Fragment = (
  { __typename: 'Field_AddressAutoComplete', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressAutoComplete_Fragment': FieldBase_Field_AddressAutoComplete_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_AddressAutoComplete_Fragment' };

type NestedField_Field_AddressCity_Fragment = (
  { __typename: 'Field_AddressCity', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressCity_Fragment': FieldBase_Field_AddressCity_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_AddressCity_Fragment' };

type NestedField_Field_AddressCountry_Fragment = (
  { __typename: 'Field_AddressCountry', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressCountry_Fragment': FieldBase_Field_AddressCountry_Fragment;'FieldAddressCountryFragment': FieldAddressCountryFragment } }
) & { ' $fragmentName'?: 'NestedField_Field_AddressCountry_Fragment' };

type NestedField_Field_AddressState_Fragment = (
  { __typename: 'Field_AddressState', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressState_Fragment': FieldBase_Field_AddressState_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_AddressState_Fragment' };

type NestedField_Field_AddressZip_Fragment = (
  { __typename: 'Field_AddressZip', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_AddressZip_Fragment': FieldBase_Field_AddressZip_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_AddressZip_Fragment' };

type NestedField_Field_Agree_Fragment = (
  { __typename: 'Field_Agree', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Agree_Fragment': FieldBase_Field_Agree_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Agree_Fragment' };

type NestedField_Field_Calculations_Fragment = (
  { __typename: 'Field_Calculations', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Calculations_Fragment': FieldBase_Field_Calculations_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Calculations_Fragment' };

type NestedField_Field_Categories_Fragment = (
  { __typename: 'Field_Categories', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Categories_Fragment': FieldBase_Field_Categories_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Categories_Fragment' };

type NestedField_Field_Checkboxes_Fragment = (
  { __typename: 'Field_Checkboxes', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Checkboxes_Fragment': FieldBase_Field_Checkboxes_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Checkboxes_Fragment' };

type NestedField_Field_Date_Fragment = (
  { __typename: 'Field_Date', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Date_Fragment': FieldBase_Field_Date_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Date_Fragment' };

type NestedField_Field_DateAmPmDropdown_Fragment = (
  { __typename: 'Field_DateAmPmDropdown', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateAmPmDropdown_Fragment': FieldBase_Field_DateAmPmDropdown_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateAmPmDropdown_Fragment' };

type NestedField_Field_DateAmPmNumber_Fragment = (
  { __typename: 'Field_DateAmPmNumber', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateAmPmNumber_Fragment': FieldBase_Field_DateAmPmNumber_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateAmPmNumber_Fragment' };

type NestedField_Field_DateDayDropdown_Fragment = (
  { __typename: 'Field_DateDayDropdown', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateDayDropdown_Fragment': FieldBase_Field_DateDayDropdown_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateDayDropdown_Fragment' };

type NestedField_Field_DateDayNumber_Fragment = (
  { __typename: 'Field_DateDayNumber', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateDayNumber_Fragment': FieldBase_Field_DateDayNumber_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateDayNumber_Fragment' };

type NestedField_Field_DateHourDropdown_Fragment = (
  { __typename: 'Field_DateHourDropdown', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateHourDropdown_Fragment': FieldBase_Field_DateHourDropdown_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateHourDropdown_Fragment' };

type NestedField_Field_DateHourNumber_Fragment = (
  { __typename: 'Field_DateHourNumber', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateHourNumber_Fragment': FieldBase_Field_DateHourNumber_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateHourNumber_Fragment' };

type NestedField_Field_DateMinuteDropdown_Fragment = (
  { __typename: 'Field_DateMinuteDropdown', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMinuteDropdown_Fragment': FieldBase_Field_DateMinuteDropdown_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateMinuteDropdown_Fragment' };

type NestedField_Field_DateMinuteNumber_Fragment = (
  { __typename: 'Field_DateMinuteNumber', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMinuteNumber_Fragment': FieldBase_Field_DateMinuteNumber_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateMinuteNumber_Fragment' };

type NestedField_Field_DateMonthDropdown_Fragment = (
  { __typename: 'Field_DateMonthDropdown', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMonthDropdown_Fragment': FieldBase_Field_DateMonthDropdown_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateMonthDropdown_Fragment' };

type NestedField_Field_DateMonthNumber_Fragment = (
  { __typename: 'Field_DateMonthNumber', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateMonthNumber_Fragment': FieldBase_Field_DateMonthNumber_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateMonthNumber_Fragment' };

type NestedField_Field_DateSecondDropdown_Fragment = (
  { __typename: 'Field_DateSecondDropdown', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateSecondDropdown_Fragment': FieldBase_Field_DateSecondDropdown_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateSecondDropdown_Fragment' };

type NestedField_Field_DateSecondNumber_Fragment = (
  { __typename: 'Field_DateSecondNumber', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateSecondNumber_Fragment': FieldBase_Field_DateSecondNumber_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateSecondNumber_Fragment' };

type NestedField_Field_DateYearDropdown_Fragment = (
  { __typename: 'Field_DateYearDropdown', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateYearDropdown_Fragment': FieldBase_Field_DateYearDropdown_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateYearDropdown_Fragment' };

type NestedField_Field_DateYearNumber_Fragment = (
  { __typename: 'Field_DateYearNumber', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_DateYearNumber_Fragment': FieldBase_Field_DateYearNumber_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_DateYearNumber_Fragment' };

type NestedField_Field_Dropdown_Fragment = (
  { __typename: 'Field_Dropdown', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Dropdown_Fragment': FieldBase_Field_Dropdown_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Dropdown_Fragment' };

type NestedField_Field_Email_Fragment = (
  { __typename: 'Field_Email', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Email_Fragment': FieldBase_Field_Email_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Email_Fragment' };

type NestedField_Field_Entries_Fragment = (
  { __typename: 'Field_Entries', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Entries_Fragment': FieldBase_Field_Entries_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Entries_Fragment' };

type NestedField_Field_FileUpload_Fragment = (
  { __typename: 'Field_FileUpload', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_FileUpload_Fragment': FieldBase_Field_FileUpload_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_FileUpload_Fragment' };

type NestedField_Field_Group_Fragment = (
  { __typename: 'Field_Group', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Group_Fragment': FieldBase_Field_Group_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Group_Fragment' };

type NestedField_Field_Heading_Fragment = (
  { __typename: 'Field_Heading', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Heading_Fragment': FieldBase_Field_Heading_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Heading_Fragment' };

type NestedField_Field_Hidden_Fragment = (
  { __typename: 'Field_Hidden', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Hidden_Fragment': FieldBase_Field_Hidden_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Hidden_Fragment' };

type NestedField_Field_Html_Fragment = (
  { __typename: 'Field_Html', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Html_Fragment': FieldBase_Field_Html_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Html_Fragment' };

type NestedField_Field_MultiLineText_Fragment = (
  { __typename: 'Field_MultiLineText', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_MultiLineText_Fragment': FieldBase_Field_MultiLineText_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_MultiLineText_Fragment' };

type NestedField_Field_Name_Fragment = (
  { __typename: 'Field_Name', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Name_Fragment': FieldBase_Field_Name_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Name_Fragment' };

type NestedField_Field_NameFirst_Fragment = (
  { __typename: 'Field_NameFirst', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_NameFirst_Fragment': FieldBase_Field_NameFirst_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_NameFirst_Fragment' };

type NestedField_Field_NameLast_Fragment = (
  { __typename: 'Field_NameLast', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_NameLast_Fragment': FieldBase_Field_NameLast_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_NameLast_Fragment' };

type NestedField_Field_NameMiddle_Fragment = (
  { __typename: 'Field_NameMiddle', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_NameMiddle_Fragment': FieldBase_Field_NameMiddle_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_NameMiddle_Fragment' };

type NestedField_Field_NamePrefix_Fragment = (
  { __typename: 'Field_NamePrefix', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_NamePrefix_Fragment': FieldBase_Field_NamePrefix_Fragment;'FieldNamePrefixFragment': FieldNamePrefixFragment } }
) & { ' $fragmentName'?: 'NestedField_Field_NamePrefix_Fragment' };

type NestedField_Field_Number_Fragment = (
  { __typename: 'Field_Number', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Number_Fragment': FieldBase_Field_Number_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Number_Fragment' };

type NestedField_Field_Password_Fragment = (
  { __typename: 'Field_Password', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Password_Fragment': FieldBase_Field_Password_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Password_Fragment' };

type NestedField_Field_Payment_Fragment = (
  { __typename: 'Field_Payment', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Payment_Fragment': FieldBase_Field_Payment_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Payment_Fragment' };

type NestedField_Field_Phone_Fragment = (
  { __typename: 'Field_Phone', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Phone_Fragment': FieldBase_Field_Phone_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Phone_Fragment' };

type NestedField_Field_Radio_Fragment = (
  { __typename: 'Field_Radio', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Radio_Fragment': FieldBase_Field_Radio_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Radio_Fragment' };

type NestedField_Field_Recipients_Fragment = (
  { __typename: 'Field_Recipients', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Recipients_Fragment': FieldBase_Field_Recipients_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Recipients_Fragment' };

type NestedField_Field_Repeater_Fragment = (
  { __typename: 'Field_Repeater', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Repeater_Fragment': FieldBase_Field_Repeater_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Repeater_Fragment' };

type NestedField_Field_Section_Fragment = (
  { __typename: 'Field_Section', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Section_Fragment': FieldBase_Field_Section_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Section_Fragment' };

type NestedField_Field_Signature_Fragment = (
  { __typename: 'Field_Signature', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Signature_Fragment': FieldBase_Field_Signature_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Signature_Fragment' };

type NestedField_Field_SingleLineText_Fragment = (
  { __typename: 'Field_SingleLineText', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_SingleLineText_Fragment': FieldBase_Field_SingleLineText_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_SingleLineText_Fragment' };

type NestedField_Field_Summary_Fragment = (
  { __typename: 'Field_Summary', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Summary_Fragment': FieldBase_Field_Summary_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Summary_Fragment' };

type NestedField_Field_Table_Fragment = (
  { __typename: 'Field_Table', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Table_Fragment': FieldBase_Field_Table_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Table_Fragment' };

type NestedField_Field_Tags_Fragment = (
  { __typename: 'Field_Tags', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Tags_Fragment': FieldBase_Field_Tags_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Tags_Fragment' };

type NestedField_Field_Users_Fragment = (
  { __typename: 'Field_Users', id?: string | null, handle?: string | null }
  & { ' $fragmentRefs'?: { 'FieldBase_Field_Users_Fragment': FieldBase_Field_Users_Fragment } }
) & { ' $fragmentName'?: 'NestedField_Field_Users_Fragment' };

export type NestedFieldFragment = NestedField_Field_Address_Fragment | NestedField_Field_Address1_Fragment | NestedField_Field_Address2_Fragment | NestedField_Field_Address3_Fragment | NestedField_Field_AddressAutoComplete_Fragment | NestedField_Field_AddressCity_Fragment | NestedField_Field_AddressCountry_Fragment | NestedField_Field_AddressState_Fragment | NestedField_Field_AddressZip_Fragment | NestedField_Field_Agree_Fragment | NestedField_Field_Calculations_Fragment | NestedField_Field_Categories_Fragment | NestedField_Field_Checkboxes_Fragment | NestedField_Field_Date_Fragment | NestedField_Field_DateAmPmDropdown_Fragment | NestedField_Field_DateAmPmNumber_Fragment | NestedField_Field_DateDayDropdown_Fragment | NestedField_Field_DateDayNumber_Fragment | NestedField_Field_DateHourDropdown_Fragment | NestedField_Field_DateHourNumber_Fragment | NestedField_Field_DateMinuteDropdown_Fragment | NestedField_Field_DateMinuteNumber_Fragment | NestedField_Field_DateMonthDropdown_Fragment | NestedField_Field_DateMonthNumber_Fragment | NestedField_Field_DateSecondDropdown_Fragment | NestedField_Field_DateSecondNumber_Fragment | NestedField_Field_DateYearDropdown_Fragment | NestedField_Field_DateYearNumber_Fragment | NestedField_Field_Dropdown_Fragment | NestedField_Field_Email_Fragment | NestedField_Field_Entries_Fragment | NestedField_Field_FileUpload_Fragment | NestedField_Field_Group_Fragment | NestedField_Field_Heading_Fragment | NestedField_Field_Hidden_Fragment | NestedField_Field_Html_Fragment | NestedField_Field_MultiLineText_Fragment | NestedField_Field_Name_Fragment | NestedField_Field_NameFirst_Fragment | NestedField_Field_NameLast_Fragment | NestedField_Field_NameMiddle_Fragment | NestedField_Field_NamePrefix_Fragment | NestedField_Field_Number_Fragment | NestedField_Field_Password_Fragment | NestedField_Field_Payment_Fragment | NestedField_Field_Phone_Fragment | NestedField_Field_Radio_Fragment | NestedField_Field_Recipients_Fragment | NestedField_Field_Repeater_Fragment | NestedField_Field_Section_Fragment | NestedField_Field_Signature_Fragment | NestedField_Field_SingleLineText_Fragment | NestedField_Field_Summary_Fragment | NestedField_Field_Table_Fragment | NestedField_Field_Tags_Fragment | NestedField_Field_Users_Fragment;

export type FormieFormExistsQueryVariables = Exact<{
  uid: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type FormieFormExistsQuery = { __typename?: 'Query', formieForm?: { __typename?: 'contactTest_Form', id?: string | null, handle?: string | null, submissionMutationName?: string | null } | { __typename?: 'enquiryForm_Form', id?: string | null, handle?: string | null, submissionMutationName?: string | null } | { __typename?: 'housingLink_Form', id?: string | null, handle?: string | null, submissionMutationName?: string | null } | { __typename?: 'testForm_Form', id?: string | null, handle?: string | null, submissionMutationName?: string | null } | null };

export type FormieIncompleteSubmissionExistsQueryVariables = Exact<{
  uid: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
  formUid: Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>;
}>;


export type FormieIncompleteSubmissionExistsQuery = { __typename?: 'Query', formieSubmission?: { __typename?: 'contactTest_Submission', uid?: string | null } | { __typename?: 'enquiryForm_Submission', uid?: string | null } | { __typename?: 'housingLink_Submission', uid?: string | null } | { __typename?: 'testForm_Submission', uid?: string | null } | null };

export type FormieFormQueryVariables = Exact<{
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>> | InputMaybe<Scalars['QueryArgument']['input']>>;
  uid?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type FormieFormQuery = { __typename?: 'Query', formieForm?: { __typename: 'contactTest_Form', id?: string | null, uid?: string | null, handle?: string | null, submissionMutationName?: string | null, slug?: string | null, rows?: Array<(
      { __typename?: 'RowType' }
      & { ' $fragmentRefs'?: { 'FormieRowFragment': FormieRowFragment } }
    ) | null> | null, captchas?: Array<(
      { __typename?: 'FormieCaptchaType' }
      & { ' $fragmentRefs'?: { 'FormieCaptchaFragment': FormieCaptchaFragment } }
    ) | null> | null, settings?: { __typename?: 'FormSettingsType', submitActionMessageHtml?: string | null, errorMessageHtml?: string | null } | null, paymentFields?: Array<{ __typename?: 'Field_Address' } | { __typename?: 'Field_Address1' } | { __typename?: 'Field_Address2' } | { __typename?: 'Field_Address3' } | { __typename?: 'Field_AddressAutoComplete' } | { __typename?: 'Field_AddressCity' } | { __typename?: 'Field_AddressCountry' } | { __typename?: 'Field_AddressState' } | { __typename?: 'Field_AddressZip' } | { __typename?: 'Field_Agree' } | { __typename?: 'Field_Calculations' } | { __typename?: 'Field_Categories' } | { __typename?: 'Field_Checkboxes' } | { __typename?: 'Field_Date' } | { __typename?: 'Field_DateAmPmDropdown' } | { __typename?: 'Field_DateAmPmNumber' } | { __typename?: 'Field_DateDayDropdown' } | { __typename?: 'Field_DateDayNumber' } | { __typename?: 'Field_DateHourDropdown' } | { __typename?: 'Field_DateHourNumber' } | { __typename?: 'Field_DateMinuteDropdown' } | { __typename?: 'Field_DateMinuteNumber' } | { __typename?: 'Field_DateMonthDropdown' } | { __typename?: 'Field_DateMonthNumber' } | { __typename?: 'Field_DateSecondDropdown' } | { __typename?: 'Field_DateSecondNumber' } | { __typename?: 'Field_DateYearDropdown' } | { __typename?: 'Field_DateYearNumber' } | { __typename?: 'Field_Dropdown' } | { __typename?: 'Field_Email' } | { __typename?: 'Field_Entries' } | { __typename?: 'Field_FileUpload' } | { __typename?: 'Field_Group' } | { __typename?: 'Field_Heading' } | { __typename?: 'Field_Hidden' } | { __typename?: 'Field_Html' } | { __typename?: 'Field_MultiLineText' } | { __typename?: 'Field_Name' } | { __typename?: 'Field_NameFirst' } | { __typename?: 'Field_NameLast' } | { __typename?: 'Field_NameMiddle' } | { __typename?: 'Field_NamePrefix' } | { __typename?: 'Field_Number' } | { __typename?: 'Field_Password' } | (
      { __typename?: 'Field_Payment' }
      & { ' $fragmentRefs'?: { 'FieldPaymentFragment': FieldPaymentFragment } }
    ) | { __typename?: 'Field_Phone' } | { __typename?: 'Field_Radio' } | { __typename?: 'Field_Recipients' } | { __typename?: 'Field_Repeater' } | { __typename?: 'Field_Section' } | { __typename?: 'Field_Signature' } | { __typename?: 'Field_SingleLineText' } | { __typename?: 'Field_Summary' } | { __typename?: 'Field_Table' } | { __typename?: 'Field_Tags' } | { __typename?: 'Field_Users' } | null> | null } | { __typename: 'enquiryForm_Form', id?: string | null, uid?: string | null, handle?: string | null, submissionMutationName?: string | null, slug?: string | null, rows?: Array<(
      { __typename?: 'RowType' }
      & { ' $fragmentRefs'?: { 'FormieRowFragment': FormieRowFragment } }
    ) | null> | null, captchas?: Array<(
      { __typename?: 'FormieCaptchaType' }
      & { ' $fragmentRefs'?: { 'FormieCaptchaFragment': FormieCaptchaFragment } }
    ) | null> | null, settings?: { __typename?: 'FormSettingsType', submitActionMessageHtml?: string | null, errorMessageHtml?: string | null } | null, paymentFields?: Array<{ __typename?: 'Field_Address' } | { __typename?: 'Field_Address1' } | { __typename?: 'Field_Address2' } | { __typename?: 'Field_Address3' } | { __typename?: 'Field_AddressAutoComplete' } | { __typename?: 'Field_AddressCity' } | { __typename?: 'Field_AddressCountry' } | { __typename?: 'Field_AddressState' } | { __typename?: 'Field_AddressZip' } | { __typename?: 'Field_Agree' } | { __typename?: 'Field_Calculations' } | { __typename?: 'Field_Categories' } | { __typename?: 'Field_Checkboxes' } | { __typename?: 'Field_Date' } | { __typename?: 'Field_DateAmPmDropdown' } | { __typename?: 'Field_DateAmPmNumber' } | { __typename?: 'Field_DateDayDropdown' } | { __typename?: 'Field_DateDayNumber' } | { __typename?: 'Field_DateHourDropdown' } | { __typename?: 'Field_DateHourNumber' } | { __typename?: 'Field_DateMinuteDropdown' } | { __typename?: 'Field_DateMinuteNumber' } | { __typename?: 'Field_DateMonthDropdown' } | { __typename?: 'Field_DateMonthNumber' } | { __typename?: 'Field_DateSecondDropdown' } | { __typename?: 'Field_DateSecondNumber' } | { __typename?: 'Field_DateYearDropdown' } | { __typename?: 'Field_DateYearNumber' } | { __typename?: 'Field_Dropdown' } | { __typename?: 'Field_Email' } | { __typename?: 'Field_Entries' } | { __typename?: 'Field_FileUpload' } | { __typename?: 'Field_Group' } | { __typename?: 'Field_Heading' } | { __typename?: 'Field_Hidden' } | { __typename?: 'Field_Html' } | { __typename?: 'Field_MultiLineText' } | { __typename?: 'Field_Name' } | { __typename?: 'Field_NameFirst' } | { __typename?: 'Field_NameLast' } | { __typename?: 'Field_NameMiddle' } | { __typename?: 'Field_NamePrefix' } | { __typename?: 'Field_Number' } | { __typename?: 'Field_Password' } | (
      { __typename?: 'Field_Payment' }
      & { ' $fragmentRefs'?: { 'FieldPaymentFragment': FieldPaymentFragment } }
    ) | { __typename?: 'Field_Phone' } | { __typename?: 'Field_Radio' } | { __typename?: 'Field_Recipients' } | { __typename?: 'Field_Repeater' } | { __typename?: 'Field_Section' } | { __typename?: 'Field_Signature' } | { __typename?: 'Field_SingleLineText' } | { __typename?: 'Field_Summary' } | { __typename?: 'Field_Table' } | { __typename?: 'Field_Tags' } | { __typename?: 'Field_Users' } | null> | null } | { __typename: 'housingLink_Form', id?: string | null, uid?: string | null, handle?: string | null, submissionMutationName?: string | null, slug?: string | null, rows?: Array<(
      { __typename?: 'RowType' }
      & { ' $fragmentRefs'?: { 'FormieRowFragment': FormieRowFragment } }
    ) | null> | null, captchas?: Array<(
      { __typename?: 'FormieCaptchaType' }
      & { ' $fragmentRefs'?: { 'FormieCaptchaFragment': FormieCaptchaFragment } }
    ) | null> | null, settings?: { __typename?: 'FormSettingsType', submitActionMessageHtml?: string | null, errorMessageHtml?: string | null } | null, paymentFields?: Array<{ __typename?: 'Field_Address' } | { __typename?: 'Field_Address1' } | { __typename?: 'Field_Address2' } | { __typename?: 'Field_Address3' } | { __typename?: 'Field_AddressAutoComplete' } | { __typename?: 'Field_AddressCity' } | { __typename?: 'Field_AddressCountry' } | { __typename?: 'Field_AddressState' } | { __typename?: 'Field_AddressZip' } | { __typename?: 'Field_Agree' } | { __typename?: 'Field_Calculations' } | { __typename?: 'Field_Categories' } | { __typename?: 'Field_Checkboxes' } | { __typename?: 'Field_Date' } | { __typename?: 'Field_DateAmPmDropdown' } | { __typename?: 'Field_DateAmPmNumber' } | { __typename?: 'Field_DateDayDropdown' } | { __typename?: 'Field_DateDayNumber' } | { __typename?: 'Field_DateHourDropdown' } | { __typename?: 'Field_DateHourNumber' } | { __typename?: 'Field_DateMinuteDropdown' } | { __typename?: 'Field_DateMinuteNumber' } | { __typename?: 'Field_DateMonthDropdown' } | { __typename?: 'Field_DateMonthNumber' } | { __typename?: 'Field_DateSecondDropdown' } | { __typename?: 'Field_DateSecondNumber' } | { __typename?: 'Field_DateYearDropdown' } | { __typename?: 'Field_DateYearNumber' } | { __typename?: 'Field_Dropdown' } | { __typename?: 'Field_Email' } | { __typename?: 'Field_Entries' } | { __typename?: 'Field_FileUpload' } | { __typename?: 'Field_Group' } | { __typename?: 'Field_Heading' } | { __typename?: 'Field_Hidden' } | { __typename?: 'Field_Html' } | { __typename?: 'Field_MultiLineText' } | { __typename?: 'Field_Name' } | { __typename?: 'Field_NameFirst' } | { __typename?: 'Field_NameLast' } | { __typename?: 'Field_NameMiddle' } | { __typename?: 'Field_NamePrefix' } | { __typename?: 'Field_Number' } | { __typename?: 'Field_Password' } | (
      { __typename?: 'Field_Payment' }
      & { ' $fragmentRefs'?: { 'FieldPaymentFragment': FieldPaymentFragment } }
    ) | { __typename?: 'Field_Phone' } | { __typename?: 'Field_Radio' } | { __typename?: 'Field_Recipients' } | { __typename?: 'Field_Repeater' } | { __typename?: 'Field_Section' } | { __typename?: 'Field_Signature' } | { __typename?: 'Field_SingleLineText' } | { __typename?: 'Field_Summary' } | { __typename?: 'Field_Table' } | { __typename?: 'Field_Tags' } | { __typename?: 'Field_Users' } | null> | null } | { __typename: 'testForm_Form', id?: string | null, uid?: string | null, handle?: string | null, submissionMutationName?: string | null, slug?: string | null, rows?: Array<(
      { __typename?: 'RowType' }
      & { ' $fragmentRefs'?: { 'FormieRowFragment': FormieRowFragment } }
    ) | null> | null, captchas?: Array<(
      { __typename?: 'FormieCaptchaType' }
      & { ' $fragmentRefs'?: { 'FormieCaptchaFragment': FormieCaptchaFragment } }
    ) | null> | null, settings?: { __typename?: 'FormSettingsType', submitActionMessageHtml?: string | null, errorMessageHtml?: string | null } | null, paymentFields?: Array<{ __typename?: 'Field_Address' } | { __typename?: 'Field_Address1' } | { __typename?: 'Field_Address2' } | { __typename?: 'Field_Address3' } | { __typename?: 'Field_AddressAutoComplete' } | { __typename?: 'Field_AddressCity' } | { __typename?: 'Field_AddressCountry' } | { __typename?: 'Field_AddressState' } | { __typename?: 'Field_AddressZip' } | { __typename?: 'Field_Agree' } | { __typename?: 'Field_Calculations' } | { __typename?: 'Field_Categories' } | { __typename?: 'Field_Checkboxes' } | { __typename?: 'Field_Date' } | { __typename?: 'Field_DateAmPmDropdown' } | { __typename?: 'Field_DateAmPmNumber' } | { __typename?: 'Field_DateDayDropdown' } | { __typename?: 'Field_DateDayNumber' } | { __typename?: 'Field_DateHourDropdown' } | { __typename?: 'Field_DateHourNumber' } | { __typename?: 'Field_DateMinuteDropdown' } | { __typename?: 'Field_DateMinuteNumber' } | { __typename?: 'Field_DateMonthDropdown' } | { __typename?: 'Field_DateMonthNumber' } | { __typename?: 'Field_DateSecondDropdown' } | { __typename?: 'Field_DateSecondNumber' } | { __typename?: 'Field_DateYearDropdown' } | { __typename?: 'Field_DateYearNumber' } | { __typename?: 'Field_Dropdown' } | { __typename?: 'Field_Email' } | { __typename?: 'Field_Entries' } | { __typename?: 'Field_FileUpload' } | { __typename?: 'Field_Group' } | { __typename?: 'Field_Heading' } | { __typename?: 'Field_Hidden' } | { __typename?: 'Field_Html' } | { __typename?: 'Field_MultiLineText' } | { __typename?: 'Field_Name' } | { __typename?: 'Field_NameFirst' } | { __typename?: 'Field_NameLast' } | { __typename?: 'Field_NameMiddle' } | { __typename?: 'Field_NamePrefix' } | { __typename?: 'Field_Number' } | { __typename?: 'Field_Password' } | (
      { __typename?: 'Field_Payment' }
      & { ' $fragmentRefs'?: { 'FieldPaymentFragment': FieldPaymentFragment } }
    ) | { __typename?: 'Field_Phone' } | { __typename?: 'Field_Radio' } | { __typename?: 'Field_Recipients' } | { __typename?: 'Field_Repeater' } | { __typename?: 'Field_Section' } | { __typename?: 'Field_Signature' } | { __typename?: 'Field_SingleLineText' } | { __typename?: 'Field_Summary' } | { __typename?: 'Field_Table' } | { __typename?: 'Field_Tags' } | { __typename?: 'Field_Users' } | null> | null } | null };

export type FieldAttributeFragment = { __typename: 'FieldAttribute', value?: string | null, label?: string | null } & { ' $fragmentName'?: 'FieldAttributeFragment' };

type Category_AccommodationType_Category_Fragment = { __typename?: 'accommodationType_Category', id?: string | null, title?: string | null, uri?: string | null } & { ' $fragmentName'?: 'Category_AccommodationType_Category_Fragment' };

type Category_ArticleCategory_Category_Fragment = { __typename?: 'articleCategory_Category', id?: string | null, title?: string | null, uri?: string | null } & { ' $fragmentName'?: 'Category_ArticleCategory_Category_Fragment' };

type Category_ProfileGroup_Category_Fragment = { __typename?: 'profileGroup_Category', id?: string | null, title?: string | null, uri?: string | null } & { ' $fragmentName'?: 'Category_ProfileGroup_Category_Fragment' };

type Category_ProfileRole_Category_Fragment = { __typename?: 'profileRole_Category', id?: string | null, title?: string | null, uri?: string | null } & { ' $fragmentName'?: 'Category_ProfileRole_Category_Fragment' };

type Category_PropertyCategory_Category_Fragment = { __typename?: 'propertyCategory_Category', id?: string | null, title?: string | null, uri?: string | null } & { ' $fragmentName'?: 'Category_PropertyCategory_Category_Fragment' };

type Category_PropertyType_Category_Fragment = { __typename?: 'propertyType_Category', id?: string | null, title?: string | null, uri?: string | null } & { ' $fragmentName'?: 'Category_PropertyType_Category_Fragment' };

type Category_ServiceCategory_Category_Fragment = { __typename?: 'serviceCategory_Category', id?: string | null, title?: string | null, uri?: string | null } & { ' $fragmentName'?: 'Category_ServiceCategory_Category_Fragment' };

export type CategoryFragment = Category_AccommodationType_Category_Fragment | Category_ArticleCategory_Category_Fragment | Category_ProfileGroup_Category_Fragment | Category_ProfileRole_Category_Fragment | Category_PropertyCategory_Category_Fragment | Category_PropertyType_Category_Fragment | Category_ServiceCategory_Category_Fragment;

export type HomePageFragment = { __typename?: 'page_Entry', blocksHome: Array<(
    { __typename?: 'blockHomeHeroBanner_Entry' }
    & { ' $fragmentRefs'?: { 'HomeHeroBannerFragment': HomeHeroBannerFragment } }
  ) | null> } & { ' $fragmentName'?: 'HomePageFragment' };

export type EntryQueryVariables = Exact<{
  site?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  preferSites?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>> | InputMaybe<Scalars['QueryArgument']['input']>>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  section?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['QueryArgument']['input']>> | InputMaybe<Scalars['QueryArgument']['input']>>;
}>;


export type EntryQuery = { __typename?: 'Query', entry?: { __typename?: 'accordionItem_Entry' } | { __typename?: 'blockHomeHeroBanner_Entry' } | { __typename?: 'linkedImage_Entry' } | (
    { __typename?: 'page_Entry' }
    & { ' $fragmentRefs'?: { 'PageEntryFragment': PageEntryFragment } }
  ) | { __typename?: 'profile_Entry' } | null };

export type ProfileEntryFragment = (
  { __typename?: 'profile_Entry', honorific?: string | null, firstName?: string | null, lastName?: string | null, summary?: string | null, htmlContentDefault?: string | null, featureImage: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null>, profileRoleMultiple: Array<(
    { __typename?: 'accommodationType_Category' }
    & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
  ) | (
    { __typename?: 'articleCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
  ) | (
    { __typename?: 'profileGroup_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
  ) | (
    { __typename?: 'profileRole_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
  ) | (
    { __typename?: 'propertyCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
  ) | (
    { __typename?: 'propertyType_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
  ) | (
    { __typename?: 'serviceCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
  ) | null>, profileGroupMultiple: Array<(
    { __typename?: 'accommodationType_Category' }
    & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
  ) | (
    { __typename?: 'articleCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
  ) | (
    { __typename?: 'profileGroup_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
  ) | (
    { __typename?: 'profileRole_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
  ) | (
    { __typename?: 'propertyCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
  ) | (
    { __typename?: 'propertyType_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
  ) | (
    { __typename?: 'serviceCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
  ) | null> }
  & { ' $fragmentRefs'?: { 'EntryBase_Profile_Entry_Fragment': EntryBase_Profile_Entry_Fragment } }
) & { ' $fragmentName'?: 'ProfileEntryFragment' };

export type PageEntryFragment = (
  { __typename?: 'page_Entry', pageTitle?: string | null, summary?: string | null, pageLayout?: string | null, openingHoursHtml?: string | null, nBathrooms?: any | null, nBeds?: any | null, nCars?: any | null, startDate?: any | null, startTime?: any | null, endDate?: any | null, endTime?: any | null, showAnchorLinks?: boolean | null, showPreciseAddress?: boolean | null, featureImage: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null>, blocks?: Array<(
    { __typename?: 'blocks_blockAccordion_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockAccordion_BlockType_Fragment': Blocks_Blocks_BlockAccordion_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockBlockquote_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockBlockquote_BlockType_Fragment': Blocks_Blocks_BlockBlockquote_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockCta_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockCta_BlockType_Fragment': Blocks_Blocks_BlockCta_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockDownloads_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockDownloads_BlockType_Fragment': Blocks_Blocks_BlockDownloads_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockForm_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockForm_BlockType_Fragment': Blocks_Blocks_BlockForm_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockImageAndText_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockImageAndText_BlockType_Fragment': Blocks_Blocks_BlockImageAndText_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockImageCarousel_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockImageCarousel_BlockType_Fragment': Blocks_Blocks_BlockImageCarousel_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockImage_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockImage_BlockType_Fragment': Blocks_Blocks_BlockImage_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockInternalPageCards_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockInternalPageCards_BlockType_Fragment': Blocks_Blocks_BlockInternalPageCards_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockLatestNews_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockLatestNews_BlockType_Fragment': Blocks_Blocks_BlockLatestNews_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockMap_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockMap_BlockType_Fragment': Blocks_Blocks_BlockMap_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockRichText_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockRichText_BlockType_Fragment': Blocks_Blocks_BlockRichText_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockServices_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockServices_BlockType_Fragment': Blocks_Blocks_BlockServices_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_blockVideo_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_BlockVideo_BlockType_Fragment': Blocks_Blocks_BlockVideo_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_profileAccordionItem_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_ProfileAccordionItem_BlockType_Fragment': Blocks_Blocks_ProfileAccordionItem_BlockType_Fragment } }
  ) | (
    { __typename?: 'blocks_profileAccordion_BlockType' }
    & { ' $fragmentRefs'?: { 'Blocks_Blocks_ProfileAccordion_BlockType_Fragment': Blocks_Blocks_ProfileAccordion_BlockType_Fragment } }
  ) | null> | null, iconAsset: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null>, serviceCategoryMultiple: Array<(
    { __typename?: 'accommodationType_Category' }
    & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
  ) | (
    { __typename?: 'articleCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
  ) | (
    { __typename?: 'profileGroup_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
  ) | (
    { __typename?: 'profileRole_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
  ) | (
    { __typename?: 'propertyCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
  ) | (
    { __typename?: 'propertyType_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
  ) | (
    { __typename?: 'serviceCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
  ) | null>, articleCategoryMultiple: Array<(
    { __typename?: 'accommodationType_Category' }
    & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
  ) | (
    { __typename?: 'articleCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
  ) | (
    { __typename?: 'profileGroup_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
  ) | (
    { __typename?: 'profileRole_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
  ) | (
    { __typename?: 'propertyCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
  ) | (
    { __typename?: 'propertyType_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
  ) | (
    { __typename?: 'serviceCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
  ) | null>, phoneLinkMultiple: Array<(
    { __typename?: 'entryLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
  ) | null>, serviceMultiple: Array<{ __typename: 'accordionItem_Entry' } | { __typename: 'blockHomeHeroBanner_Entry' } | { __typename: 'linkedImage_Entry' } | { __typename: 'page_Entry', id?: string | null, title?: string | null, summary?: string | null, url?: string | null, uri?: string | null, iconAsset: Array<(
      { __typename?: 'assets_Asset' }
      & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
    ) | (
      { __typename?: 'icons_Asset' }
      & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
    ) | null>, serviceCategoryMultiple: Array<(
      { __typename?: 'accommodationType_Category' }
      & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
    ) | (
      { __typename?: 'articleCategory_Category' }
      & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
    ) | (
      { __typename?: 'profileGroup_Category' }
      & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
    ) | (
      { __typename?: 'profileRole_Category' }
      & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
    ) | (
      { __typename?: 'propertyCategory_Category' }
      & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
    ) | (
      { __typename?: 'propertyType_Category' }
      & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
    ) | (
      { __typename?: 'serviceCategory_Category' }
      & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
    ) | null> } | { __typename: 'profile_Entry' } | null>, propertyTypeMultiple: Array<(
    { __typename?: 'accommodationType_Category' }
    & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
  ) | (
    { __typename?: 'articleCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
  ) | (
    { __typename?: 'profileGroup_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
  ) | (
    { __typename?: 'profileRole_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
  ) | (
    { __typename?: 'propertyCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
  ) | (
    { __typename?: 'propertyType_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
  ) | (
    { __typename?: 'serviceCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
  ) | null>, propertyCategoryMultiple: Array<(
    { __typename?: 'accommodationType_Category' }
    & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
  ) | (
    { __typename?: 'articleCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
  ) | (
    { __typename?: 'profileGroup_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
  ) | (
    { __typename?: 'profileRole_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
  ) | (
    { __typename?: 'propertyCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
  ) | (
    { __typename?: 'propertyType_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
  ) | (
    { __typename?: 'serviceCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
  ) | null>, accommodationTypeMultiple: Array<(
    { __typename?: 'accommodationType_Category' }
    & { ' $fragmentRefs'?: { 'Category_AccommodationType_Category_Fragment': Category_AccommodationType_Category_Fragment } }
  ) | (
    { __typename?: 'articleCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ArticleCategory_Category_Fragment': Category_ArticleCategory_Category_Fragment } }
  ) | (
    { __typename?: 'profileGroup_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileGroup_Category_Fragment': Category_ProfileGroup_Category_Fragment } }
  ) | (
    { __typename?: 'profileRole_Category' }
    & { ' $fragmentRefs'?: { 'Category_ProfileRole_Category_Fragment': Category_ProfileRole_Category_Fragment } }
  ) | (
    { __typename?: 'propertyCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyCategory_Category_Fragment': Category_PropertyCategory_Category_Fragment } }
  ) | (
    { __typename?: 'propertyType_Category' }
    & { ' $fragmentRefs'?: { 'Category_PropertyType_Category_Fragment': Category_PropertyType_Category_Fragment } }
  ) | (
    { __typename?: 'serviceCategory_Category' }
    & { ' $fragmentRefs'?: { 'Category_ServiceCategory_Category_Fragment': Category_ServiceCategory_Category_Fragment } }
  ) | null>, images: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null>, floorplan: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null>, ticketsCta: Array<(
    { __typename?: 'entryLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'entryLinkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkAssetMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'linkSingle_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLinkMultiple_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'phoneLink_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'socialLinks_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Asset_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Category_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Custom_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Email_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Embed_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Entry_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Phone_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Site_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_Url_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
  ) | (
    { __typename?: 'ticketsCta_User_LinkType' }
    & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
  ) | null>, address?: (
    { __typename?: 'GoogleMaps_Address' }
    & { ' $fragmentRefs'?: { 'MapAddressFragment': MapAddressFragment } }
  ) | null }
  & { ' $fragmentRefs'?: { 'EntryBase_Page_Entry_Fragment': EntryBase_Page_Entry_Fragment;'HomePageFragment': HomePageFragment } }
) & { ' $fragmentName'?: 'PageEntryFragment' };

export type EntryWithTheLotQueryVariables = Exact<{
  uri?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type EntryWithTheLotQuery = { __typename?: 'Query', entry?: { __typename?: 'accordionItem_Entry', id?: string | null, title?: string | null, sectionHandle?: string | null, typeHandle: string } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, title?: string | null, sectionHandle?: string | null, typeHandle: string } | { __typename?: 'linkedImage_Entry', id?: string | null, title?: string | null, sectionHandle?: string | null, typeHandle: string } | (
    { __typename?: 'page_Entry', id?: string | null, title?: string | null, sectionHandle?: string | null, typeHandle: string }
    & { ' $fragmentRefs'?: { 'PageEntryFragment': PageEntryFragment } }
  ) | (
    { __typename?: 'profile_Entry', id?: string | null, title?: string | null, sectionHandle?: string | null, typeHandle: string }
    & { ' $fragmentRefs'?: { 'ProfileEntryFragment': ProfileEntryFragment } }
  ) | null };

export type PingQueryVariables = Exact<{ [key: string]: never; }>;


export type PingQuery = { __typename?: 'Query', ping?: string | null };

export type GlobalsQueryVariables = Exact<{ [key: string]: never; }>;


export type GlobalsQuery = { __typename?: 'Query', legal?: { __typename?: 'acknowledgmentOfCountry_GlobalSet' } | { __typename?: 'awards_GlobalSet' } | { __typename?: 'legal_GlobalSet', id?: string | null, copyrightText?: string | null, copyrightEntity?: string | null } | { __typename?: 'social_GlobalSet' } | null, social?: { __typename?: 'acknowledgmentOfCountry_GlobalSet' } | { __typename?: 'awards_GlobalSet' } | { __typename?: 'legal_GlobalSet' } | { __typename?: 'social_GlobalSet', id?: string | null, socialLabel?: string | null, phoneLink: Array<(
      { __typename?: 'entryLinkMultiple_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
    ) | null>, socialLinks: Array<(
      { __typename?: 'entryLinkMultiple_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment': LinkField_EntryLinkMultiple_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment': LinkField_EntryLinkMultiple_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment': LinkField_EntryLinkMultiple_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment': LinkField_EntryLinkMultiple_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment': LinkField_EntryLinkMultiple_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment': LinkField_EntryLinkMultiple_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment': LinkField_EntryLinkMultiple_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment': LinkField_EntryLinkMultiple_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment': LinkField_EntryLinkMultiple_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkMultiple_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkMultiple_User_LinkType_Fragment': LinkField_EntryLinkMultiple_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment': LinkField_EntryLinkSingle_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Category_LinkType_Fragment': LinkField_EntryLinkSingle_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment': LinkField_EntryLinkSingle_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Email_LinkType_Fragment': LinkField_EntryLinkSingle_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment': LinkField_EntryLinkSingle_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment': LinkField_EntryLinkSingle_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment': LinkField_EntryLinkSingle_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Site_LinkType_Fragment': LinkField_EntryLinkSingle_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_Url_LinkType_Fragment': LinkField_EntryLinkSingle_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'entryLinkSingle_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_EntryLinkSingle_User_LinkType_Fragment': LinkField_EntryLinkSingle_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment': LinkField_LinkAssetMultiple_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment': LinkField_LinkAssetMultiple_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment': LinkField_LinkAssetMultiple_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment': LinkField_LinkAssetMultiple_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment': LinkField_LinkAssetMultiple_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment': LinkField_LinkAssetMultiple_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment': LinkField_LinkAssetMultiple_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment': LinkField_LinkAssetMultiple_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment': LinkField_LinkAssetMultiple_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkAssetMultiple_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkAssetMultiple_User_LinkType_Fragment': LinkField_LinkAssetMultiple_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Asset_LinkType_Fragment': LinkField_LinkSingle_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Category_LinkType_Fragment': LinkField_LinkSingle_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Custom_LinkType_Fragment': LinkField_LinkSingle_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Email_LinkType_Fragment': LinkField_LinkSingle_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Embed_LinkType_Fragment': LinkField_LinkSingle_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Entry_LinkType_Fragment': LinkField_LinkSingle_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Phone_LinkType_Fragment': LinkField_LinkSingle_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Site_LinkType_Fragment': LinkField_LinkSingle_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_Url_LinkType_Fragment': LinkField_LinkSingle_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'linkSingle_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_LinkSingle_User_LinkType_Fragment': LinkField_LinkSingle_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment': LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment': LinkField_PhoneLinkMultiple_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment': LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment': LinkField_PhoneLinkMultiple_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment': LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment': LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment': LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment': LinkField_PhoneLinkMultiple_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment': LinkField_PhoneLinkMultiple_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLinkMultiple_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment': LinkField_PhoneLinkMultiple_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Asset_LinkType_Fragment': LinkField_PhoneLink_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Category_LinkType_Fragment': LinkField_PhoneLink_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Custom_LinkType_Fragment': LinkField_PhoneLink_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Email_LinkType_Fragment': LinkField_PhoneLink_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Embed_LinkType_Fragment': LinkField_PhoneLink_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Entry_LinkType_Fragment': LinkField_PhoneLink_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Phone_LinkType_Fragment': LinkField_PhoneLink_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Site_LinkType_Fragment': LinkField_PhoneLink_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_Url_LinkType_Fragment': LinkField_PhoneLink_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'phoneLink_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_PhoneLink_User_LinkType_Fragment': LinkField_PhoneLink_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Asset_LinkType_Fragment': LinkField_SocialLinks_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Category_LinkType_Fragment': LinkField_SocialLinks_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Custom_LinkType_Fragment': LinkField_SocialLinks_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Email_LinkType_Fragment': LinkField_SocialLinks_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Embed_LinkType_Fragment': LinkField_SocialLinks_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Entry_LinkType_Fragment': LinkField_SocialLinks_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Phone_LinkType_Fragment': LinkField_SocialLinks_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Site_LinkType_Fragment': LinkField_SocialLinks_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_Url_LinkType_Fragment': LinkField_SocialLinks_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'socialLinks_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_SocialLinks_User_LinkType_Fragment': LinkField_SocialLinks_User_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Asset_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Asset_LinkType_Fragment': LinkField_TicketsCta_Asset_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Category_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Category_LinkType_Fragment': LinkField_TicketsCta_Category_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Custom_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Custom_LinkType_Fragment': LinkField_TicketsCta_Custom_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Email_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Email_LinkType_Fragment': LinkField_TicketsCta_Email_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Embed_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Embed_LinkType_Fragment': LinkField_TicketsCta_Embed_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Entry_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Entry_LinkType_Fragment': LinkField_TicketsCta_Entry_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Phone_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Phone_LinkType_Fragment': LinkField_TicketsCta_Phone_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Site_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Site_LinkType_Fragment': LinkField_TicketsCta_Site_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_Url_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_Url_LinkType_Fragment': LinkField_TicketsCta_Url_LinkType_Fragment } }
    ) | (
      { __typename?: 'ticketsCta_User_LinkType' }
      & { ' $fragmentRefs'?: { 'LinkField_TicketsCta_User_LinkType_Fragment': LinkField_TicketsCta_User_LinkType_Fragment } }
    ) | null> } | null, awards?: { __typename?: 'acknowledgmentOfCountry_GlobalSet' } | { __typename?: 'awards_GlobalSet', id?: string | null, logoGallery: Array<{ __typename?: 'linkedImage_Entry', title?: string | null, linkUri?: string | null, image: Array<(
        { __typename?: 'assets_Asset' }
        & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
      ) | (
        { __typename?: 'icons_Asset' }
        & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
      ) | null> } | null> } | { __typename?: 'legal_GlobalSet' } | { __typename?: 'social_GlobalSet' } | null, acknowledgmentOfCountry?: { __typename?: 'acknowledgmentOfCountry_GlobalSet', id?: string | null, htmlContentSimple?: string | null } | { __typename?: 'awards_GlobalSet' } | { __typename?: 'legal_GlobalSet' } | { __typename?: 'social_GlobalSet' } | null };

type NavNode_FooterCtasNav_Node_Fragment = { __typename?: 'footerCtasNav_Node', id?: string | null, title?: string | null, uri?: string | null, url?: string | null, nodeUri?: string | null, newWindow?: string | null, classes?: string | null, lft?: number | null, rgt?: number | null, customAttributes?: Array<{ __typename?: 'NodeCustomAttribute', attribute?: string | null, value?: string | null } | null> | null, parent?: { __typename?: 'footerCtasNav_Node', id?: string | null } | { __typename?: 'footerNav_Node', id?: string | null } | { __typename?: 'policiesNav_Node', id?: string | null } | { __typename?: 'primaryNav_Node', id?: string | null } | { __typename?: 'utilitiesNav_Node', id?: string | null } | null } & { ' $fragmentName'?: 'NavNode_FooterCtasNav_Node_Fragment' };

type NavNode_FooterNav_Node_Fragment = { __typename?: 'footerNav_Node', id?: string | null, title?: string | null, uri?: string | null, url?: string | null, nodeUri?: string | null, newWindow?: string | null, classes?: string | null, lft?: number | null, rgt?: number | null, customAttributes?: Array<{ __typename?: 'NodeCustomAttribute', attribute?: string | null, value?: string | null } | null> | null, parent?: { __typename?: 'footerCtasNav_Node', id?: string | null } | { __typename?: 'footerNav_Node', id?: string | null } | { __typename?: 'policiesNav_Node', id?: string | null } | { __typename?: 'primaryNav_Node', id?: string | null } | { __typename?: 'utilitiesNav_Node', id?: string | null } | null } & { ' $fragmentName'?: 'NavNode_FooterNav_Node_Fragment' };

type NavNode_PoliciesNav_Node_Fragment = { __typename?: 'policiesNav_Node', id?: string | null, title?: string | null, uri?: string | null, url?: string | null, nodeUri?: string | null, newWindow?: string | null, classes?: string | null, lft?: number | null, rgt?: number | null, customAttributes?: Array<{ __typename?: 'NodeCustomAttribute', attribute?: string | null, value?: string | null } | null> | null, parent?: { __typename?: 'footerCtasNav_Node', id?: string | null } | { __typename?: 'footerNav_Node', id?: string | null } | { __typename?: 'policiesNav_Node', id?: string | null } | { __typename?: 'primaryNav_Node', id?: string | null } | { __typename?: 'utilitiesNav_Node', id?: string | null } | null } & { ' $fragmentName'?: 'NavNode_PoliciesNav_Node_Fragment' };

type NavNode_PrimaryNav_Node_Fragment = { __typename?: 'primaryNav_Node', id?: string | null, title?: string | null, uri?: string | null, url?: string | null, nodeUri?: string | null, newWindow?: string | null, classes?: string | null, lft?: number | null, rgt?: number | null, customAttributes?: Array<{ __typename?: 'NodeCustomAttribute', attribute?: string | null, value?: string | null } | null> | null, parent?: { __typename?: 'footerCtasNav_Node', id?: string | null } | { __typename?: 'footerNav_Node', id?: string | null } | { __typename?: 'policiesNav_Node', id?: string | null } | { __typename?: 'primaryNav_Node', id?: string | null } | { __typename?: 'utilitiesNav_Node', id?: string | null } | null } & { ' $fragmentName'?: 'NavNode_PrimaryNav_Node_Fragment' };

type NavNode_UtilitiesNav_Node_Fragment = { __typename?: 'utilitiesNav_Node', id?: string | null, title?: string | null, uri?: string | null, url?: string | null, nodeUri?: string | null, newWindow?: string | null, classes?: string | null, lft?: number | null, rgt?: number | null, customAttributes?: Array<{ __typename?: 'NodeCustomAttribute', attribute?: string | null, value?: string | null } | null> | null, parent?: { __typename?: 'footerCtasNav_Node', id?: string | null } | { __typename?: 'footerNav_Node', id?: string | null } | { __typename?: 'policiesNav_Node', id?: string | null } | { __typename?: 'primaryNav_Node', id?: string | null } | { __typename?: 'utilitiesNav_Node', id?: string | null } | null } & { ' $fragmentName'?: 'NavNode_UtilitiesNav_Node_Fragment' };

export type NavNodeFragment = NavNode_FooterCtasNav_Node_Fragment | NavNode_FooterNav_Node_Fragment | NavNode_PoliciesNav_Node_Fragment | NavNode_PrimaryNav_Node_Fragment | NavNode_UtilitiesNav_Node_Fragment;

export type NavQueryVariables = Exact<{
  handle: Scalars['String']['input'];
}>;


export type NavQuery = { __typename?: 'Query', navigationNodes?: Array<(
    { __typename?: 'footerCtasNav_Node' }
    & { ' $fragmentRefs'?: { 'NavNode_FooterCtasNav_Node_Fragment': NavNode_FooterCtasNav_Node_Fragment } }
  ) | (
    { __typename?: 'footerNav_Node' }
    & { ' $fragmentRefs'?: { 'NavNode_FooterNav_Node_Fragment': NavNode_FooterNav_Node_Fragment } }
  ) | (
    { __typename?: 'policiesNav_Node' }
    & { ' $fragmentRefs'?: { 'NavNode_PoliciesNav_Node_Fragment': NavNode_PoliciesNav_Node_Fragment } }
  ) | (
    { __typename?: 'primaryNav_Node' }
    & { ' $fragmentRefs'?: { 'NavNode_PrimaryNav_Node_Fragment': NavNode_PrimaryNav_Node_Fragment } }
  ) | (
    { __typename?: 'utilitiesNav_Node' }
    & { ' $fragmentRefs'?: { 'NavNode_UtilitiesNav_Node_Fragment': NavNode_UtilitiesNav_Node_Fragment } }
  ) | null> | null };

type LinkField_EntryLinkMultiple_Asset_LinkType_Fragment = { __typename?: 'entryLinkMultiple_Asset_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkMultiple_Asset_LinkType_Fragment' };

type LinkField_EntryLinkMultiple_Category_LinkType_Fragment = { __typename?: 'entryLinkMultiple_Category_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkMultiple_Category_LinkType_Fragment' };

type LinkField_EntryLinkMultiple_Custom_LinkType_Fragment = { __typename?: 'entryLinkMultiple_Custom_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkMultiple_Custom_LinkType_Fragment' };

type LinkField_EntryLinkMultiple_Email_LinkType_Fragment = { __typename?: 'entryLinkMultiple_Email_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkMultiple_Email_LinkType_Fragment' };

type LinkField_EntryLinkMultiple_Embed_LinkType_Fragment = { __typename?: 'entryLinkMultiple_Embed_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkMultiple_Embed_LinkType_Fragment' };

type LinkField_EntryLinkMultiple_Entry_LinkType_Fragment = { __typename?: 'entryLinkMultiple_Entry_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkMultiple_Entry_LinkType_Fragment' };

type LinkField_EntryLinkMultiple_Phone_LinkType_Fragment = { __typename?: 'entryLinkMultiple_Phone_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkMultiple_Phone_LinkType_Fragment' };

type LinkField_EntryLinkMultiple_Site_LinkType_Fragment = { __typename?: 'entryLinkMultiple_Site_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkMultiple_Site_LinkType_Fragment' };

type LinkField_EntryLinkMultiple_Url_LinkType_Fragment = { __typename?: 'entryLinkMultiple_Url_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkMultiple_Url_LinkType_Fragment' };

type LinkField_EntryLinkMultiple_User_LinkType_Fragment = { __typename?: 'entryLinkMultiple_User_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkMultiple_User_LinkType_Fragment' };

type LinkField_EntryLinkSingle_Asset_LinkType_Fragment = { __typename?: 'entryLinkSingle_Asset_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkSingle_Asset_LinkType_Fragment' };

type LinkField_EntryLinkSingle_Category_LinkType_Fragment = { __typename?: 'entryLinkSingle_Category_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkSingle_Category_LinkType_Fragment' };

type LinkField_EntryLinkSingle_Custom_LinkType_Fragment = { __typename?: 'entryLinkSingle_Custom_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkSingle_Custom_LinkType_Fragment' };

type LinkField_EntryLinkSingle_Email_LinkType_Fragment = { __typename?: 'entryLinkSingle_Email_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkSingle_Email_LinkType_Fragment' };

type LinkField_EntryLinkSingle_Embed_LinkType_Fragment = { __typename?: 'entryLinkSingle_Embed_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkSingle_Embed_LinkType_Fragment' };

type LinkField_EntryLinkSingle_Entry_LinkType_Fragment = { __typename?: 'entryLinkSingle_Entry_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkSingle_Entry_LinkType_Fragment' };

type LinkField_EntryLinkSingle_Phone_LinkType_Fragment = { __typename?: 'entryLinkSingle_Phone_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkSingle_Phone_LinkType_Fragment' };

type LinkField_EntryLinkSingle_Site_LinkType_Fragment = { __typename?: 'entryLinkSingle_Site_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkSingle_Site_LinkType_Fragment' };

type LinkField_EntryLinkSingle_Url_LinkType_Fragment = { __typename?: 'entryLinkSingle_Url_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkSingle_Url_LinkType_Fragment' };

type LinkField_EntryLinkSingle_User_LinkType_Fragment = { __typename?: 'entryLinkSingle_User_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_EntryLinkSingle_User_LinkType_Fragment' };

type LinkField_LinkAssetMultiple_Asset_LinkType_Fragment = { __typename?: 'linkAssetMultiple_Asset_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkAssetMultiple_Asset_LinkType_Fragment' };

type LinkField_LinkAssetMultiple_Category_LinkType_Fragment = { __typename?: 'linkAssetMultiple_Category_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkAssetMultiple_Category_LinkType_Fragment' };

type LinkField_LinkAssetMultiple_Custom_LinkType_Fragment = { __typename?: 'linkAssetMultiple_Custom_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkAssetMultiple_Custom_LinkType_Fragment' };

type LinkField_LinkAssetMultiple_Email_LinkType_Fragment = { __typename?: 'linkAssetMultiple_Email_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkAssetMultiple_Email_LinkType_Fragment' };

type LinkField_LinkAssetMultiple_Embed_LinkType_Fragment = { __typename?: 'linkAssetMultiple_Embed_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkAssetMultiple_Embed_LinkType_Fragment' };

type LinkField_LinkAssetMultiple_Entry_LinkType_Fragment = { __typename?: 'linkAssetMultiple_Entry_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkAssetMultiple_Entry_LinkType_Fragment' };

type LinkField_LinkAssetMultiple_Phone_LinkType_Fragment = { __typename?: 'linkAssetMultiple_Phone_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkAssetMultiple_Phone_LinkType_Fragment' };

type LinkField_LinkAssetMultiple_Site_LinkType_Fragment = { __typename?: 'linkAssetMultiple_Site_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkAssetMultiple_Site_LinkType_Fragment' };

type LinkField_LinkAssetMultiple_Url_LinkType_Fragment = { __typename?: 'linkAssetMultiple_Url_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkAssetMultiple_Url_LinkType_Fragment' };

type LinkField_LinkAssetMultiple_User_LinkType_Fragment = { __typename?: 'linkAssetMultiple_User_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkAssetMultiple_User_LinkType_Fragment' };

type LinkField_LinkSingle_Asset_LinkType_Fragment = { __typename?: 'linkSingle_Asset_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkSingle_Asset_LinkType_Fragment' };

type LinkField_LinkSingle_Category_LinkType_Fragment = { __typename?: 'linkSingle_Category_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkSingle_Category_LinkType_Fragment' };

type LinkField_LinkSingle_Custom_LinkType_Fragment = { __typename?: 'linkSingle_Custom_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkSingle_Custom_LinkType_Fragment' };

type LinkField_LinkSingle_Email_LinkType_Fragment = { __typename?: 'linkSingle_Email_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkSingle_Email_LinkType_Fragment' };

type LinkField_LinkSingle_Embed_LinkType_Fragment = { __typename?: 'linkSingle_Embed_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkSingle_Embed_LinkType_Fragment' };

type LinkField_LinkSingle_Entry_LinkType_Fragment = { __typename?: 'linkSingle_Entry_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkSingle_Entry_LinkType_Fragment' };

type LinkField_LinkSingle_Phone_LinkType_Fragment = { __typename?: 'linkSingle_Phone_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkSingle_Phone_LinkType_Fragment' };

type LinkField_LinkSingle_Site_LinkType_Fragment = { __typename?: 'linkSingle_Site_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkSingle_Site_LinkType_Fragment' };

type LinkField_LinkSingle_Url_LinkType_Fragment = { __typename?: 'linkSingle_Url_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkSingle_Url_LinkType_Fragment' };

type LinkField_LinkSingle_User_LinkType_Fragment = { __typename?: 'linkSingle_User_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_LinkSingle_User_LinkType_Fragment' };

type LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment = { __typename?: 'phoneLinkMultiple_Asset_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment' };

type LinkField_PhoneLinkMultiple_Category_LinkType_Fragment = { __typename?: 'phoneLinkMultiple_Category_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLinkMultiple_Category_LinkType_Fragment' };

type LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment = { __typename?: 'phoneLinkMultiple_Custom_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment' };

type LinkField_PhoneLinkMultiple_Email_LinkType_Fragment = { __typename?: 'phoneLinkMultiple_Email_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLinkMultiple_Email_LinkType_Fragment' };

type LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment = { __typename?: 'phoneLinkMultiple_Embed_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment' };

type LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment = { __typename?: 'phoneLinkMultiple_Entry_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment' };

type LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment = { __typename?: 'phoneLinkMultiple_Phone_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment' };

type LinkField_PhoneLinkMultiple_Site_LinkType_Fragment = { __typename?: 'phoneLinkMultiple_Site_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLinkMultiple_Site_LinkType_Fragment' };

type LinkField_PhoneLinkMultiple_Url_LinkType_Fragment = { __typename?: 'phoneLinkMultiple_Url_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLinkMultiple_Url_LinkType_Fragment' };

type LinkField_PhoneLinkMultiple_User_LinkType_Fragment = { __typename?: 'phoneLinkMultiple_User_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLinkMultiple_User_LinkType_Fragment' };

type LinkField_PhoneLink_Asset_LinkType_Fragment = { __typename?: 'phoneLink_Asset_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLink_Asset_LinkType_Fragment' };

type LinkField_PhoneLink_Category_LinkType_Fragment = { __typename?: 'phoneLink_Category_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLink_Category_LinkType_Fragment' };

type LinkField_PhoneLink_Custom_LinkType_Fragment = { __typename?: 'phoneLink_Custom_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLink_Custom_LinkType_Fragment' };

type LinkField_PhoneLink_Email_LinkType_Fragment = { __typename?: 'phoneLink_Email_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLink_Email_LinkType_Fragment' };

type LinkField_PhoneLink_Embed_LinkType_Fragment = { __typename?: 'phoneLink_Embed_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLink_Embed_LinkType_Fragment' };

type LinkField_PhoneLink_Entry_LinkType_Fragment = { __typename?: 'phoneLink_Entry_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLink_Entry_LinkType_Fragment' };

type LinkField_PhoneLink_Phone_LinkType_Fragment = { __typename?: 'phoneLink_Phone_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLink_Phone_LinkType_Fragment' };

type LinkField_PhoneLink_Site_LinkType_Fragment = { __typename?: 'phoneLink_Site_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLink_Site_LinkType_Fragment' };

type LinkField_PhoneLink_Url_LinkType_Fragment = { __typename?: 'phoneLink_Url_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLink_Url_LinkType_Fragment' };

type LinkField_PhoneLink_User_LinkType_Fragment = { __typename?: 'phoneLink_User_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_PhoneLink_User_LinkType_Fragment' };

type LinkField_SocialLinks_Asset_LinkType_Fragment = { __typename?: 'socialLinks_Asset_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_SocialLinks_Asset_LinkType_Fragment' };

type LinkField_SocialLinks_Category_LinkType_Fragment = { __typename?: 'socialLinks_Category_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_SocialLinks_Category_LinkType_Fragment' };

type LinkField_SocialLinks_Custom_LinkType_Fragment = { __typename?: 'socialLinks_Custom_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_SocialLinks_Custom_LinkType_Fragment' };

type LinkField_SocialLinks_Email_LinkType_Fragment = { __typename?: 'socialLinks_Email_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_SocialLinks_Email_LinkType_Fragment' };

type LinkField_SocialLinks_Embed_LinkType_Fragment = { __typename?: 'socialLinks_Embed_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_SocialLinks_Embed_LinkType_Fragment' };

type LinkField_SocialLinks_Entry_LinkType_Fragment = { __typename?: 'socialLinks_Entry_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_SocialLinks_Entry_LinkType_Fragment' };

type LinkField_SocialLinks_Phone_LinkType_Fragment = { __typename?: 'socialLinks_Phone_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_SocialLinks_Phone_LinkType_Fragment' };

type LinkField_SocialLinks_Site_LinkType_Fragment = { __typename?: 'socialLinks_Site_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_SocialLinks_Site_LinkType_Fragment' };

type LinkField_SocialLinks_Url_LinkType_Fragment = { __typename?: 'socialLinks_Url_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_SocialLinks_Url_LinkType_Fragment' };

type LinkField_SocialLinks_User_LinkType_Fragment = { __typename?: 'socialLinks_User_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_SocialLinks_User_LinkType_Fragment' };

type LinkField_TicketsCta_Asset_LinkType_Fragment = { __typename?: 'ticketsCta_Asset_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_TicketsCta_Asset_LinkType_Fragment' };

type LinkField_TicketsCta_Category_LinkType_Fragment = { __typename?: 'ticketsCta_Category_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_TicketsCta_Category_LinkType_Fragment' };

type LinkField_TicketsCta_Custom_LinkType_Fragment = { __typename?: 'ticketsCta_Custom_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_TicketsCta_Custom_LinkType_Fragment' };

type LinkField_TicketsCta_Email_LinkType_Fragment = { __typename?: 'ticketsCta_Email_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_TicketsCta_Email_LinkType_Fragment' };

type LinkField_TicketsCta_Embed_LinkType_Fragment = { __typename?: 'ticketsCta_Embed_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_TicketsCta_Embed_LinkType_Fragment' };

type LinkField_TicketsCta_Entry_LinkType_Fragment = { __typename?: 'ticketsCta_Entry_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_TicketsCta_Entry_LinkType_Fragment' };

type LinkField_TicketsCta_Phone_LinkType_Fragment = { __typename?: 'ticketsCta_Phone_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_TicketsCta_Phone_LinkType_Fragment' };

type LinkField_TicketsCta_Site_LinkType_Fragment = { __typename?: 'ticketsCta_Site_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_TicketsCta_Site_LinkType_Fragment' };

type LinkField_TicketsCta_Url_LinkType_Fragment = { __typename?: 'ticketsCta_Url_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_TicketsCta_Url_LinkType_Fragment' };

type LinkField_TicketsCta_User_LinkType_Fragment = { __typename?: 'ticketsCta_User_LinkType', ariaLabel?: string | null, classes?: string | null, isElement?: boolean | null, isEmpty?: boolean | null, linkText?: string | null, linkUri?: string | null, linkUrl?: string | null, linkValue?: string | null, newWindow?: boolean | null, target?: string | null, text?: string | null, title?: string | null, type?: string | null, url?: string | null, urlPrefix?: string | null, urlSuffix?: string | null, id?: string | null } & { ' $fragmentName'?: 'LinkField_TicketsCta_User_LinkType_Fragment' };

export type LinkFieldFragment = LinkField_EntryLinkMultiple_Asset_LinkType_Fragment | LinkField_EntryLinkMultiple_Category_LinkType_Fragment | LinkField_EntryLinkMultiple_Custom_LinkType_Fragment | LinkField_EntryLinkMultiple_Email_LinkType_Fragment | LinkField_EntryLinkMultiple_Embed_LinkType_Fragment | LinkField_EntryLinkMultiple_Entry_LinkType_Fragment | LinkField_EntryLinkMultiple_Phone_LinkType_Fragment | LinkField_EntryLinkMultiple_Site_LinkType_Fragment | LinkField_EntryLinkMultiple_Url_LinkType_Fragment | LinkField_EntryLinkMultiple_User_LinkType_Fragment | LinkField_EntryLinkSingle_Asset_LinkType_Fragment | LinkField_EntryLinkSingle_Category_LinkType_Fragment | LinkField_EntryLinkSingle_Custom_LinkType_Fragment | LinkField_EntryLinkSingle_Email_LinkType_Fragment | LinkField_EntryLinkSingle_Embed_LinkType_Fragment | LinkField_EntryLinkSingle_Entry_LinkType_Fragment | LinkField_EntryLinkSingle_Phone_LinkType_Fragment | LinkField_EntryLinkSingle_Site_LinkType_Fragment | LinkField_EntryLinkSingle_Url_LinkType_Fragment | LinkField_EntryLinkSingle_User_LinkType_Fragment | LinkField_LinkAssetMultiple_Asset_LinkType_Fragment | LinkField_LinkAssetMultiple_Category_LinkType_Fragment | LinkField_LinkAssetMultiple_Custom_LinkType_Fragment | LinkField_LinkAssetMultiple_Email_LinkType_Fragment | LinkField_LinkAssetMultiple_Embed_LinkType_Fragment | LinkField_LinkAssetMultiple_Entry_LinkType_Fragment | LinkField_LinkAssetMultiple_Phone_LinkType_Fragment | LinkField_LinkAssetMultiple_Site_LinkType_Fragment | LinkField_LinkAssetMultiple_Url_LinkType_Fragment | LinkField_LinkAssetMultiple_User_LinkType_Fragment | LinkField_LinkSingle_Asset_LinkType_Fragment | LinkField_LinkSingle_Category_LinkType_Fragment | LinkField_LinkSingle_Custom_LinkType_Fragment | LinkField_LinkSingle_Email_LinkType_Fragment | LinkField_LinkSingle_Embed_LinkType_Fragment | LinkField_LinkSingle_Entry_LinkType_Fragment | LinkField_LinkSingle_Phone_LinkType_Fragment | LinkField_LinkSingle_Site_LinkType_Fragment | LinkField_LinkSingle_Url_LinkType_Fragment | LinkField_LinkSingle_User_LinkType_Fragment | LinkField_PhoneLinkMultiple_Asset_LinkType_Fragment | LinkField_PhoneLinkMultiple_Category_LinkType_Fragment | LinkField_PhoneLinkMultiple_Custom_LinkType_Fragment | LinkField_PhoneLinkMultiple_Email_LinkType_Fragment | LinkField_PhoneLinkMultiple_Embed_LinkType_Fragment | LinkField_PhoneLinkMultiple_Entry_LinkType_Fragment | LinkField_PhoneLinkMultiple_Phone_LinkType_Fragment | LinkField_PhoneLinkMultiple_Site_LinkType_Fragment | LinkField_PhoneLinkMultiple_Url_LinkType_Fragment | LinkField_PhoneLinkMultiple_User_LinkType_Fragment | LinkField_PhoneLink_Asset_LinkType_Fragment | LinkField_PhoneLink_Category_LinkType_Fragment | LinkField_PhoneLink_Custom_LinkType_Fragment | LinkField_PhoneLink_Email_LinkType_Fragment | LinkField_PhoneLink_Embed_LinkType_Fragment | LinkField_PhoneLink_Entry_LinkType_Fragment | LinkField_PhoneLink_Phone_LinkType_Fragment | LinkField_PhoneLink_Site_LinkType_Fragment | LinkField_PhoneLink_Url_LinkType_Fragment | LinkField_PhoneLink_User_LinkType_Fragment | LinkField_SocialLinks_Asset_LinkType_Fragment | LinkField_SocialLinks_Category_LinkType_Fragment | LinkField_SocialLinks_Custom_LinkType_Fragment | LinkField_SocialLinks_Email_LinkType_Fragment | LinkField_SocialLinks_Embed_LinkType_Fragment | LinkField_SocialLinks_Entry_LinkType_Fragment | LinkField_SocialLinks_Phone_LinkType_Fragment | LinkField_SocialLinks_Site_LinkType_Fragment | LinkField_SocialLinks_Url_LinkType_Fragment | LinkField_SocialLinks_User_LinkType_Fragment | LinkField_TicketsCta_Asset_LinkType_Fragment | LinkField_TicketsCta_Category_LinkType_Fragment | LinkField_TicketsCta_Custom_LinkType_Fragment | LinkField_TicketsCta_Email_LinkType_Fragment | LinkField_TicketsCta_Embed_LinkType_Fragment | LinkField_TicketsCta_Entry_LinkType_Fragment | LinkField_TicketsCta_Phone_LinkType_Fragment | LinkField_TicketsCta_Site_LinkType_Fragment | LinkField_TicketsCta_Url_LinkType_Fragment | LinkField_TicketsCta_User_LinkType_Fragment;

export type MapAddressFragment = { __typename?: 'GoogleMaps_Address', id?: string | null, lat?: number | null, lng?: number | null, zoom?: number | null, formatted?: string | null, street1?: string | null, street2?: string | null, state?: string | null, city?: string | null } & { ' $fragmentName'?: 'MapAddressFragment' };

type EntryId_AccordionItem_Entry_Fragment = { __typename?: 'accordionItem_Entry', siteHandle?: string | null, id?: string | null, title?: string | null, parent?: { __typename?: 'accordionItem_Entry', id?: string | null, title?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, title?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, title?: string | null } | { __typename?: 'page_Entry', id?: string | null, title?: string | null } | { __typename?: 'profile_Entry', id?: string | null, title?: string | null } | null } & { ' $fragmentName'?: 'EntryId_AccordionItem_Entry_Fragment' };

type EntryId_BlockHomeHeroBanner_Entry_Fragment = { __typename?: 'blockHomeHeroBanner_Entry', siteHandle?: string | null, id?: string | null, title?: string | null, parent?: { __typename?: 'accordionItem_Entry', id?: string | null, title?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, title?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, title?: string | null } | { __typename?: 'page_Entry', id?: string | null, title?: string | null } | { __typename?: 'profile_Entry', id?: string | null, title?: string | null } | null } & { ' $fragmentName'?: 'EntryId_BlockHomeHeroBanner_Entry_Fragment' };

type EntryId_LinkedImage_Entry_Fragment = { __typename?: 'linkedImage_Entry', siteHandle?: string | null, id?: string | null, title?: string | null, parent?: { __typename?: 'accordionItem_Entry', id?: string | null, title?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, title?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, title?: string | null } | { __typename?: 'page_Entry', id?: string | null, title?: string | null } | { __typename?: 'profile_Entry', id?: string | null, title?: string | null } | null } & { ' $fragmentName'?: 'EntryId_LinkedImage_Entry_Fragment' };

type EntryId_Page_Entry_Fragment = { __typename?: 'page_Entry', siteHandle?: string | null, id?: string | null, title?: string | null, parent?: { __typename?: 'accordionItem_Entry', id?: string | null, title?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, title?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, title?: string | null } | { __typename?: 'page_Entry', id?: string | null, title?: string | null } | { __typename?: 'profile_Entry', id?: string | null, title?: string | null } | null } & { ' $fragmentName'?: 'EntryId_Page_Entry_Fragment' };

type EntryId_Profile_Entry_Fragment = { __typename?: 'profile_Entry', siteHandle?: string | null, id?: string | null, title?: string | null, parent?: { __typename?: 'accordionItem_Entry', id?: string | null, title?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, title?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, title?: string | null } | { __typename?: 'page_Entry', id?: string | null, title?: string | null } | { __typename?: 'profile_Entry', id?: string | null, title?: string | null } | null } & { ' $fragmentName'?: 'EntryId_Profile_Entry_Fragment' };

export type EntryIdFragment = EntryId_AccordionItem_Entry_Fragment | EntryId_BlockHomeHeroBanner_Entry_Fragment | EntryId_LinkedImage_Entry_Fragment | EntryId_Page_Entry_Fragment | EntryId_Profile_Entry_Fragment;

type EntryBase_AccordionItem_Entry_Fragment = { __typename?: 'accordionItem_Entry', searchScore?: number | null, id?: string | null, uri?: string | null, url?: string | null, slug?: string | null, title?: string | null, sectionHandle?: string | null, typeHandle: string, postDate?: any | null, parent?: { __typename?: 'accordionItem_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'page_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'profile_Entry', id?: string | null, uri?: string | null, title?: string | null } | null } & { ' $fragmentName'?: 'EntryBase_AccordionItem_Entry_Fragment' };

type EntryBase_BlockHomeHeroBanner_Entry_Fragment = { __typename?: 'blockHomeHeroBanner_Entry', searchScore?: number | null, id?: string | null, uri?: string | null, url?: string | null, slug?: string | null, title?: string | null, sectionHandle?: string | null, typeHandle: string, postDate?: any | null, parent?: { __typename?: 'accordionItem_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'page_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'profile_Entry', id?: string | null, uri?: string | null, title?: string | null } | null } & { ' $fragmentName'?: 'EntryBase_BlockHomeHeroBanner_Entry_Fragment' };

type EntryBase_LinkedImage_Entry_Fragment = { __typename?: 'linkedImage_Entry', searchScore?: number | null, id?: string | null, uri?: string | null, url?: string | null, slug?: string | null, title?: string | null, sectionHandle?: string | null, typeHandle: string, postDate?: any | null, parent?: { __typename?: 'accordionItem_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'page_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'profile_Entry', id?: string | null, uri?: string | null, title?: string | null } | null } & { ' $fragmentName'?: 'EntryBase_LinkedImage_Entry_Fragment' };

type EntryBase_Page_Entry_Fragment = { __typename?: 'page_Entry', searchScore?: number | null, id?: string | null, uri?: string | null, url?: string | null, slug?: string | null, title?: string | null, sectionHandle?: string | null, typeHandle: string, postDate?: any | null, parent?: { __typename?: 'accordionItem_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'page_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'profile_Entry', id?: string | null, uri?: string | null, title?: string | null } | null } & { ' $fragmentName'?: 'EntryBase_Page_Entry_Fragment' };

type EntryBase_Profile_Entry_Fragment = { __typename?: 'profile_Entry', searchScore?: number | null, id?: string | null, uri?: string | null, url?: string | null, slug?: string | null, title?: string | null, sectionHandle?: string | null, typeHandle: string, postDate?: any | null, parent?: { __typename?: 'accordionItem_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'blockHomeHeroBanner_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'linkedImage_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'page_Entry', id?: string | null, uri?: string | null, title?: string | null } | { __typename?: 'profile_Entry', id?: string | null, uri?: string | null, title?: string | null } | null } & { ' $fragmentName'?: 'EntryBase_Profile_Entry_Fragment' };

export type EntryBaseFragment = EntryBase_AccordionItem_Entry_Fragment | EntryBase_BlockHomeHeroBanner_Entry_Fragment | EntryBase_LinkedImage_Entry_Fragment | EntryBase_Page_Entry_Fragment | EntryBase_Profile_Entry_Fragment;

type EntryCard_AccordionItem_Entry_Fragment = { __typename?: 'accordionItem_Entry' } & { ' $fragmentName'?: 'EntryCard_AccordionItem_Entry_Fragment' };

type EntryCard_BlockHomeHeroBanner_Entry_Fragment = { __typename?: 'blockHomeHeroBanner_Entry' } & { ' $fragmentName'?: 'EntryCard_BlockHomeHeroBanner_Entry_Fragment' };

type EntryCard_LinkedImage_Entry_Fragment = { __typename?: 'linkedImage_Entry' } & { ' $fragmentName'?: 'EntryCard_LinkedImage_Entry_Fragment' };

type EntryCard_Page_Entry_Fragment = (
  { __typename: 'page_Entry', iconAsset: Array<(
    { __typename?: 'assets_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Assets_Asset_Fragment': ImageAsset_Assets_Asset_Fragment } }
  ) | (
    { __typename?: 'icons_Asset' }
    & { ' $fragmentRefs'?: { 'ImageAsset_Icons_Asset_Fragment': ImageAsset_Icons_Asset_Fragment } }
  ) | null> }
  & { ' $fragmentRefs'?: { 'EntryBase_Page_Entry_Fragment': EntryBase_Page_Entry_Fragment } }
) & { ' $fragmentName'?: 'EntryCard_Page_Entry_Fragment' };

type EntryCard_Profile_Entry_Fragment = { __typename?: 'profile_Entry' } & { ' $fragmentName'?: 'EntryCard_Profile_Entry_Fragment' };

export type EntryCardFragment = EntryCard_AccordionItem_Entry_Fragment | EntryCard_BlockHomeHeroBanner_Entry_Fragment | EntryCard_LinkedImage_Entry_Fragment | EntryCard_Page_Entry_Fragment | EntryCard_Profile_Entry_Fragment;

export const ImageAssetFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<ImageAssetFragment, unknown>;
export const CategoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]} as unknown as DocumentNode<CategoryFragment, unknown>;
export const ArticleCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]} as unknown as DocumentNode<ArticleCardFragment, unknown>;
export const EventCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<EventCardFragment, unknown>;
export const RelatedServiceFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedService"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]} as unknown as DocumentNode<RelatedServiceFragment, unknown>;
export const LocationCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedService"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedService"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]} as unknown as DocumentNode<LocationCardFragment, unknown>;
export const AccommodationTypeCategoryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccommodationTypeCategory"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accommodationType_Category"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]} as unknown as DocumentNode<AccommodationTypeCategoryFragment, unknown>;
export const PropertyCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"propertyTypeMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nBeds"}},{"kind":"Field","name":{"kind":"Name","value":"nBathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<PropertyCardFragment, unknown>;
export const SearchResultsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"SearchResults"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}}]}}]} as unknown as DocumentNode<SearchResultsFragment, unknown>;
export const FieldBaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]} as unknown as DocumentNode<FieldBaseFragment, unknown>;
export const FieldOptionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]} as unknown as DocumentNode<FieldOptionFragment, unknown>;
export const FieldAddressCountryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddressCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_AddressCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]} as unknown as DocumentNode<FieldAddressCountryFragment, unknown>;
export const FormieNestedRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieNestedRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RowInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddressCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_AddressCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}}]} as unknown as DocumentNode<FormieNestedRowFragment, unknown>;
export const FieldAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"nestedRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieNestedRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddressCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_AddressCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieNestedRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RowInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}}]}}]}}]} as unknown as DocumentNode<FieldAddressFragment, unknown>;
export const FieldAgreeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAgree"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Agree"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"uncheckedValue"}},{"kind":"Field","name":{"kind":"Name","value":"checkedValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"defaultState"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]} as unknown as DocumentNode<FieldAgreeFragment, unknown>;
export const FieldCheckboxesFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldCheckboxes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Checkboxes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]} as unknown as DocumentNode<FieldCheckboxesFragment, unknown>;
export const FieldDropdownFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldDropdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Dropdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]} as unknown as DocumentNode<FieldDropdownFragment, unknown>;
export const FieldDateFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldDate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Date"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDate"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]} as unknown as DocumentNode<FieldDateFragment, unknown>;
export const FieldNameFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Name"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"useMultipleFields"}},{"kind":"Field","name":{"kind":"Name","value":"nestedRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieNestedRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddressCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_AddressCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieNestedRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RowInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}}]}}]}}]} as unknown as DocumentNode<FieldNameFragment, unknown>;
export const FieldRadioFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldRadio"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Radio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]} as unknown as DocumentNode<FieldRadioFragment, unknown>;
export const FieldFileUploadFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldFileUpload"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_FileUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"allowedKinds"}},{"kind":"Field","name":{"kind":"Name","value":"limitFiles"}},{"kind":"Field","name":{"kind":"Name","value":"sizeLimit"}},{"kind":"Field","name":{"kind":"Name","value":"sizeMinLimit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]} as unknown as DocumentNode<FieldFileUploadFragment, unknown>;
export const FieldPaymentFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldPayment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntegrationType"}},{"kind":"Field","name":{"kind":"Name","value":"providerSettings"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]} as unknown as DocumentNode<FieldPaymentFragment, unknown>;
export const FieldNamePrefixFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldNamePrefix"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_NamePrefix"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}}]} as unknown as DocumentNode<FieldNamePrefixFragment, unknown>;
export const FieldSectionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]} as unknown as DocumentNode<FieldSectionFragment, unknown>;
export const FieldHeadingFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldHeading"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Heading"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}}]} as unknown as DocumentNode<FieldHeadingFragment, unknown>;
export const FieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"field"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddress"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAgree"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldCheckboxes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldDropdown"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldDate"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldRadio"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldFileUpload"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldPayment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldNamePrefix"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldHeading"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddressCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_AddressCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieNestedRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RowInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"nestedRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieNestedRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAgree"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Agree"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"uncheckedValue"}},{"kind":"Field","name":{"kind":"Name","value":"checkedValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"defaultState"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldCheckboxes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Checkboxes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldDropdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Dropdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldDate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Date"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDate"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Name"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"useMultipleFields"}},{"kind":"Field","name":{"kind":"Name","value":"nestedRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieNestedRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldRadio"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Radio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldFileUpload"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_FileUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"allowedKinds"}},{"kind":"Field","name":{"kind":"Name","value":"limitFiles"}},{"kind":"Field","name":{"kind":"Name","value":"sizeLimit"}},{"kind":"Field","name":{"kind":"Name","value":"sizeMinLimit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldPayment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntegrationType"}},{"kind":"Field","name":{"kind":"Name","value":"providerSettings"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldNamePrefix"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_NamePrefix"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldHeading"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Heading"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}}]} as unknown as DocumentNode<FieldFragment, unknown>;
export const FormieRowFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RowInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"field"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddressCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_AddressCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieNestedRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RowInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"nestedRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieNestedRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAgree"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Agree"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"uncheckedValue"}},{"kind":"Field","name":{"kind":"Name","value":"checkedValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"defaultState"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldCheckboxes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Checkboxes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldDropdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Dropdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldDate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Date"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDate"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Name"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"useMultipleFields"}},{"kind":"Field","name":{"kind":"Name","value":"nestedRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieNestedRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldRadio"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Radio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldFileUpload"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_FileUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"allowedKinds"}},{"kind":"Field","name":{"kind":"Name","value":"limitFiles"}},{"kind":"Field","name":{"kind":"Name","value":"sizeLimit"}},{"kind":"Field","name":{"kind":"Name","value":"sizeMinLimit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldPayment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntegrationType"}},{"kind":"Field","name":{"kind":"Name","value":"providerSettings"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldNamePrefix"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_NamePrefix"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldHeading"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Heading"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"field"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddress"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAgree"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldCheckboxes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldDropdown"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldDate"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldRadio"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldFileUpload"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldPayment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldNamePrefix"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldHeading"}}]}}]} as unknown as DocumentNode<FormieRowFragment, unknown>;
export const FormieCaptchaFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieCaptcha"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormieCaptchaType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<FormieCaptchaFragment, unknown>;
export const FormieFormFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieForm"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"submissionMutationName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieRow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"captchas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieCaptcha"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitActionMessageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessageHtml"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"paymentFields"},"name":{"kind":"Name","value":"formFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldPayment"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddressCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_AddressCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieNestedRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RowInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"nestedRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieNestedRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAgree"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Agree"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"uncheckedValue"}},{"kind":"Field","name":{"kind":"Name","value":"checkedValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"defaultState"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldCheckboxes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Checkboxes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldDropdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Dropdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldDate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Date"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDate"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Name"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"useMultipleFields"}},{"kind":"Field","name":{"kind":"Name","value":"nestedRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieNestedRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldRadio"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Radio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldFileUpload"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_FileUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"allowedKinds"}},{"kind":"Field","name":{"kind":"Name","value":"limitFiles"}},{"kind":"Field","name":{"kind":"Name","value":"sizeLimit"}},{"kind":"Field","name":{"kind":"Name","value":"sizeMinLimit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldPayment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntegrationType"}},{"kind":"Field","name":{"kind":"Name","value":"providerSettings"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldNamePrefix"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_NamePrefix"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldHeading"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Heading"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"field"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddress"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAgree"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldCheckboxes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldDropdown"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldDate"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldRadio"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldFileUpload"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldPayment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldNamePrefix"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldHeading"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RowInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"field"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieCaptcha"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormieCaptchaType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<FormieFormFragment, unknown>;
export const NestedFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"nestedField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldNamePrefix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddressCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_AddressCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldNamePrefix"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_NamePrefix"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}}]} as unknown as DocumentNode<NestedFieldFragment, unknown>;
export const FieldAttributeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAttribute"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldAttribute"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}}]}}]} as unknown as DocumentNode<FieldAttributeFragment, unknown>;
export const EntryBaseFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchScore"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}},{"kind":"Field","name":{"kind":"Name","value":"typeHandle"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"formatDateTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"j M Y","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<EntryBaseFragment, unknown>;
export const AccordionItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accordionItem_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}}]} as unknown as DocumentNode<AccordionItemFragment, unknown>;
export const AccordionBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockAccordion_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"accordionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccordionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accordionItem_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}}]} as unknown as DocumentNode<AccordionBlockFragment, unknown>;
export const BlockquoteBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockquoteBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockBlockquote_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}}]} as unknown as DocumentNode<BlockquoteBlockFragment, unknown>;
export const LinkFieldFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}}]} as unknown as DocumentNode<LinkFieldFragment, unknown>;
export const CtaBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CtaBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockCta_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}}]} as unknown as DocumentNode<CtaBlockFragment, unknown>;
export const DownloadsBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DownloadsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockDownloads_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linkAssetMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}}]} as unknown as DocumentNode<DownloadsBlockFragment, unknown>;
export const FormBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockForm_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<FormBlockFragment, unknown>;
export const ImageBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImage_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<ImageBlockFragment, unknown>;
export const ImageCarouselBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageCarouselBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImageCarousel_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<ImageCarouselBlockFragment, unknown>;
export const LatestNewsBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LatestNewsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockLatestNews_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}}]} as unknown as DocumentNode<LatestNewsBlockFragment, unknown>;
export const MapAddressFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleMaps_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"zoom"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"street1"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]} as unknown as DocumentNode<MapAddressFragment, unknown>;
export const MapBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockMap_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"showPreciseAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleMaps_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"zoom"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"street1"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]} as unknown as DocumentNode<MapBlockFragment, unknown>;
export const RichTextBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RichTextBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockRichText_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}}]} as unknown as DocumentNode<RichTextBlockFragment, unknown>;
export const ServiceCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]} as unknown as DocumentNode<ServiceCardFragment, unknown>;
export const ServicesBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServicesBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockServices_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}}]}}]} as unknown as DocumentNode<ServicesBlockFragment, unknown>;
export const VideoBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockVideo_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}}]} as unknown as DocumentNode<VideoBlockFragment, unknown>;
export const ImageAndTextBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAndTextBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImageAndText_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<ImageAndTextBlockFragment, unknown>;
export const ProfileEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"profile_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"honorific"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileRoleMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileGroupMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchScore"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}},{"kind":"Field","name":{"kind":"Name","value":"typeHandle"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"formatDateTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"j M Y","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}}]} as unknown as DocumentNode<ProfileEntryFragment, unknown>;
export const ProfileAccordionItemFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordionItem_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"profileMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileEntry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchScore"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}},{"kind":"Field","name":{"kind":"Name","value":"typeHandle"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"formatDateTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"j M Y","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"profile_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"honorific"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileRoleMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileGroupMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}}]} as unknown as DocumentNode<ProfileAccordionItemFragment, unknown>;
export const ProfileAccordionFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordion_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileAccordionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchScore"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}},{"kind":"Field","name":{"kind":"Name","value":"typeHandle"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"formatDateTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"j M Y","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"profile_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"honorific"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileRoleMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileGroupMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordionItem_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"profileMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileEntry"}}]}}]}}]} as unknown as DocumentNode<ProfileAccordionFragment, unknown>;
export const PageCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<PageCardFragment, unknown>;
export const InternalPageCardsBlockFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalPageCardsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockInternalPageCards_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}}]} as unknown as DocumentNode<InternalPageCardsBlockFragment, unknown>;
export const BlocksFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Blocks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NeoBlockInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccordionBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockquoteBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CtaBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DownloadsBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageCarouselBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LatestNewsBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RichTextBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServicesBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAndTextBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileAccordion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalPageCardsBlock"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accordionItem_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleMaps_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"zoom"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"street1"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchScore"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}},{"kind":"Field","name":{"kind":"Name","value":"typeHandle"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"formatDateTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"j M Y","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"profile_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"honorific"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileRoleMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileGroupMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordionItem_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"profileMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileEntry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockAccordion_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"accordionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccordionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockquoteBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockBlockquote_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CtaBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockCta_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DownloadsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockDownloads_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linkAssetMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockForm_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImage_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageCarouselBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImageCarousel_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LatestNewsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockLatestNews_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockMap_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"showPreciseAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RichTextBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockRichText_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServicesBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockServices_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockVideo_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAndTextBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImageAndText_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordion_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileAccordionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalPageCardsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockInternalPageCards_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageCard"}}]}}]}}]} as unknown as DocumentNode<BlocksFragment, unknown>;
export const HomeHeroBannerFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeHeroBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blockHomeHeroBanner_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroHeading"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickLinksLabel"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<HomeHeroBannerFragment, unknown>;
export const HomePageFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomePage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocksHome"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeHeroBanner"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeHeroBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blockHomeHeroBanner_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroHeading"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickLinksLabel"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}}]} as unknown as DocumentNode<HomePageFragment, unknown>;
export const PageEntryFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Blocks"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomePage"}},{"kind":"Field","name":{"kind":"Name","value":"pageLayout"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneLinkMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openingHoursHtml"}},{"kind":"Field","name":{"kind":"Name","value":"serviceMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nBathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"nBeds"}},{"kind":"Field","name":{"kind":"Name","value":"nCars"}},{"kind":"Field","name":{"kind":"Name","value":"propertyTypeMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"propertyCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accommodationTypeMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"floorplan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsCta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showAnchorLinks"}},{"kind":"Field","name":{"kind":"Name","value":"showPreciseAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapAddress"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accordionItem_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockAccordion_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"accordionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccordionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockquoteBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockBlockquote_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CtaBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockCta_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DownloadsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockDownloads_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linkAssetMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockForm_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImage_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageCarouselBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImageCarousel_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LatestNewsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockLatestNews_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleMaps_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"zoom"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"street1"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockMap_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"showPreciseAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RichTextBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockRichText_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServicesBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockServices_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockVideo_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAndTextBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImageAndText_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchScore"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}},{"kind":"Field","name":{"kind":"Name","value":"typeHandle"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"formatDateTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"j M Y","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"profile_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"honorific"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileRoleMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileGroupMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordionItem_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"profileMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileEntry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordion_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileAccordionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalPageCardsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockInternalPageCards_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeHeroBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blockHomeHeroBanner_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroHeading"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickLinksLabel"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Blocks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NeoBlockInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccordionBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockquoteBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CtaBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DownloadsBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageCarouselBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LatestNewsBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RichTextBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServicesBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAndTextBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileAccordion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalPageCardsBlock"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomePage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocksHome"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeHeroBanner"}}]}}]}}]} as unknown as DocumentNode<PageEntryFragment, unknown>;
export const NavNodeFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NodeInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"nodeUri"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"customAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lft"}},{"kind":"Field","name":{"kind":"Name","value":"rgt"}}]}}]} as unknown as DocumentNode<NavNodeFragment, unknown>;
export const EntryIdFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryId"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"siteHandle"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<EntryIdFragment, unknown>;
export const EntryCardFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchScore"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}},{"kind":"Field","name":{"kind":"Name","value":"typeHandle"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"formatDateTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"j M Y","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<EntryCardFragment, unknown>;
export const LatestNewsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestNews"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"article","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"postDate desc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<LatestNewsQuery, LatestNewsQueryVariables>;
export const LatestArticlesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestArticles"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"4"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}}]} as unknown as DocumentNode<LatestArticlesQuery, LatestArticlesQueryVariables>;
export const LatestArticlesWithCategoryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestArticlesWithCategory"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"4"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"category"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"articleEntries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"relatedToCategories"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"category"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}}]} as unknown as DocumentNode<LatestArticlesWithCategoryQuery, LatestArticlesWithCategoryQueryVariables>;
export const SearchEntriesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchEntries"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"defaultValue":{"kind":"StringValue","value":"default","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preferSites"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"default","block":false}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unique"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"addressNear"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleMaps_Near"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"12"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"defaultValue":{"kind":"IntValue","value":"0"}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"search"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relatedToCategories"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryRelationCriteriaInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"relatedToEntries"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EntryRelationCriteriaInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fixedOrder"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressNear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressNear"}}},{"kind":"Argument","name":{"kind":"Name","value":"site"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site"}}},{"kind":"Argument","name":{"kind":"Name","value":"preferSites"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preferSites"}}},{"kind":"Argument","name":{"kind":"Name","value":"unique"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unique"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"relatedToCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relatedToCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"relatedToEntries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relatedToEntries"}}},{"kind":"Argument","name":{"kind":"Name","value":"fixedOrder"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fixedOrder"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PropertyCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ArticleCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"EventCard"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceCard"}}]}},{"kind":"Field","name":{"kind":"Name","value":"entryCount"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"addressNear"},"value":{"kind":"Variable","name":{"kind":"Name","value":"addressNear"}}},{"kind":"Argument","name":{"kind":"Name","value":"site"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site"}}},{"kind":"Argument","name":{"kind":"Name","value":"preferSites"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preferSites"}}},{"kind":"Argument","name":{"kind":"Name","value":"unique"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unique"}}},{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"search"},"value":{"kind":"Variable","name":{"kind":"Name","value":"search"}}},{"kind":"Argument","name":{"kind":"Name","value":"relatedToCategories"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relatedToCategories"}}},{"kind":"Argument","name":{"kind":"Name","value":"relatedToEntries"},"value":{"kind":"Variable","name":{"kind":"Name","value":"relatedToEntries"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RelatedService"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PropertyCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"propertyTypeMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nBeds"}},{"kind":"Field","name":{"kind":"Name","value":"nBathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}}]}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"RelatedService"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ArticleCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"postDate"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EventCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}}]}}]} as unknown as DocumentNode<SearchEntriesQuery, SearchEntriesQueryVariables>;
export const LatestPropertyDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"LatestProperty"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entries"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"StringValue","value":"property","block":false}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"IntValue","value":"1"}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"StringValue","value":"postDate desc","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"nBeds"}},{"kind":"Field","name":{"kind":"Name","value":"nBathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<LatestPropertyQuery, LatestPropertyQueryVariables>;
export const FormieFormExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formieFormExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uid"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formieForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"submissionMutationName"}}]}}]}}]} as unknown as DocumentNode<FormieFormExistsQuery, FormieFormExistsQueryVariables>;
export const FormieIncompleteSubmissionExistsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formieIncompleteSubmissionExists"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uid"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"formUid"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formieSubmission"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uid"}}},{"kind":"Argument","name":{"kind":"Name","value":"form"},"value":{"kind":"Variable","name":{"kind":"Name","value":"formUid"}}},{"kind":"Argument","name":{"kind":"Name","value":"isIncomplete"},"value":{"kind":"BooleanValue","value":true}},{"kind":"Argument","name":{"kind":"Name","value":"isSpam"},"value":{"kind":"BooleanValue","value":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uid"}}]}}]}}]} as unknown as DocumentNode<FormieIncompleteSubmissionExistsQuery, FormieIncompleteSubmissionExistsQueryVariables>;
export const FormieFormDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"formieForm"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uid"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"formieForm"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}},{"kind":"Argument","name":{"kind":"Name","value":"uid"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uid"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"submissionMutationName"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"rows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieRow"}}]}},{"kind":"Field","name":{"kind":"Name","value":"captchas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieCaptcha"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settings"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"submitActionMessageHtml"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessageHtml"}}]}},{"kind":"Field","alias":{"kind":"Name","value":"paymentFields"},"name":{"kind":"Name","value":"formFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldPayment"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"containerAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"cssClasses"}},{"kind":"Field","name":{"kind":"Name","value":"defaultValue"}},{"kind":"Field","name":{"kind":"Name","value":"displayName"}},{"kind":"Field","name":{"kind":"Name","value":"emailValue"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"errorMessage"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"inputAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"inputTypeName"}},{"kind":"Field","name":{"kind":"Name","value":"instructions"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"labelPosition"}},{"kind":"Field","name":{"kind":"Name","value":"matchField"}},{"kind":"Field","name":{"kind":"Name","value":"placeholder"}},{"kind":"Field","name":{"kind":"Name","value":"prePopulate"}},{"kind":"Field","name":{"kind":"Name","value":"required"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"typeName"}},{"kind":"Field","name":{"kind":"Name","value":"uid"}},{"kind":"Field","name":{"kind":"Name","value":"visibility"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldOption"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldOption"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"value"}},{"kind":"Field","name":{"kind":"Name","value":"label"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddressCountry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_AddressCountry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieNestedRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RowInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"nestedRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieNestedRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldAgree"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Agree"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"uncheckedValue"}},{"kind":"Field","name":{"kind":"Name","value":"checkedValue"}},{"kind":"Field","name":{"kind":"Name","value":"descriptionHtml"}},{"kind":"Field","name":{"kind":"Name","value":"defaultState"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldCheckboxes"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Checkboxes"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldDropdown"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Dropdown"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"multi"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldDate"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Date"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"defaultDate"}},{"kind":"Field","name":{"kind":"Name","value":"fields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldName"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Name"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"useMultipleFields"}},{"kind":"Field","name":{"kind":"Name","value":"nestedRows"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"formieNestedRow"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldRadio"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Radio"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"layout"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldFileUpload"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_FileUpload"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"allowedKinds"}},{"kind":"Field","name":{"kind":"Name","value":"limitFiles"}},{"kind":"Field","name":{"kind":"Name","value":"sizeLimit"}},{"kind":"Field","name":{"kind":"Name","value":"sizeMinLimit"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldPayment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Payment"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntegration"}},{"kind":"Field","name":{"kind":"Name","value":"paymentIntegrationType"}},{"kind":"Field","name":{"kind":"Name","value":"providerSettings"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldNamePrefix"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_NamePrefix"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"Field","name":{"kind":"Name","value":"options"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldOption"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldSection"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Section"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"fieldHeading"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Field_Heading"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"field"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FieldInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"conditions"}},{"kind":"Field","name":{"kind":"Name","value":"enableConditions"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldBase"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddress"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAgree"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldCheckboxes"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldDropdown"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldDate"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldName"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldRadio"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldFileUpload"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldPayment"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldNamePrefix"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldAddressCountry"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldSection"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"fieldHeading"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieRow"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"RowInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"rowFields"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"field"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"formieCaptcha"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"FormieCaptchaType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"handle"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}}]} as unknown as DocumentNode<FormieFormQuery, FormieFormQueryVariables>;
export const EntryDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Entry"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"site"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"defaultValue":{"kind":"StringValue","value":"default","block":false}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"preferSites"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}},"defaultValue":{"kind":"ListValue","values":[{"kind":"StringValue","value":"default","block":false}]}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unique"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Boolean"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uri"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"slug"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"section"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"type"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"QueryArgument"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"site"},"value":{"kind":"Variable","name":{"kind":"Name","value":"site"}}},{"kind":"Argument","name":{"kind":"Name","value":"preferSites"},"value":{"kind":"Variable","name":{"kind":"Name","value":"preferSites"}}},{"kind":"Argument","name":{"kind":"Name","value":"unique"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unique"}}},{"kind":"Argument","name":{"kind":"Name","value":"uri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uri"}}},{"kind":"Argument","name":{"kind":"Name","value":"slug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"slug"}}},{"kind":"Argument","name":{"kind":"Name","value":"section"},"value":{"kind":"Variable","name":{"kind":"Name","value":"section"}}},{"kind":"Argument","name":{"kind":"Name","value":"type"},"value":{"kind":"Variable","name":{"kind":"Name","value":"type"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageEntry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchScore"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}},{"kind":"Field","name":{"kind":"Name","value":"typeHandle"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"formatDateTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"j M Y","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accordionItem_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockAccordion_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"accordionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccordionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockquoteBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockBlockquote_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CtaBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockCta_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DownloadsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockDownloads_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linkAssetMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockForm_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImage_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageCarouselBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImageCarousel_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LatestNewsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockLatestNews_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleMaps_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"zoom"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"street1"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockMap_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"showPreciseAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RichTextBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockRichText_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServicesBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockServices_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockVideo_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAndTextBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImageAndText_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"profile_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"honorific"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileRoleMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileGroupMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordionItem_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"profileMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileEntry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordion_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileAccordionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalPageCardsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockInternalPageCards_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Blocks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NeoBlockInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccordionBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockquoteBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CtaBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DownloadsBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageCarouselBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LatestNewsBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RichTextBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServicesBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAndTextBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileAccordion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalPageCardsBlock"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeHeroBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blockHomeHeroBanner_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroHeading"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickLinksLabel"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomePage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocksHome"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeHeroBanner"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Blocks"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomePage"}},{"kind":"Field","name":{"kind":"Name","value":"pageLayout"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneLinkMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openingHoursHtml"}},{"kind":"Field","name":{"kind":"Name","value":"serviceMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nBathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"nBeds"}},{"kind":"Field","name":{"kind":"Name","value":"nCars"}},{"kind":"Field","name":{"kind":"Name","value":"propertyTypeMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"propertyCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accommodationTypeMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"floorplan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsCta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showAnchorLinks"}},{"kind":"Field","name":{"kind":"Name","value":"showPreciseAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapAddress"}}]}}]}}]} as unknown as DocumentNode<EntryQuery, EntryQueryVariables>;
export const EntryWithTheLotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EntryWithTheLot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"uri"}},"type":{"kind":"ListType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entry"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"uri"},"value":{"kind":"Variable","name":{"kind":"Name","value":"uri"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}},{"kind":"Field","name":{"kind":"Name","value":"typeHandle"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageEntry"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileEntry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EntryBase"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EntryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"searchScore"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"slug"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}},{"kind":"Field","name":{"kind":"Name","value":"typeHandle"}},{"kind":"Field","name":{"kind":"Name","value":"postDate"},"directives":[{"kind":"Directive","name":{"kind":"Name","value":"formatDateTime"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"format"},"value":{"kind":"StringValue","value":"j M Y","block":false}}]}]},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"accordionItem_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccordionBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockAccordion_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"accordionItems"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccordionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BlockquoteBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockBlockquote_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CtaBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockCta_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"DownloadsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockDownloads_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"linkAssetMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"FormBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockForm_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"form"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImage_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageCarouselBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImageCarousel_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LatestNewsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockLatestNews_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapAddress"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GoogleMaps_Address"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lat"}},{"kind":"Field","name":{"kind":"Name","value":"lng"}},{"kind":"Field","name":{"kind":"Name","value":"zoom"}},{"kind":"Field","name":{"kind":"Name","value":"formatted"}},{"kind":"Field","name":{"kind":"Name","value":"street1"}},{"kind":"Field","name":{"kind":"Name","value":"street2"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"city"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"MapBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockMap_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"showPreciseAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapAddress"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"RichTextBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockRichText_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Category"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"CategoryInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServicesBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockServices_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VideoBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockVideo_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"videoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"caption"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAndTextBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockImageAndText_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"imageAlignment"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"profile_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"honorific"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileRoleMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"profileGroupMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentDefault"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordionItem"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordionItem_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"profileMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileEntry"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProfileAccordion"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_profileAccordion_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileAccordionItem"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageCard"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"sectionHandle"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InternalPageCardsBlock"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blocks_blockInternalPageCards_BlockType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"heading"}},{"kind":"Field","name":{"kind":"Name","value":"entryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"PageCard"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"Blocks"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NeoBlockInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccordionBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"BlockquoteBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"CtaBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"DownloadsBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"FormBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageCarouselBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"LatestNewsBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"RichTextBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServicesBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"VideoBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAndTextBlock"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProfileAccordion"}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"InternalPageCardsBlock"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomeHeroBanner"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"blockHomeHeroBanner_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"heroHeading"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"linkSingle"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"quickLinksLabel"}},{"kind":"Field","name":{"kind":"Name","value":"entryLinkMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"HomePage"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"blocksHome"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomeHeroBanner"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"PageEntry"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EntryBase"}},{"kind":"Field","name":{"kind":"Name","value":"pageTitle"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"featureImage"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"blocks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Blocks"}}]}},{"kind":"FragmentSpread","name":{"kind":"Name","value":"HomePage"}},{"kind":"Field","name":{"kind":"Name","value":"pageLayout"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"articleCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"phoneLinkMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"openingHoursHtml"}},{"kind":"Field","name":{"kind":"Name","value":"serviceMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"}},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"page_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"summary"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"iconAsset"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"serviceCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"nBathrooms"}},{"kind":"Field","name":{"kind":"Name","value":"nBeds"}},{"kind":"Field","name":{"kind":"Name","value":"nCars"}},{"kind":"Field","name":{"kind":"Name","value":"propertyTypeMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"propertyCategoryMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accommodationTypeMultiple"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"Category"}}]}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"floorplan"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"ticketsCta"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"showAnchorLinks"}},{"kind":"Field","name":{"kind":"Name","value":"showPreciseAddress"}},{"kind":"Field","name":{"kind":"Name","value":"address"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"MapAddress"}}]}}]}}]} as unknown as DocumentNode<EntryWithTheLotQuery, EntryWithTheLotQueryVariables>;
export const PingDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Ping"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"ping"}}]}}]} as unknown as DocumentNode<PingQuery, PingQueryVariables>;
export const GlobalsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Globals"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"legal"},"name":{"kind":"Name","value":"globalSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"StringValue","value":"legal","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"legal_GlobalSet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"copyrightText"}},{"kind":"Field","name":{"kind":"Name","value":"copyrightEntity"}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"social"},"name":{"kind":"Name","value":"globalSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"StringValue","value":"social","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"social_GlobalSet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"phoneLink"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}},{"kind":"Field","name":{"kind":"Name","value":"socialLabel"}},{"kind":"Field","name":{"kind":"Name","value":"socialLinks"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LinkField"}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"awards"},"name":{"kind":"Name","value":"globalSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"StringValue","value":"awards","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"awards_GlobalSet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"logoGallery"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"linkedImage_Entry"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"image"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ImageAsset"}}]}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}}]}}]}}]}}]}},{"kind":"Field","alias":{"kind":"Name","value":"acknowledgmentOfCountry"},"name":{"kind":"Name","value":"globalSet"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"handle"},"value":{"kind":"StringValue","value":"acknowledgmentOfCountry","block":false}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"acknowledgmentOfCountry_GlobalSet"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"htmlContentSimple"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LinkField"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"HyperLinkInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"id"},"name":{"kind":"Name","value":"link"}},{"kind":"Field","name":{"kind":"Name","value":"ariaLabel"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"isElement"}},{"kind":"Field","name":{"kind":"Name","value":"isEmpty"}},{"kind":"Field","name":{"kind":"Name","value":"linkText"}},{"kind":"Field","name":{"kind":"Name","value":"linkUri"}},{"kind":"Field","name":{"kind":"Name","value":"linkUrl"}},{"kind":"Field","name":{"kind":"Name","value":"linkValue"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"target"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"urlPrefix"}},{"kind":"Field","name":{"kind":"Name","value":"urlSuffix"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ImageAsset"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AssetInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"width"}},{"kind":"Field","name":{"kind":"Name","value":"height"}},{"kind":"Field","name":{"kind":"Name","value":"alt"}},{"kind":"Field","name":{"kind":"Name","value":"filename"}}]}}]} as unknown as DocumentNode<GlobalsQuery, GlobalsQueryVariables>;
export const NavDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Nav"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"handle"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"navigationNodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"navHandle"},"value":{"kind":"Variable","name":{"kind":"Name","value":"handle"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"NavNode"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"NavNode"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"NodeInterface"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"uri"}},{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"nodeUri"}},{"kind":"Field","name":{"kind":"Name","value":"newWindow"}},{"kind":"Field","name":{"kind":"Name","value":"classes"}},{"kind":"Field","name":{"kind":"Name","value":"customAttributes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"attribute"}},{"kind":"Field","name":{"kind":"Name","value":"value"}}]}},{"kind":"Field","name":{"kind":"Name","value":"parent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lft"}},{"kind":"Field","name":{"kind":"Name","value":"rgt"}}]}}]} as unknown as DocumentNode<NavQuery, NavQueryVariables>;